// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../font/Barlow/Barlow-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/notification_bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
	height: 100%;
	--scrollbarBG: #008FF1;
	--thumbBG: #0A313F;
}


body {
	margin: 0;
	padding: 0;

	overflow: hidden;
	height: 100%;

}

@font-face {
	font-family: 'GothamNarrow-Thin';
	/*src: url(../font/nucleus/GothamNarrow-Thin.otf); */
	src: url(https://s3-us-west-2.amazonaws.com/nucleuscare/font/nucleus/GothamNarrow-Thin.otf);
}

@font-face {
	font-family: 'GothamNarrow-Light';
	/*src: url(../font/nucleus/GothamNarrow-Light.otf); */
	src: url(https://s3-us-west-2.amazonaws.com/nucleuscare/font/nucleus/GothamNarrow-Light.otf);
}

@font-face {
	font-family: 'GothamNarrow-Medium';
	/*src: url(../font/nucleus/GothamNarrow-Medium.otf); */
	src: url(https://s3-us-west-2.amazonaws.com/nucleuscare/font/nucleus/GothamNarrow-Medium.otf);
}

@font-face {
	font-family: 'GothamNarrow-Book';
	/*src: url(../font/nucleus/GothamNarrow-Book.otf); */
	src: url(https://s3-us-west-2.amazonaws.com/nucleuscare/font/nucleus/GothamNarrow-Book.otf);
}

@font-face {
	font-family: 'Barlow';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}


.sideBarFont {
	font-family: 'Barlow';
	font-size: 14px;
}

.main {

	margin: 0;
	padding: 0;
	height: 100%;
}

.nucleus-main-content {
	margin: 0;
	padding: 0;
	overflow: hidden;
	height: 100%;
	width: 100%;
	display: flex;

}

.alto {
	height: 100%;
}

.altoImportant {
	padding: 0px;
	min-height: 80%;
	height: 100% !important;
	border: 2px none purple;
}

.altoImportantStaff {
	height: 90% !important;
}

.altoImportantContainer {
	padding: 0px;
	min-height: 80%;
	height: 90%;
	max-height: 90%;
	border: 2px none purple;


}

.profile-header-body{
	background-color: white;
	margin-bottom: 0px;
	box-shadow: 2px 0px #d5d5d5;
	color:#09303f;
	min-width: 720px;
}

.profile-header-bottom {
	background-color: white;
    border-radius: 0px 0px 15px 15px;
    box-shadow: 2px 2px #d5d5d5;
    color: #09303f;
    min-width: 720px
}

.bottom-border-menu {
    border-bottom: 4px solid #B3C6D4;
    padding-bottom: 5px;
    color: #0F2B3A;
}

.staffSubTab {
	border-bottom: 4px solid #2A97FF;
    padding-bottom: 9px;
}

.padding-15 {
    padding: 15px;
}

.selectStyle .css-1hwfws3 {
    height: 33px;
}

.css-1hwfws3 {
    align-items: center;
    display: flex;
    flex: 1 1;
    flex-wrap: wrap;
    padding: 2px 8px;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
}

.nucleus-input-mdm {
	/* width: 10% !important; */
	max-width: 220px;
	min-width: 120px;
    margin-left: 2rem !important;
}

.selectContainer {
	display: flex;
	align-items: center;
}

.checkboxContainer {
	display: flex;
	width: 22.5%;
    justify-content: space-between;
}

.networkCheckboxSpace {
	margin-left: 5rem;
}

.nucleusSearchInputContainer {
	display: flex;
	flex-direction: row;
	width: 24%;
}

.nucleusSearchInput {
	margin-left: 1rem !important;
	margin-right: 1rem !important;
}

.nucleus-input-form-small {
    text-align: left !important; 
    color: #000; 
    padding-bottom: 0px !important; 
    margin-bottom: 4px !important; 
    border: 3px solid black; 
    height: 19px; 
    font-size: 15px !important; 
    font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif; 
    font-size: larger; 
    width: 50% !important; 
    text-align: center; 
}

.pdl-0 {
	padding: 0 0 !important;
}

.staffTabs1 {
	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: large;
	font-weight: bolder;
	font-size: 19px !important;
	color: black;
	text-transform: none !important;
	padding-left: 10px;
	padding-right: 10px;
	
}

.staffTabs2 {
	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: large;
	font-weight: bolder;
	font-size: 19px !important;
	color: black;
	text-transform: none !important;
	padding-left: 10px;
	padding-right: 10px;
	margin-left: 20px;
	line-height: 40px;
}

.nucleusTabContainer{
	/* white-space: nowrap; */
	line-height: 40px;
}
.nucleusTabText{
	/* white-space: nowrap; */
	display: inline-flex;
}

.staffTabs {
	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: large;
	font-weight: bolder;
	font-size: 19px !important;
	color: #0A313F;
	text-transform: none !important;
	height: 40px;
	margin-left: 10px;
	margin-right: 10px;
}

.staffTabsMain {
	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: large;
	font-weight: bolder;
	font-size: 24px !important;
	color: #0A313F;
	text-transform: none !important;
	height: 40px;
	margin-left: 10px;
	margin-right: 10px;
}

.mdm-tabs-container {
	display: flex;
	flex-direction: row;
	gap: 16px;
	justify-content: flex-start;
}

.mdm-main-tabs-container {
	display: flex;
	flex-direction: row;
	gap: 16px;
	justify-content: flex-start;
	justify-content: space-around;
    width: 40%;
}

.mdm-tab {
	cursor: pointer;
}

.nucleus-btn-center {
	display: flex;
	justify-content: center;
}

.profile-header-btn1 {
    box-shadow: 1px 1px #666666;
    text-align: center;
    padding: 3px 19px 2px;
    border: 1px solid gray;
    border-radius: 4px;
}

.staffTab {
	padding-bottom: 3px;
	border-bottom: 3px solid #2A97FF;
}

.staffTabMain {
	padding-bottom: 3px;
	border-bottom: 3px solid #FFCA20;
}

.mdmPolicyFooterContainer {
	width: 100%;
	display: flex;
	justify-content: flex-end;
	border-top:  3px solid #B4C6D3;
	padding: 1%;
	margin-top: 21%;
}

.kioskAppContainer {
	display: flex;
    flex-direction: row;
    align-items: center;
	width: 50%;
    justify-content: space-between;
}

.kioskAppContainerNew {
	display: flex;
    flex-direction: row;
    align-items: center;
	width: 70%;
    justify-content: space-between;
}

.kioskAppWarningTxt {
	font-size: 16px;
	color: #0A313F;
	font-weight: bold;
}

.kioskAppLine {
	width: 100%;
	border: 1px solid #B4C6D3;
	margin-top: 1%;
    margin-bottom: 5%;
}

.mdmPolicyFooterButtonContainer {
	display: flex;
	flex-direction: row;
}

.mdmText {
	font-size: 16px;
	color: #0A313F;
}

.mdmTextLg {
	font-size: 24px;
	color: #0A313F;
}

.screenPluggedContainer {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
    width: 32%;
}

.screenPluggedCheckBoxContainer {
	display: flex;
	flex-direction: column;
}

.kioskWarning {
	color: #FE3824;
	font-weight: bold;
	font-size: 60px;
}

.kioskTxt {
	font-size: 20px;
	color: #0A313F;
}

.kioskContainer {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.screenCounterContainer {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
    width: 32%;
}

.counterContainer {
	display: flex;
	flex-direction: row;
}

.ancho {
	width: 100%;
}

.txt-black {
	color: #000;
}

.txt-white {
	color: #FFFFFF;
}

.txt-red {
	color: #FE3824;
}

.txt-green {
	color: #6dbe73;
}

.txt-special-color {
	color: #052F3E;
}

.nucleus-input-login {
	text-align: center;
	color: #fff;
}

.text-center-align {
	text-align: center !important;
}

.center-block {
	margin-left: auto !important;
	margin-right: auto !important;
}

.nucleus-input-login:focus {
	box-shadow: none !important;
}

.nucleus-input-login2 {
	text-align: center;
	color: #fff;
	box-shadow: none !important;
	border-bottom: 1px solid #2ba0fa !important;
	height: 2.5rem !important;
}

.nucleus-input-login2:focus {
	box-shadow: none !important;
	border-bottom: 1px solid #2ba0fa !important;
}

/* label color */
.input-field label {
	color: #000;
}

.input-field {
	display: flex;
}

/* label focus color */
.input-field input[type=text]:focus+label {
	color: #000;
}

/* label underline focus color */
.input-field input[type=email]:focus {
	border-bottom: 1px none yellow;
	box-shadow: 0 1px 0 0 yellow;
}

/* valid color 
   .input-field input[type=text].valid {
     border-bottom: 1px solid #000;
     box-shadow: 0 1px 0 0 #000;
   }*/
/* invalid color 
   .input-field input[type=text].invalid {
     border-bottom: 1px solid #000;
     box-shadow: 0 1px 0 0 #000;
   }*/
/* icon prefix focus color 
   .input-field .prefix.active {
     color: #000;
   }*/

.no-margin {
	margin: 0px !important;
	padding: 0px !important;
}

.flex {
	display: flex;
}

.devices-refresh {
	padding: 3px;
    margin-left: 10px;
} 

.no-margin-left {
	margin-left: 0px !important;
	padding-left: 0px !important;
}

.no-margin-right {
	margin-right: 0px !important;
	padding-right: 0px !important;
}

.no-margin-bottom {
	margin-bottom: 0px !important;
}

.nucleus-scroll {
	overflow: auto;
	overflow-y: scroll;
	height: 100% !important;
}

.nucleus-no-scroll {
	overflow: hidden;
}

.nucleus-font-8 {
	font-size: 8px !important;
}

.nucleus-font-10 {
	font-size: 10px !important;
}

.nucleus-font-11 {
	font-size: 11px !important;
}

.nucleus-font-13 {
	font-size: 13px !important;
}

.nucleus-font-14 {
	font-size: 14px !important;
}

.nucleus-font-modal-btn {
	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: medium;
	font-weight: bold;
	font-size: 16px;

}

/*MDM STYLES FOR MODAL */
.darkBG {
	background-color: rgba(0, 0, 0, 0.3);
	width: 100vw;
	height: 100vh;
	z-index: 0;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	position: fixed;
  }
  
  .centered {
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
  }

  .addAppsCheckBox {
	opacity: 1 !important;
	position: inherit !important;
  }

.nucleusCard {
	display: flex;
	background-color: #EBF2FE;
	border-radius: 5px;
	box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.3);
  }

.nucleusCardFooterTxt {
	font-size: 14px;
	color: #0A313F;
}
  .accountDetailsCardsContainer {
	display: flex;
	width: 100%;
	justify-content: space-evenly;
  }
  .mDMAccountDetailsNavBarContainer {
	display: flex;
	width: 100%;
	flex-direction: column;
	margin-top: 3%;
  }
  .mDMAccountDetailsNavBarOptionsContainer {
	width: 13%;
    display: flex;
    justify-content: space-between;
  }
  .mDMAccountDetailsNavBarTxt {
	font-size: 18px;
	color: #0A313F;
	font-weight: bold;
	cursor: pointer;
  }
  .mDMAccountDetailsNavBarTxtActive {
	border-bottom: 1px solid #0092FF;
  }
  .mDMModal {
	display: flex;
	min-height: 400px;
	min-width: 640px;
	background: white;
	border-radius: 10px;
	z-index: 10;
	box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);
  }

  .mDMModalAddApps {
	display: flex;
	width: 795px;
	background: white;
	color: white;
	z-index: 10;
	box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);
  }
  
  .modalHeader {
	height: 50px;
	background: white;
	overflow: hidden;
	border-top-left-radius: 16px;
	border-top-right-radius: 16px;
  }
  
  .heading {
	margin: 0;
	padding: 10px;
	color: #2c3e50;
	font-weight: 500;
	font-size: 18px;
	text-align: center;
  }
  
  .modalContent {
	padding: 10px;
	font-size: 14px;
	text-align: center;
	background-color: #E5E5E5;
	border-radius: 10px;
	width: 100%;
  }
  
  .modalActions {
	margin-bottom: 10px;
	width: 100%;
  }
  
  .actionsContainer {
	display: flex;
	justify-content: space-evenly;
	align-items: center;
  }
  
  .closeBtn {
	cursor: pointer;
	font-weight: 500;
	padding: 4px 8px;
	border-radius: 8px;
	border: none;
	font-size: 18px;
	color: #2c3e50;
	background: white;
	transition: all 0.25s ease;
	box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.06);
	position: absolute;
	right: 0;
	top: 0;
	align-self: flex-end;
	margin-top: -7px;
	margin-right: -7px;
  }
  
  .closeBtn:hover {
	box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);
	transform: translate(-4px, 4px);
  }
  
  .deleteBtn {
	margin-top: 10px;
	cursor: pointer;
	font-weight: 500;
	width: 18%;
	padding: 11px 28px;
	border-radius: 50px;
	font-size: 0.8rem;
	border: #0A313F solid 1px ;
	color: #0A313F;
	background: #E5E5E5;
	transition: all 0.25s ease;
  }

  .deleteBtnKiosk {
	margin-top: 10px;
	cursor: pointer;
	font-weight: 500;
	width: 28%;
	padding: 11px 28px;
	border-radius: 50px;
	font-size: 0.8rem;
	border: #0A313F solid 1px ;
	color: #0A313F;
	background: #E5E5E5;
	transition: all 0.25s ease;
  }
  
  .deleteBtn:hover {
	box-shadow: 0 10px 20px -10px rgba(93, 91, 215, 0.6);
	transform: translateY(-5px);
	background: #E5E5E5;
  }

  .cancelBtnKiosk {
	margin-top: 10px;
	cursor: pointer;
	font-weight: 500;
	width: 28%;
	padding: 11px 28px;
	border-radius: 50px;
	font-size: 0.8rem;
	border: #0A313F solid 1px;
	color: #ffffff;
	background: #0A313F;
	transition: all 0.25s ease;
  }
  
  .cancelBtn {
	margin-top: 10px;
	cursor: pointer;
	font-weight: 500;
	width: 18%;
	padding: 11px 28px;
	border-radius: 50px;
	font-size: 0.8rem;
	border: #0A313F solid 1px;
	color: #ffffff;
	background: #0A313F;
	transition: all 0.25s ease;
  }
  
  .cancelBtn:hover {
	box-shadow: none;
	transform: none;
	background:#0A313F;
  }
  
.mDMAddAppsContainer {
	display: flex;
	width: 100%;
	height: 500px;
	flex-direction: column;
}

.nucleusAppsModalSearchInputContainer {
	width: 100%;
	display: flex;
}
/*MDM STYLES FOR MODAL */


.nucleus-font-small {
	font-size: small;
}

.nucleus-font-medium {
	font-size: medium;
}

.border {
	border: 2px none black;
}

.bordered1 {
	border: 1px solid red;
}

.nucleus-login {
	background-color: #008FFF;
	font-family: GothamNarrow-Light, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', Geneva, sans-serif;
	font-size: large;
}

.login-info {
	font-size: medium;

}

.nucleus-token-btn {
	color: white !important;
	font-size: 16px !important;
	font-weight: normal !important;
	background-color: #124355;
	box-shadow: 1px 1px #666666;
	text-align: center;
	padding: 3px 19px 2px;
	border: 1px solid gray;
	border-radius: 4px;
}

.new-nucleus-page-subtitle{
	font-family: GothamNarrow-Medium, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: 18px;
	display: inline;

	color :#0F2B3A;

	padding-left: 3px;
	padding-right: 3px;
	padding-bottom: 2px;
	border-bottom: 3px solid #FCCB00;
	margin-bottom: 15px;
}

.devices-container {
	background-color: white;
	border-radius: 15px 15px 15px 15px;
	box-shadow: 2px 2px #d5d5d5;

	margin-top: 12px;
    padding-left: 8px;
    padding-bottom: 25px;
    padding-top: 6px;

    min-width: 998px;

}

.patientSettings {
	background-color: white;
	border-radius: 15px 15px 15px 15px;
	box-shadow: 2px 2px #d5d5d5;

	margin-top: 12px;
    padding-bottom: 25px;
    margin-bottom: 20px;

    border:1px solid #d9d9d9;

    min-width: 720px;
}

.tabSmallContainer{
	padding-top: 9px;
    display: inline-flex;
    border-right: 1px solid #b4b4b4;
    margin-bottom: -9px;

}

.staffTabsSmall2{
	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: large;
	font-weight: bold;
	font-size: 17px !important;
	color: black ;
	text-transform: none !important;
	padding-bottom: 9px;
	    padding-left: 5px;
    padding-right: 5px;

    color :#0F2B3A !important;

}


.nucleus-unblock-api-btn {
	color: white !important;
	font-size: 16px !important;
	font-weight: normal !important;
	background-color: #124355;
	box-shadow: 1px 1px #666666;
	text-align: center;
	padding: 3px 52px 2px;
	border: 1px solid gray;
	border-radius: 4px;
	cursor: pointer;
}

.nucleus-unblock-api-btn:disabled,
.nucleus-unblock-api-btn[disabled] {
	background-color: rgba(181, 188, 191, 0.5);
	box-shadow: 1px 1px #666666;
	pointer-events: none;
}

.nucleus-unblock-api-btn:hover {
	cursor: pointer;
}

.nucleus-bold {
	font-weight: bolder;
}

/* .bold-text {
	
	font-weight: bolder !important;

} */

.login-error {
	/* color:#cc0000; */
	color: #FFCA20;
	font-family: GothamNarrow-Medium, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', Geneva, sans-serif;
	font-size: large;
}

.forgot-style {
	margin-top: -35px;
}

.nucleus-login-row {
	margin-top: 0px !important;
	margin-bottom: 0px !important;
}

.nucleus-submit-btn {
	border-radius: 25px;
	background: #0A313F;
	padding: 12px 50px 12px 50px;
}

.nucleus-submit-btn-tools {
	border-radius: 25px;
	background: #0A313F;
	padding: 8px 40px 8px 40px;
	display: inline-flex;
}

.nucleus-submit-btn-tools:hover {
	cursor: pointer;
	display: inline-flex;
}

.enterpriseFormTitleContainer {
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
}

.enterpriseFormTitleTxt {
	font-size: 20px;
	color: #0A313F;
}

.enterpriseFormContainer {
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 3%;
}

.mt-30 {
	margin-top: 30%;
}

.enterpriseInputContainer {
	display: flex;
	width: 100%;
	justify-content: space-evenly;
}

.enterpriseModalLabelContainer {
  display: flex;
  width: 40%;
}

.enterpriseModalInputContainer {
	display: flex;
	width: 60%;
} 

.deleteBtnEnterpriseModal {
	margin-top: 10px;
    cursor: pointer;
    font-weight: 500;
    width: 30%;
    padding: 11px 28px;
    border-radius: 50px;
    font-size: 0.8rem;
    border: #0A313F solid 1px;
    color: #0A313F;
    background: #E5E5E5;
    transition: all 0.25s ease;
}

.cancelBtnEnterpriseModal {
	margin-top: 10px;
    cursor: pointer;
    font-weight: 500;
    width: 30%;
    padding: 11px 28px;
    border-radius: 50px;
    font-size: 0.8rem;
    border: #0A313F solid 1px;
    color: #ffffff;
    background: #0A313F;
    transition: all 0.25s ease;
}

.enterpriseInput {
	min-width: 200px !important;
	background-color: #FFFFFF !important;
	border-radius: 5px !important;
}

.enterpriseInputTxt {
	color: #0A313F;
	font-size: 18px;
} 

.nucleus-submit-floating-btn {
	/*border-radius: 25px;
    background: #0A313F;
    padding: 1px 30px 1px 50px;*/
}

.toper-container {
	background-color: white;
	border-radius: 15px 15px 0px 0px;
	padding-top: 8px;
	box-shadow: 2px 0px #d5d5d5;

	
	min-width: 720px;
	    min-width: 1180px;
		min-width: 720px;
}

.nucleus-submit-btn-disabled {
	border-radius: 25px;
	background: rgba(181, 188, 191, 0.5);
	padding: 12px 50px 12px 50px;
	pointer-events: none;
}

.nucleus-submit-btn:hover {
	cursor: pointer;
}

.nucleus-submit-btn-small {
	border-radius: 25px;
	background: #0A313F;
	padding: 5px 20px 5px 20px;
	cursor: pointer;
}

.nucleus-submit-btn-small-disabled {
	border-radius: 25px;
	background: rgba(181, 188, 191, 0.5);
	padding: 5px 20px 5px 20px;
	pointer-events: none;
}

.nucleus-submit-btn-small:hover {
	cursor: pointer;
}

.nucleus-api-token-btn-small {
	border-radius: 5px;
	background: #929192;
	padding: 5px 20px 5px 20px;
	cursor: pointer;
}

.dark-blue {
	color: #0A313F !important;
}

.border2 {
	border: 1px solid red;
}

.border3 {
	border: 1px solid blue;
}

.nucleus-link {
	color: #000000;
}

.nucleus-link-disabled {
	opacity: .25;
	-moz-opacity: .25;
	filter: alpha(opacity=25);
	pointer-events: none;
}

.new-page-title {
	font-size: 2.5rem;
	color:#09303f;
}

.btn-add-new {
	margin-left: -30px !important;
}

.nucleus-link:hover {
	cursor: pointer;
	font-weight: bold;
}

.staffTabsMain:hover {
	cursor: pointer;
	font-weight: bold;
}

.staffTabs:hover {
	cursor: pointer;
	font-weight: bold;
}


.mt-10 {
  margin-top: 10px;
}

.nucleus-link-light {
	color: #000;
}

.nucleus-link-light:hover {
	cursor: pointer;
}

.nucleus-link-red {
	cursor: pointer;
	color: #FE3824;
}

.nucleus-link-red:hover {
	cursor: pointer;
	color: #FE3824;
}

.nucleus-floating-btn  i {
	font-size: 1.3rem !important;
    line-height: 30.1px !important;
}

.modalScrollableWidth{
	background: #EBEBEB;
	border-radius: 10px 10px 10px 10px;
	min-width: 390px !important;
	width: 65%;
	padding-bottom: 10px;
}

.nucleus-font-label-title{
	font-weight: 500 !important;
	font-size: 14px;
	margin-bottom: 5px;
	/*font-family: GothamNarrow-Light, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;*/
	font-size: medium;
}
.patient-edit-title-container {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.profile-header-btn2{
	box-shadow: 1px 1px #666666;
    text-align: center;
    padding: 3px 9px 2px;
    border: 1px solid gray;
    border-radius: 4px;
}

.a-little-right-11 {
    padding-left: 11px !important;
}

.nucleus-floating-btn-mini {
    width: 21px;
    height: 21px;
    line-height: 21px;
}

.nucleus-floating-btn-mini > i {
    line-height: 0px !important;
	font-size: 1rem !important;
}

.bottom-separated {
    margin-top: 0px;
    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: 9px;
}

.patientConfigSelect {
    margin-top: -5px;
    min-width: 90% !important;
    width: 95% !important;
    height: 30px; 
}

.selected-flag {
    background-color: transparent !important;
}

.nucleus-link-button {	
	cursor: pointer;

	color: rgb(9, 131, 206);
	border-color: rgb(9, 131, 206);
	
    border-width: 2px;
    border-style: solid;
    border-radius: 13px;
    padding-right: 4px;

	font-weight: 500;
}

.nucleus-link-button:hover {
	cursor: pointer;

	color:#0A313F;
	border-color: #0A313F;
	
    border-width: 2px;
    border-style: solid;
    border-radius: 13px;
    padding-right: 4px;

	font-weight: 500;
}
.nucleus-row {
	cursor: pointer;
}
.nucleus-clickable:hover {
	cursor: pointer;
}
.nucleus-floating-btn-icon-copy-to-cb {
	background-color: #03313E !important;
}
.nucleus-row-small {
	padding-top: 15px;
	padding-bottom: 15px;
	cursor: pointer;
}

.nucleus-row-small-top{
	padding-top: 7px;
	padding-bottom: 0px;
    vertical-align: top;
}

.nucleus-floating-btn {
    width: 30px;
    height: 30px;
    line-height: 30px;
    margin-bottom: 7px;
}


.nucleus-sidebar {
	/*
	min-width: 40px;
	max-width: 80px;
	*/

	font-family: GothamNarrow-Light, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: medium;

	margin: 0;
	padding: 0;

	height: 100% !important;
	width: 100%;
	overflow-y: auto;
	overflow-x: hidden;

	display: inline-flex;
	border:#03313E 1px solid;
	min-width: 108px;
}

.nucleus-sidebar-bottom {
	padding-bottom: 0px;
	margin-bottom: 0px;
}

.nucleus-sidebar::-webkit-scrollbar {
	width: 11px;
  }
  .nucleus-sidebar {
	scrollbar-width: auto;
	scrollbar-color: var(--thumbBG) var(--scrollbarBG);
  }
  .nucleus-sidebar::-webkit-scrollbar-track {
	background: var(--scrollbarBG);
  }
  .nucleus-sidebar::-webkit-scrollbar-thumb {
	background-color: var(--scrollbarBG) ;
	border-radius: 6px;
	border: 2px solid var(--scrollbarBG);
  }

  .nucleus-sidebar::-webkit-scrollbar-thumb:hover {
	background-color: var(--thumbBG) ;
	border-radius: 6px;
	border: 2px solid var(--scrollbarBG);
  }

.sidebar-logo {
	height: 100px;
}

.nucleus-topbar {
	/*
	min-width: 40px;
	max-width: 80px;
	*/
	background-color: #F0F0F0;
	height: 53px;
	width: 100% !important;
	margin: 0px;
	padding: 0px;
	top: 0;
}

.nucleus-search {
	width: 80%;
	max-width: 80%;
	height: 100%;
	max-height: 100%;
}

.search-icon {
	width: 16px;
	margin-top: -15px;
}

.nucleus-menu {
	padding-top: 15px;
	padding-bottom: 15px;
	margin-top: 0px;
	margin-bottom: 0px;
	font-family: "GothamNarrow-Medium";
}

.nucleus-active-menu {
	position: relative;
}

.nucleus-menu-icon {
	z-index: 10;
	position: absolute;
}

.nucleus-menu-notification {

	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	color: white;
	text-align: center;
	font-weight: bolder;
	font-family: -apple-system, BlinkMacSystemFont, sans-serif;
	z-index: 12;
	position: absolute;
	margin-left: -44px;
	font-size: 13px;
	padding: 4px;

	/*
	    background-color: #FFCA1F;
    border-radius: 12px;
    border: 3px solid white;
    padding: 0px;
    line-height: 12px;
    */
}

.menu-active {
	/* background-color:  #073140; */
	background-color: #FFCA20;
	color: #0A313F;
}

.menu-active img {
	filter: invert(100%) sepia(30%) saturate(1472%) hue-rotate(152deg) brightness(89%) contrast(94%);
}

.nucleus-menu:hover {
	background-color: #008FF1;
}

.menu-active:hover {
	/* background-color:  #073140; */
	background-color: #FFCA20;
}

.menu-content {
	position: relative;
	/* height: 100%; */
	min-height: 1190px;
}

.menu-logout {
	width: 100%;
	/* position:absolute;  */
	bottom: 0;
	margin-bottom: 10px;
}

.general-content {
	margin: 0;
	padding: 0px !important;
	overflow: hidden;
	height: 100%;
}

.general-containter {
	margin: 0;
	padding: 0;

	width: 100%;
	height: 100%;
	margin-top: -53px;
	padding-top: 53px;

}

.nucleus-page {
	margin: 0;
	padding: 50px;
	padding-top: 0px;

	position: relative;


	height: 100%;
	overflow: hidden;
}

.nucleus-scrollable-page {
	padding-left: 30px;
	padding-right: 30px;
	min-height: 88% !important;
	height: 100% !important;
	margin-bottom: 10px !important;
	position: relative;

	overflow: auto;
	overflow-y: overlay;

	border: 2px none red;

	padding-right: 30px;
}

.nucleus-hard-container {
	width: 100%;
	height: 100%;
	border: 1px none orange;
	display: inline-block;
	padding-left: 30px;
	padding-right: 10px;
	min-height: 88% !important;
	height: 100% !important;
	margin-bottom: 10px !important;
	position: relative;
	/* background-color: #f6f6f6; */
	overflow: auto;
	overflow-y: scroll;
	overflow-x: scroll;


}

.page-index {
    background-color: transparent;
    width: 48px;
    height: 48px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #656D77;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .page-index:hover {
    background-color: #ccc5;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #656D77;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .page-index-selected {
    background-color: #0092ff;
    width: 48px;
    height: 48px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 500;
  }
  .page-index-disabled {
    background-color: transparent;
    color: #ccc;
    cursor: not-allowed;
  }
  
  .page-index-disabled:hover {
    background-color: transparent;
    color: #ccc;
    cursor: not-allowed;
  }
  

.nucleus-tools-container {
	width: 100%;
	height: 100%;
	border: 1px none orange;
	display: inline-block;

	padding-left: 30px;
	padding-right: 10px;
	min-height: 88% !important;
	height: 100% !important;
	margin-bottom: 10px !important;
	position: relative;

	overflow: auto;
	overflow-y: scroll;
	overflow-x: scroll;
}

.nucleus-tools-container-devices {
	width: 100%;
	height: 100%;
	border: 1px none orange;
	display: inline-block;

	padding-left: 30px;
	padding-right: 10px;
	min-height: 88% !important;
	height: 100% !important;
	padding-bottom: 10px;
	position: relative;

	overflow: auto;
	/* overflow-y: scroll; */
	overflow-x:auto;
}

.nucleus-tools-container-accounts {
	width: 100%;
	height: 100%;
	border: 1px none orange;
	display: inline-block;

	padding-left: 30px;
	padding-right: 10px;
	min-height: 88% !important;
	height: 95% !important;
	margin-bottom: 10px !important;
	position: relative;

	/* overflow: auto;
	overflow-y: scroll;
	overflow-x: scroll; */
}


.nucleus-all-scrollable-page {

	min-width: 1130px;
	width: 100%;
	border: 1px none red;
	padding-right: 10px;
}

.nucleus-page-title {
	/* GothamNarrow-Light, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif; */
	font-family: GothamNarrow-Book;
	font-size: x-large;
	color: #000;
	font-weight: bolder;
}

.nucleus-page-subtitle {
	font-family: GothamNarrow-Medium, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: 18px;
	display: inline;
}

.nucleus-page-subtitle-special {
	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: 19px;
	font-weight: bold;
}

.nucleus-page-toast {
	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: 16px;
	font-weight: bold;
	/* color: #0A313F; */
}

.nucleus-font {
	font-family: GothamNarrow-Light;
}

.nucleus-font-family-medium {
	font-family: GothamNarrow-Medium, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}

.nucleus-news-separator {
	font-size: 8px;
	width: 100%;
	border-bottom: 1px solid #B4C6D3;
	margin-bottom: 15px;
}

.user-img {
	width: 75%;
	max-width: 80% !important;
}

.nucleus-labels-small {
	font-size: 15px;
	margin-bottom: 5px;

	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: medium;
}

.nucleus-labels {
	font-size: 16px;
	margin-bottom: 5px;

	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: medium;
}

.nucleus-labels-large {
	font-size: 16px;
	margin-bottom: 5px;

	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: large;
}

.nucleus-label-book {
	font-size: 16px;

	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;

}

.bold-500 {
	font-weight: 500;
}

.nucleus-tools-page-title {
	font-weight: bolder;
	color: #0a313f;
	font-size: 24px;
	font-family: GothamNarrow-Book;
}

.nucleus-tools-page-text-title {
	font-size: 16px;
	padding-top: 30px !important;
	color: #0A313F;
	font-family: GothamNarrow-Medium, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}

.nucleus-tools-page-text-label {
	font-size: 16px;
	padding-top: 30px !important;
	color: #0A313F;
	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}

.nucleus-token-labels {
	font-size: 16px;
	margin-top: 30px;

	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: medium;
}

.nucleus-labels-height {
	font-size: 16px;
	margin-bottom: 5px;

	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: medium;
	line-height: 30px !important;
}

.nucleus-labels-bold {
	font-size: 16px;
	margin-bottom: 5px;

	font-family: GothamNarrow-Medium, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: medium;
	/*font-weight: bolder !important;*/
}

.nucleus-labels-large-bold{
	font-size: 16px;
	margin-bottom: 5px;

	font-family: GothamNarrow-Medium, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: large;
	/*font-weight: bolder !important;*/
}

.nucleus-labels-bold-height {
	font-size: 16px;
	margin-bottom: 5px;

	font-family: GothamNarrow-Medium, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: medium;
	/*font-weight: bolder !important;*/
}

.nucleus-labels-special {
	font-size: 16px;
	margin-bottom: 5px;

	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: medium;

	margin-left: -15px;
}

.nucleus-input-form {
	text-align: left;
	color: #000;
	padding-bottom: 0px !important;
	margin-bottom: 5px !important;
	border: 3px solid black;
	height: 20px;

	font-size: 16px !important;

	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: larger;
}

.nucleus-tel-input-form {
	text-align: left;
	color: #000;
	padding-bottom: 0px !important;
	margin-bottom: 5px !important;
	border: 3px solid black;
	height: 20px;

	font-size: 16px !important;

	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: larger;

	width: 95% !important;
	margin: 0px !important;
	padding-top: 10px !important;
	border-radius: 5px !important;
	background-color: #fff !important;
	font-size: 16px !important;
	box-shadow: none !important;
}

.nucleus-tel-input-form-container {

		width: 85% !important;
}

.nucleus-input-form-disabled {
	text-align: left;
	color: #000;
	padding-bottom: 0px !important;
	margin-bottom: 5px !important;
	border: 3px solid black;
	height: 20px;

	font-size: 16px !important;

	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: larger;

	border-bottom: 0px none #e6e6e6 !important;
}


.nucleus-table-icon {
	color: #000;
}

.img-company-logo {
	margin-top: 20px;
}

.nucleus-fixed-container {

	padding: 0px;
	min-height: 88% !important;
	height: 95% !important;
	min-width: 920px !important;
	border: 1px none blue;
	padding-bottom: 30px;
}

.nucleus-table-container,
.nucleus-form-container {
	float: top;
	padding: 0px;
	min-height: 88% !important;
	height: 95% !important;
	position: relative;

	/* overflow: auto; */
	overflow-y: scroll;

	border: 2px none blue;
	padding-bottom: 30px;
}

.nucleus-table-container-s {
	float: top;
	padding: 0px;
	/* min-height: 88% !important; */
	height: 95% !important;
	position: relative;

	overflow: hidden;
	overflow-y: hidden;

	border: 2px none blue;
	padding-bottom: 30px;
}

.nucleus-table-container-s-90 {
	float: top;
	padding: 0px;
	/* min-height: 88% !important; */
	height: 90% !important;
	position: relative;

	overflow: hidden;
	overflow-y: hidden;

	border: 2px none blue;
	padding-bottom: 30px;
}

.nucleus-table-container-s-70 {
	float: top;
	padding: 0px;
	/* min-height: 88% !important; */
	height: 70% !important;
	position: relative;

	overflow: hidden;
	overflow-y: hidden;

	border: 2px none blue;
	padding-bottom: 30px;
}

.nucleus-middle-table-container {
	float: top;
	padding: 0px;
	min-height: 50% !important;
	/* height: 35% !important; */
	height: 450px !important;
	position: relative;

	overflow: auto;
	overflow-y: scroll;

	border: 2px none pink;
	padding-bottom: 30px;
}


.nucleus-75-table-container {
	float: top;
	padding: 0px;
	min-height: 50% !important;
	height: 72% !important;
	/* height: 560px !important; */
	position: relative;

	overflow: auto;
	overflow-y: auto;

	border: 2px none pink;
	padding-bottom: 30px;
}

.nucleus-quarter-table-container {
	float: top;
	padding: 0px;
	min-height: 58% !important;
	height: 65% !important;
	position: relative;

	overflow: auto;
	overflow-y: scroll;

	border: 2px none pink;
	padding-bottom: 30px;
}

.nucleus-mini-table-container {
	float: top;
	padding: 0px;
	min-height: 70px !important;
	height: 80px !important;

	overflow: auto;
	overflow-y: scroll;

	border: 2px none pink;
}

.work-log {
	min-height: 20%;
	height: 60%;
	margin-bottom: 10px !important;
	position: relative;

	overflow: hidden;
	border: 2px none blue;
}

.work-log-long {
	min-height: 20%;
	height: 90%;
	margin-bottom: 10px !important;
	position: relative;

	overflow: hidden;
	border: 2px none blue;
}



.table-scroll-space {
	padding-right: 16px;
}

.nucleus-table-container::-webkit-scrollbar {
	width: 8px;
	background-color: #F5F5F5;
}

.nucleus-table-container::-webkit-scrollbar-thumb {
	background-color: rgba(3, 52, 66, 0.1);
	background-color: #03313E;
	border-radius: 10px;
}

.nucleus-table-container::-webkit-scrollbar-thumb:hover {
	background-color: #03313E;
	border-radius: 10px;
}

.nucleus-table-container::-webkit-scrollbar-track {
	border-radius: 5px;
}

.nucleus-table-container::-webkit-scrollbar-track-piece {
	height: 50px;
}

.nucleus-table-container::-webkit-scrollbar-thumb:vertical {
	height: 50px;
}


.nucleus-middle-table-container::-webkit-scrollbar,
.nucleus-scrollable-page::-webkit-scrollbar,
.nucleus-textarea-scroll::-webkit-scrollbar {
	width: 8px;
	background-color: #F5F5F5;
}

.nucleus-middle-table-container::-webkit-scrollbar-thumb,
.nucleus-scrollable-page::-webkit-scrollbar-thumb,
.nucleus-textarea-scroll::-webkit-scrollbar-thumb {
	background-color: rgba(3, 52, 66, 0.1);
	background-color: #03313E;
	border-radius: 10px;
}

.nucleus-middle-table-container::-webkit-scrollbar-thumb:hover,
.nucleus-scrollable-page::-webkit-scrollbar-thumb:hover,
.nucleus-textarea-scroll::-webkit-scrollbar-thumb:hover {
	background-color: #03313E;
	border-radius: 10px;
}

.nucleus-middle-table-container::-webkit-scrollbar-track,
.nucleus-scrollable-page::-webkit-scrollbar-track,
.nucleus-textarea-scroll::-webkit-scrollbar-track {
	border-radius: 5px;
}

.nucleus-middle-table-container::-webkit-scrollbar-track-piece,
.nucleus-scrollable-page::-webkit-scrollbar-track-piece,
.nucleus-textarea-scroll::-webkit-scrollbar-track-piece {
	height: 50px;
}

.nucleus-middle-table-container::-webkit-scrollbar-thumb:vertical,
.nucleus-scrollable-page::-webkit-scrollbar-thumb:vertical,
.nucleus-textarea-scroll::-webkit-scrollbar-thumb:vertical {
	height: 50px;
}


.nucleus-hard-container::-webkit-scrollbar {
	width: 8px;
	height: 8px;
	background-color: #F5F5F5;
}

.nucleus-hard-container::-webkit-scrollbar-thumb {
	background-color: rgba(3, 52, 66, 0.1);
	background-color: #03313E;
	border-radius: 10px;
}

.nucleus-hard-container::-webkit-scrollbar-thumb:hover {
	background-color: #03313E;
	border-radius: 10px;
}

.nucleus-hard-container::-webkit-scrollbar-track {
	border-radius: 5px;
}

.nucleus-hard-container::-webkit-scrollbar-track-piece {
	height: 50px;
}

.nucleus-hard-container::-webkit-scrollbar-thumb:vertical {
	height: 50px;
}

.nucleus-hard-container::-webkit-scrollbar-thumb:horizontal {
	width: 50px;
}

*:not(.nucleus-sidebar)::-webkit-scrollbar {
	width: 8px;
	height: 8px;
	background-color: #F5F5F5;
}

*:not(.nucleus-sidebar)::-webkit-scrollbar-thumb {
	background-color: rgba(3, 52, 66, 0.1);
	background-color: #03313E;
	border-radius: 10px;
}

*:not(.nucleus-sidebar)::-webkit-scrollbar-thumb:hover {
	background-color: #03313E;
	border-radius: 10px;
}

*:not(.nucleus-sidebar)::-webkit-scrollbar-track {
	border-radius: 5px;
}

*:not(.nucleus-sidebar)::-webkit-scrollbar-track-piece {
	height: 50px;
}

*:not(.nucleus-sidebar)::-webkit-scrollbar-thumb:vertical {
	height: 50px;
}

*:not(.nucleus-sidebar)::-webkit-scrollbar-thumb:horizontal {
	width: 50px;
}




.nucleus-mini-table-container::-webkit-scrollbar {
	width: 8px;
	background-color: #F5F5F5;
}

.nucleus-mini-table-container::-webkit-scrollbar-thumb {
	background-color: rgba(3, 52, 66, 0.1);
	background-color: #03313E;
	border-radius: 10px;
}

.nucleus-mini-table-container::-webkit-scrollbar-thumb:hover {
	background-color: #03313E;
	border-radius: 10px;
}

.nucleus-mini-table-container::-webkit-scrollbar-track {
	border-radius: 5px;
}

.nucleus-mini-table-container::-webkit-scrollbar-track-piece {
	height: 50px;
}

.nucleus-mini-table-container::-webkit-scrollbar-thumb:vertical {
	height: 50px;
}

.nucleus-table {
	max-height: 97%;
}



.log-table-cell {
	margin: 0px;
	padding: -30px;
}

input[type=text] {
	padding-bottom: -3px !important;
}

.nucleus-icon {
	width: 1.6em;
}

.nucleus-icon-s {
	margin-top: 4px !important;
	width: 29px;
	margin-bottom: -3px;
}

.nucleus-icon-smaller {
	width: 1.3em;
	margin-bottom: 1px;
}

.nucleus-icon-bigger {
	width: 1.8em;
}

.nucleus-icon-dynamic {
	margin: 0px;
	padding: 0px;
	padding-top: 0px;
	height: 28px;
}

.nucleus-chart {
	width: 90%;
	height: 60%;

	border: 1px solid #B3B3B3;
	border-radius: 9px;
}

.nucleus-chart-title {
	height: 45px;
	border-bottom: 1px solid #B3B3B3;
}

.nucleus-chart-title-text {
	font-size: 14px;
}

.nucleus-chart-body {
	height: 290px;
	margin-left: 10px;
	margin-right: 10px;
	bottom: 0;
}

.chart-red {
	color: #C70100;
	font-weight: bold;
}

.chart-yellow {
	color: #FCD200;
	font-weight: bold;
}

.chart-dark-yellow {
	color: #FCD200;
	font-size: 13px;
}

.chart-dark-white {
	color: #f2f2f2;
	font-size: 11px;
}

.chart-blue {
	color: #3099D5;
	font-weight: bold;
}

.chart-orange {
	color: #FA6500;
	font-weight: bold;
}

.color-nucleus-yellow {
	color: #FFCD01;
	font-weight: bold;
}

.color-nucleus-blue {
	color: #018FFF;
	font-weight: bold;
}


.nucleus-modal {
	overflow-y: hidden;
	min-width: 50px;
	min-height: 50px;

	max-width: 760px;
	max-height: 471px;

	padding: 0;
	background-color: rgb(0, 0, 0);
	/*13, 16, 45*/
	border: 2px none green;
	border-radius: 5px 5px 10px 10px;
}

#modalUpdateAssigneCaregiver {
	margin-top: 5%;
	width: 35%;
	z-index: 2000;
}

.nucleus-modal-content {
	/* padding: 0 !important;
	margin:0px

	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;; */
	padding-top: 23px !important;
	padding-left: 35px !important;
	padding-right: 35px !important;
	padding-bottom: 25px !important;
}



.nucleus-call-image {
	margin: 0 !important;
	border: 2px none red;
}

.nucleus-modal-call {
	overflow-y: hidden;


	width: 640px;
	height: 403px;

	padding: 0 !important;
	background-color: rgb(0, 0, 0);
	/*13, 16, 45*/
	border: 0px none green;
	border-radius: 5px 5px 10px 10px;
	overflow-x: hidden !important;

}

.nucleus-modal-content-call {
	margin: 0px !important;
	padding: 0px !important;

	width: 99.9%;
	height: 99.9%;

	border: 0px none blue;

	background-color: #0E102B;

}

.volume-controls {
	position: absolute;
	width: 30%;
	margin: 0px !important;
	padding: 0px !important;

	left: 0;
	border: 1px none white;
}

.volume-controls-bar {
	width: 100%;
	padding-left: 5px;
	padding-right: 5px;
	height: 50% !important;
	border: 1px none white;
	padding: 7px !important;
}

.nucleus-control-range {
	border: 1px none white !important;
	min-width: 40% !important;
	width: 60%;
	max-width: 60% !important;
	/*height: 30% !important;*/
	text-decoration: none !important;
	margin: 0px !important;
	padding: 0px !important;
	margin-left: 15px !important;
	margin-right: 15px !important;

	-webkit-appearance: none !important;
}

/*input[type=range]{
    text-decoration: none !important;
  	outline: none;
     -webkit-appearance: none !important; Hides the slider so that custom slider can be made 
  	height: 30% !important;
  	border: 1px none white !important;
}
*/
input[type="range"] {
	-webkit-appearance: none !important;
	-moz-apperance: none !important;
	border-radius: 6px;
	height: 10px !important;

	background-image: -webkit-gradient(linear,
			left top,
			right top,
			color-stop(0.5, rgba(194, 192, 194, 1)),
			color-stop(0.5, rgba(194, 192, 194, 0.3)));
}

input[type='range']::-webkit-slider-thumb {
	-webkit-appearance: none !important;
	background-color: #E9E9E9;
	border: 1px solid #CECECE;
	height: 15px;
	width: 15px;
}

input[type=range]:focus {
	border: 1px none transparent !important;
	min-width: 40% !important;
	width: 60%;
	max-width: 60% !important;
	height: 10px !important;
	text-decoration: none !important;
	margin: 0px !important;
	padding: 0px !important;
	margin-left: 15px !important;
	margin-right: 15px !important;
}

input[type=range]::-webkit-slider-runnable-track {
	background: transparent;
}

input[type=range]::-webkit-slider-thumb {
	-webkit-appearance: none !important;
}

/*input[type=range]:focus {
  outline: none;  Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. 
}*/




.nucleus-communication-frame {
	position: absolute;
	border: 0px none white;
	width: 640px !important;
	height: 364px !important;

	margin: 0px !important;
	padding: 0px !important;
	background-color: #000;
	margin-top: 43px !important;
}

.nucleus-audiocall-frame {
	position: absolute;
	border: 0px none white;
	width: 99.9% !important;
	height: 95% !important;

	margin: 0px !important;
	padding: 0px !important;
	background-color: #0E102B;
	margin-top: 43px !important;
}

.nucleus-videocall-frame {
	position: absolute;
	border: 0px none white;
	width: 99.9% !important;
	height: 95% !important;

	margin: 0px !important;
	padding: 0px !important;
	margin-top: 43px !important;
}

.nucleus-call-bar {
	position: absolute;
	width: 99.9%;
	margin: 0px !important;
	padding: 0px !important;
	min-height: 30px;
	height: 43px;
	top: 0;
	background-color: #0E102B;
	border: 0px none red;
}

.nucleus-call-caller {
	position: absolute;
	width: 99.9%;
	margin: 0px !important;
	padding: 0px !important;
	height: 99.9%;
	top: 0;
	border: 2px none yellow;
	background-color: #0E102B;
}

.call-name-capitals {
	position: absolute;
	font-size: 4em;
}

.call-rings,
.call-oval {

	position: absolute;
	margin: auto;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}

.ring1 {
	width: 180px;
	height: 180px;
}

.ring2 {
	width: 180px;
	height: 180px;
}

.ring3 {
	width: 210px;
	height: 150px;
}

.ring4 {
	width: 290px;
	height: 150px;
}

.call-frame-background {
	position: absolute;
	width: 99%;
	max-width: 99%;
	max-height:  99%;
	margin-top: -20px;
	text-align: center;
}

.callModeTitle {
	position: absolute;
	height: 99%;
	width: 99.9%;
	margin-top: 35px;
	font-size: 29px !important;
	font-family: GothamNarrow-Light, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;

}


.callModeSubtitle {
	position: absolute;
	height: 99%;
	width: 99%;
	margin-top: 75px;
	font-size: 18px !important;
	font-family: GothamNarrow-Light, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;

}

.nucleus-call-controls {
	position: absolute;
	width: 99.9%;
	margin: 0px !important;
	padding: 0px !important;
	padding-top: 9px !important;
	bottom: 0;
	border: 0px none yellow;

	display: inline;
}

.nucleus-call-control {
	width: 42px;
	margin-top: 5px;
}

.nucleus-call-controls-bg {
	background-color: rgba(64, 64, 64, 0.2);
}

.control-panels-container {
	border: 1px none white;
	display: inline-flex;
}

.control-panels {
	border: 1px none white;
	display: block;
	width: 80px;
	font-size: 10px;
	text-align: center !important;
}

.control_end_call {}

.mic1 {
	width: 11px;
}

.vol1 {
	width: 17px;
}

.call-control-title {
	margin-top: -10px;
}

input[type=range]::-webkit-slider-thumb {
	background-color: white;
	border: 0px none white !important;
}

input[type=range]::-moz-range-thumb {
	background-color: white !important;
}

input[type=range]::-ms-thumb {
	background-color: white !important;
}

/***** These are to edit the thumb and the text inside the thumb *****/
input[type=range]+.thumb {
	display: none;
	text-decoration-color: none;
	text-decoration: none;
}

input[type=range]+.thumb.active .value {
	color: white;
}

.modalScrollableSmall {
	background: #EBEBEB;
	border-radius: 10px 10px 10px 10px;
	min-width: 390px !important;
	width: 36%;
	padding-bottom: 10px;
}

.modalCallLog,
.modalMultiSMS {
	background: #D8D8D8;
	border-radius: 10px 10px 10px 10px;
	/*height: 50%;
	min-height: 54%;
	max-height: 70%;*/
	border: 2px none green;
	overflow: hidden;
}

#modalEditAssignment {
	max-height: 90%;
}

.modalScrollable {
	/*background: #D8D8D8;*/
	border-radius: 10px 10px 10px 10px;
	min-width: 35%;
	width: 45%;
}

.modalScrollable_55 {
	/*background: #D8D8D8;*/
	border-radius: 10px 10px 10px 10px;
	min-width: 45%;
	width: 55%;
}

.modalAssignment {
	background: #D8D8D8;
	border-radius: 10px 10px 10px 10px;
	height: 65%;
	/*min-height: 54%;
	max-height: 70%;*/
	border: 2px none green;
	overflow: hidden;
	min-width: 35%;
	width: 45%;
	max-width: 55%;
}

.nucleus-modal-wrapper {
	width: 100%;
	min-height: 80%;
	height: 100% !important;
	border: 2px none blue;
	margin-bottom: 0px !important;
}

.nucleus-modal-wrapper-scrollable {
	width: 100%;
	min-height: 80%;
	height: 100% !important;
	border: 2px none blue;
	margin-bottom: 0px !important;
	overflow-y: scroll;
}

.modallScrollable {}

.modalCallLogContent {

	margin: 0px;
	padding: 0px;
	min-height: 50%;
	height: 83%;
	max-height: 90%;
	border: 2px none red;
	position: relative;
	display: block;
}

.modalSeparator {
	position: relative;
	margin-top: 25% !important;
	font-size: 5px;
}

.nucleus-textarea {
	background-color: white !important;
	margin: 0;
	min-height: 140px;
	height: 70%;
	max-height: 92%;
	overflow-y: scroll;
	margin-bottom: 10px;
	padding: 8px;
}

.nucleus-textarea-medium {
	background-color: white !important;
	margin: 0;
	min-height: 115px;
	height: 65%;
	max-height: 85%;
	overflow-y: scroll;
	margin-bottom: 10px;
	padding: 8px;
}

.nucleus-textarea-small {
	background-color: white !important;
	margin: 0;
	min-height: 85px;
	height: 50%;
	max-height: 85%;
	overflow-y: scroll;
	margin-bottom: 10px;
	padding: 8px;
}

.img-close-modal {
	position: relative;
	float: right;
	/* margin-top: -10px; */
	width: 14px;
	cursor: pointer;
}

.modal-overlay {
	/*display: none !important;*/
}

.log-header {
	border: 2px none red;
	margin-top: 23px;
	margin-bottom: 5px;
	padding-left: 0px;
}

.log-row {
	border: 2px none blue;
	margin-top: 13px;
	margin-bottom: 13px;
}

.no-padding {
	padding: 0px;
}

.no-padding-left {
	padding-left: 0px !important;
}

.modalUnblockApi 
.modalResetUserPassword
{
	border-radius: 10px 10px 10px 10px;
	padding-bottom: 0px;

	min-width: 36%;
	width: 36% !important;
	max-width: 60%;
}

#modalResetUserPasswordForce{
	width: 36% !important;
}

.modalDeletePatient,
.modalDeleteCaregiver,
.modalDeleteQueueItem,
.modalDeviceSelectedDetails,
.modalDeletePatientGenerateApiToken {

	border-radius: 10px 10px 10px 10px;
	padding-bottom: 0px;

	min-width: 40%;
	width: 40%;
	max-width: 60%;
}

.modalDeleteAccountDevice,
.modalDownloadDeviceLogs,
.modalEditCategory,
.modalNewCategory,
.modalDeleteAccountButton,

.modalEditCsUser,
.modalDeviceDetails,
.modalPatientTimezone 
{

	border-radius: 10px 10px 10px 10px;
	padding-bottom: 0px;

	min-width: 40%;
	width: 40%;
	max-width: 60%;
}

.modalDeleteUser,
.modalAssignClient,
.modalUnassignClient,
.modalAssignAllPatients {

	border-radius: 10px 10px 10px 10px;
	padding-bottom: 0px;

	min-width: 40%;
	width: 40%;
	max-width: 60%;
}

.modalMedium,
.modalSelectTemplate,
.modalOrderDetails {
	border-radius: 10px 10px 10px 10px;
	padding-bottom: 0px;

	min-width: 60%;
	width: 60%;
	max-width: 70%;
}

.modalNewAccount,
.modalNewAccountDevice,
.modalNewAccountLanguage,
.modalNewAccountButton,
.modalEditAccountButton,
.modalNewAccountBiometricDevice,
.modalEditAccountBiometricDevice,
.modalDeleteAccountBioDevice,
.modalNewAccountSchedule,
.modalEditAccountSchedule,
.modalDeleteAccountSchedule,
.modalUpdateDefaultAccountSchedule,
.modalDeleteAccount {

	border-radius: 10px 10px 10px 10px;
	padding-bottom: 0px;

	min-width: 40%;
	width: 40%;
	max-width: 60%;
}

.modal-content-delete,
.modal-general-content {
	margin-bottom: 0px;
	padding-bottom: 0px !important;
}


input {
	border-bottom: 1px solid #e6e6e6 !important;
	box-shadow: 0 1px 0 0 #e6e6e6 !important;

	padding-bottom: 0px !important;
	height: 2rem !important;
}

input:focus {
	border-bottom: 1px solid black !important;
	box-shadow: 0 1px 0 0 black !important;

	padding-bottom: 0px !important;
	height: 2rem !important;
}

.nucleus-table-header {
	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: large;
	font-weight: bolder;
	font-size: 19px;
	padding-bottom: 0px !important;
}

.nucleus-table-header-medium {
	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: large;
	font-weight: bold;
	font-size: 18px;
	padding-bottom: 0px !important;
}

.nucleus-table-header-small {
	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: medium;
	font-weight: 500;
	font-size: 17px;
	padding-bottom: 0px !important;
}



td {
	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: medium;

	padding-top: 7px;
	padding-bottom: 7px;

}

th {
	padding-top: 7px;
	padding-bottom: 2px;
	vertical-align: bottom;
}

.nucleus-form-error {
	font-family: GothamNarrow-Light, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: 14px;
	color: red;
	width: 100%;
}

.nucleus-form-error-tools {
	font-family: GothamNarrow-Book, 'Lucida Sans';
	font-size: 14px;
	color: #D0021B;
}

.nucleus-date-picker {
	border: 2px none red !important;
	background-color: white !important;
	padding-left: 4px !important;
	margin-bottom: 0px !important;
	padding-bottom: 0px !important;
}

.nucleus-date-picker2 {
	border: 1px none red !important;
	background-color: white !important;
	padding-left: 4px !important;
	margin-bottom: 0px !important;
	padding-bottom: 0px !important;
	width: 60% !important;
	border-radius: 2px !important;
	margin-top: -2px;

}

/* do not group these rules */
.placeholder-black::-webkit-input-placeholder {
	color: black;
}

.placeholder-black:-moz-placeholder {
	/* FF 4-18 */
	color: black;
}

.placeholder-black::-moz-placeholder {
	/* FF 19+ */
	color: black;
}

.placeholder-black:-ms-input-placeholder {
	/* IE 10+ */
	color: black;
}

.placeholder-gray {
	color: #9D9D9D;
}

.gray {
	color: #868686;
}

/* .table-col-1{
	width: 1%;
}
.table-col-2{
	width: 2%;
}
.table-col-3{
	width: 3%;
}
.table-col-4{
	width: 4%;
}
.table-col-5{
	width: 5%;
}
.table-col-5{
	width: 5%;
}
.table-col-6{
	width: 6%;
}
.table-col-7{
	width: 7%;
}
.table-col-8{
	width: 8%;
}
.table-col-9{
	width: 9%;
}
.table-col-10{
	width: 10%;
}
.table-col-11{
	width: 11%;
}
.table-col-12{
	width: 12%;
}
.table-col-13{
	width: 13%;
}
.table-col-14{
	width: 14%;
}
.table-col-15{
	width: 15%;
}
.table-col-16{
	width: 16%;
}
.table-col-17{
	width: 17%;
}
.table-col-18{
	width: 18%;
}
.table-col-19{
	width: 19%;
}
.table-col-20{
	width: 20%;
}
.table-col-21{
	width: 21%;
}
.table-col-24{
	width: 24%;
}
.table-col-25{
	width: 25%;
}
.table-col-30{
	width: 30%;
}
.table-col-40{
	width: 40%;
}
.table-col-45{
	width: 45%;
}
.table-col-50{
	width: 50%;
} */

.invalid-field {
	background: red !important;
	color: white;
}

.nucleus-profile {
	background-color: #008FFF;
	font-family: GothamNarrow-Light, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', Geneva, sans-serif;
	font-size: large;
}

.txt-device-mac,
.txt-device-mac:focus {
	width: 190px !important;
	height: 35px !important;
	margin-top: 9px !important;
}

.select-device-mac,
.select-device-mac:focus {
	margin-top: 9px;
	height: 35px !important;
}


/* CS Style */
/* ============== */

.nucleus-labels-bottom {
	font-size: 16px;
	margin-bottom: 5px;

	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: medium;
	position: absolute;
	bottom: 0;
}

.accountLogo {
	width: 29px;
}

.accountTextShort {
	min-width: 150px !important;
	width: 165px !important;
}

.accountText {
	min-width: 140px !important;
	width: 160px !important;
}

.accountTextBitShort {
	min-width: 25% !important;
	width: 30% !important;
}

.dim-input-size {
	max-width: 25% !important;
	width: 25% !important;
}

.accountTextLong {
	min-width: 60% !important;
	width: 65% !important;
}

.accountTextMedium {
	min-width: 70% !important;
	width: 75% !important;
}

.accountTextFull {
	min-width: 90% !important;
	width: 95% !important;
}

.accountTextFull2 {
	min-width: 90% !important;
	width: 100% !important;
}

.accountTextFull3 {
	min-width: 90% !important;
	width: 104% !important;
}

.accountSelect {
	margin-top: 5px;
    min-width: 8% !important;
    /* width: 8% !important; */
    height: 30px;
}

.b-table-colored thead th {
	vertical-align: bottom;
	vertical-align: bottom;
	border-bottom: 2px solid #2296f3;
	color: #2296f3;
}

.nucleus-table-header-colored {
	color: #2296f3;
}

.accountSelectApps {
	margin-top: 5px;
    min-width: 24% !important;
    width: 24% !important;
    height: 30px;
}

.accountSelectDim {
	margin-left: 30px !important;
	min-width: 30% !important;
	width: 50% !important;
	height: 30px;
}

.accountSelect100 {
	margin-top: 5px;
	min-width: 90% !important;
	width: 100% !important;
	height: 30px;
}

.vbottom-align {
	text-align: bottom;
	/* vertical-align: bottom !important; */
	min-height: 30px;
    height: 38px;
	display: inline-table;
    width: 100%;
}

.vbottom-align-not-height {
	text-align: bottom;
	vertical-align: bottom !important;
	min-height: 25px;
	height: 30px;
}

.span-text-bottom {
	padding-top: 10px;
}

.top-more-separated {
	padding-bottom: 30px !important;
}

.bit-top-separated {
	padding-top: 5px !important;
}

.bit-top-separated-2 {
	padding-top: 2px !important;
}

.top-separated {
	padding-top: 10px !important;
}

.top-separated-12 {
	margin-top: 12px !important;
}

.top-separated-15 {
	margin-top: 15px !important;
}

.top-separated-20 {
	padding-top: 20px !important;
}

.a-few-left {
	margin-right: 5px !important;
}

.a-bit-left {
	margin-left: -2px;
}

.a-bit-lower3 {
    margin-top: 5px !important;
}

.only-top-margin-upper{
    margin: -5px 0px 0px;
	padding: 0px !important;
}

.a-left {
	margin-left: -4px;
}

.a-bit-right {
	margin-left: 3px;
}

.a-few-right {
	margin-left: 5px;
}

.a-more-right {
	margin-left: 10px !important;
}

.a-more-right-21 {
	margin-left: 21px !important;
}

.a-more-right-23 {
	margin-left: 23px !important;
}

.a-little-right {
	padding-left: 2px !important;
}

.padding-left-10 {
	padding-left: 10px;
}

.a-few-right2 {
	margin-left: 20px;
}

.a-much-right {
	margin-left: 185px !important;
}

.a-much-left {
	margin-right: 185px !important;
}

.margin-left {
	margin-left: 10px !important;
}

.a-margin-left {
	margin-left: 25px !important;
}

.margin-right {
	margin-right: 10px !important;
}

.a-margin-right {
	margin-right: 15px !important;
}

.much-margin-left {
	margin-left: 50px !important;
}

.nucleus-floating-button {
	height: 48px !important;
	width: 48px !important;
}

.nucleus-floating-icon {
	line-height: 48px !important;
}

.nucleus-floating-btn-icon {
	font-size: 1.1rem !important;
	line-height: 30px !important;
}

.nucleus-floating-copy-btn-icon {
	font-size: 1.1rem !important;
	line-height: 30px !important;
	margin-bottom: 5px !important;
}

.nucleus-check {
	margin-left: 0px !important;
}

.nucleus-input-form-small-left {
	text-align: left;
	color: #000;
	padding-bottom: 0px !important;
	margin-bottom: 4px !important;
	border: 3px solid black;
	height: 19px;

	font-size: 17px !important;

	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: larger;
	width: 50% !important;
}

.no-margin-bottom {
	margin-bottom: 0px !important;
}

.height30 {
	height: 30px !important;
}

.width100 {
	width: 100%;
}

.width83 {
	width: 73% !important;
}

/*.selected-flag {
	background-color: #fff !important;
}*/

.selected-flag:focus {
	background-color: #fff !important;
}

.txt-black-forced {
	color: #000 !important;
}

.txt-1-4 {
	min-width: 70% !important;
	width: 75% !important;
	height: 21px !important;
}

.txt-1-4:hover {
	height: 21px !important;
}

.txt-1-4:focus {
	height: 21px !important;
}


.f-small {
	font-size: 15px !important;
	white-space: pre;
}


.nucleus-icon-active {
	color: #000;
}

.nucleus-icon-inactive {
	color: #b3b3b3;
}

.nucleus-icon-active:hover {
	cursor: pointer;
}

.nucleus-icon-inactive:hover {
	cursor: pointer;
}

.MuiInputBase-root {
	margin-top: -5px;
	width: 100%;
}

.MuiInputBase-root input {
	border-style: none !important;
	box-shadow: none !important;
	margin-bottom: 0px !important;
}

.MuiInputBase-root input:focus {
	border-style: none !important;
	box-shadow: none !important;
	margin-bottom: 0px !important;
}

.browser-default .MuiInput-underline:before {
  border-bottom: none !important;
}

.MuiPickersClock-squareMask {
	cursor: pointer;
}

.MuiIconButton-root:focus {
	background-color: transparent !important;
}

.bottom-line {
	border-bottom-color: #b1b6ba;
	border-bottom-width: 1px;
	border-bottom-style: solid;
	padding-bottom: 5px;
}

.right-line-separator {
	border-right-color: #b1b6ba;
	border-right-width: 2px;
	border-right-style: solid;
	margin-bottom: 12px;
}

.specialOverflowX {
	overflow-x: scroll;
}

.specialOverflowX:hover {
	overflow-x: scroll;
}

.thead-s {
	margin-right: 16px;
}

.tbody-s {
	display: block;
	height: 560px;
	overflow: auto;
}

/* .thead-s, .tbody-s tr {
    display:table;
    table-layout:fixed;
} */

/* New Table Css */
.b-table {
	width: 100%;
	margin-bottom: 1rem;
	color: #212529;
	border-collapse: separate; 
}

.b-table td {
	padding: .75rem;
	vertical-align: center;
	border-top: 1px solid #dee2e6
}

.b-table thead th {
	vertical-align: bottom;
	border-bottom: 2px solid #dee2e6
}

.b-table-colored thead th {
	vertical-align: bottom;
	border-bottom: 2px solid #2296f3ff
}

.b-table tbody+tbody {
	border-top: 2px solid #dee2e6
}

.b-table .thead-dark th {
	color: #fff;
	background-color: #343a40;
	border-color: #454d55
}

.b-table .thead-light th {
	color: #495057;
	background-color: #e9ecef;
	border-color: #dee2e6
}

/* .b-table {
	border-collapse: collapse !important
} */
/* .b-table td,
.b-table th {
	background-color: #fff !important
} */

.b-table .thead-dark th {
	color: inherit;
	border-color: #dee2e6
}

.b-table-bordered {
	border: 1px solid #dee2e6
}

.b-table-bordered td,
.b-table-bordered th {
	border: 1px solid #dee2e6
}

.b-table-bordered thead td,
.b-table-bordered thead th {
	border-bottom-width: 2px
}

.table-dark.b-table-bordered {
	border: 0
}

@media (max-width:575.98px) {
	.table-responsive-sm {
		display: block;
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch
	}

	.table-responsive-sm>.b-table-bordered {
		border: 0
	}
}

@media (max-width:767.98px) {
	.table-responsive-md {
		display: block;
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch
	}

	.table-responsive-md>.b-table-bordered {
		border: 0
	}
}

@media (max-width:991.98px) {
	.table-responsive-lg {
		display: block;
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch
	}

	.table-responsive-lg>.b-table-bordered {
		border: 0
	}
}

@media (max-width:1199.98px) {
	.table-responsive-xl {
		display: block;
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch
	}

	.table-responsive-xl>.b-table-bordered {
		border: 0
	}
}

.table-responsive {
	display: block;
	width: 100%;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch
}

.table-responsive>.b-table-bordered {
	border: 0
}

.b-table-bordered td,
.b-table-bordered th {
	border: 1px solid #dee2e6 !important
}

/* table {
	border-collapse: collapse
} */

.b-table-hover tbody tr:hover {
	/* color: #FFFFFF; */
	background-color: #eeeeee
}

/* .b-table-active,
.b-table-active>td,
.b-table-active>th {
    background-color: rgba(0, 0, 0, .075)
}

.b-table-hover .b-table-active:hover {
	background-color: #03313E
}

.b-table-hover .b-table-active:hover>td,
.b-table-hover .b-table-active:hover>th {
	background-color: #03313E
} */

.sticky-thead th {
	z-index: 999;
	background: white;
	position: sticky;
	top: 0; /* Don't forget this, required for the stickiness */
	/* box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4); */
}
.b-table td{
	/* display: tab; */
}
.col,
.b-col-1,
.b-col-10,
.b-col-11,
.b-col-12,
.b-col-2,
.b-col-3,
.b-col-4,
.b-col-5,
.b-col-6,
.b-col-7,
.b-col-8,
.b-col-9,
.b-col-auto,
.b-col-lg,
.b-col-lg-1,
.b-col-lg-10,
.b-col-lg-11,
.b-col-lg-12,
.b-col-lg-2,
.b-col-lg-3,
.b-col-lg-4,
.b-col-lg-5,
.b-col-lg-6,
.b-col-lg-7,
.b-col-lg-8,
.b-col-lg-9,
.b-col-lg-auto,
.b-col-md,
.b-col-md-1,
.b-col-md-10,
.b-col-md-11,
.b-col-md-12,
.b-col-md-2,
.b-col-md-3,
.b-col-md-4,
.b-col-md-5,
.b-col-md-6,
.b-col-md-7,
.b-col-md-8,
.b-col-md-9,
.b-col-md-auto,
.b-col-sm,
.b-col-sm-1,
.b-col-sm-10,
.b-col-sm-11,
.b-col-sm-12,
.b-col-sm-2,
.b-col-sm-3,
.b-col-sm-4,
.b-col-sm-5,
.b-col-sm-6,
.b-col-sm-7,
.b-col-sm-8,
.b-col-sm-9,
.b-col-sm-auto,
.b-col-xl,
.b-col-xl-1,
.b-col-xl-10,
.b-col-xl-11,
.b-col-xl-12,
.b-col-xl-2,
.b-col-xl-3,
.b-col-xl-4,
.b-col-xl-5,
.b-col-xl-6,
.b-col-xl-7,
.b-col-xl-8,
.b-col-xl-9,
.b-col-xl-auto {
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px
}

.b-col {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%
}

.b-col-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%
}

.b-col-1 {
    flex: 0 0 8.333333%;
    max-width: 8.333333%
}

.b-col-2 {
    flex: 0 0 16.666667%;
    max-width: 16.666667%
}

.b-col-3 {
    flex: 0 0 25%;
    max-width: 25%
}

.b-col-4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%
}

.b-col-5 {
    flex: 0 0 41.666667%;
    max-width: 41.666667%
}

.b-col-6 {
    flex: 0 0 50%;
    max-width: 50%
}

.b-col-7 {
    flex: 0 0 58.333333%;
    max-width: 58.333333%
}

.b-col-8 {
    flex: 0 0 66.666667%;
    max-width: 66.666667%
}

.b-col-9 {
    flex: 0 0 75%;
    max-width: 75%
}

.b-col-10 {
    flex: 0 0 83.333333%;
    max-width: 83.333333%
}

.b-col-11 {
    flex: 0 0 91.666667%;
    max-width: 91.666667%
}

.b-col-12 {
    flex: 0 0 100%;
    max-width: 100%
}

.nucleusSearchInputMainContainer {
	display: flex;
	width: 100%;
	flex-direction: row;
	justify-content: space-between;
}

.nucleusInputSelect {
	display: block; 
	width: 200px; 
	height: 35px;
	border-radius: 10px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.nucleus-chips input{
	text-decoration: none !important;
	border-bottom: 0px none white !important;
	

	border-bottom: 1px solid white !important;
    box-shadow: none !important;
    padding-top: 5px !important;

    width: 150px !important;
	text-align: center;
}

.nucleus-chips .input{

    width: 148px !important;
}

.nucleus-chips input:hover{
	text-decoration: none !important;
	border-bottom: 0px none white !important;
	width: 140px !important;
}


/* For page Accounts */
.nucleus-input-form-big-left{
	text-align: left;
	color: #000;
	padding-bottom: 0px !important;
	margin-bottom: 4px !important;
	border:3px solid black;
    height: 19px;

    font-size: 15px !important;

	font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
	font-size: larger;
}

.nucleus-select-wrapper{
	height: 50px;
	overflow-y: visible;
	width: 102px;
    display: inline-flex;
	margin-left: 105px;
}
  .nucleus-m-1 {
	margin: 1rem;
  }
  
  .nucleus-m-2 {
	margin: 2rem;
  }
  
  .nucleus-m-3 {
	margin: 3rem;
  }
  
  .nucleus-m-4 {
	margin: 4rem;
  }
  
  .nucleus-m-5 {
	margin: 5rem;
  }
  
  .nucleus-m-6 {
	margin: 6rem;
  }
  
  .nucleus-m-7 {
	margin: 7rem;
  }
  
  .nucleus-m-8 {
	margin: 8rem;
  }
  
  .nucleus-m-9 {
	margin: 9rem;
  }
  
  .nucleus-m-10 {
	margin: 10rem;
  }
  
  .nucleus-m-11 {
	margin: 11rem;
  }
  
  .nucleus-m-12 {
	margin: 12rem;
  }
  
  .nucleus-mt-1 {
	margin-top: 1rem;
  }
  
  .nucleus-mr-1 {
	margin-right: 1rem;
  }
  
  .nucleus-mb-1 {
	margin-bottom: 1rem;
  }
  
  .nucleus-ml-1 {
	margin-left: 1rem;
  }
  
  .nucleus-mt-2 {
	margin-top: 2rem;
  }
  
  .nucleus-mr-2 {
	margin-right: 2rem;
  }
  
  .nucleus-mb-2 {
	margin-bottom: 2rem;
  }
  
  .nucleus-ml-2 {
	margin-left: 2rem;
  }
  
  .nucleus-mt-3 {
	margin-top: 3rem;
  }
  
  .nucleus-mr-3 {
	margin-right: 3rem;
  }
  
  .nucleus-mb-3 {
	margin-bottom: 3rem;
  }
  
  .nucleus-ml-3 {
	margin-left: 3rem;
  }
  
  .nucleus-mt-4 {
	margin-top: 4rem;
  }
  
  .nucleus-mr-4 {
	margin-right: 4rem;
  }
  
  .nucleus-mb-4 {
	margin-bottom: 4rem;
  }
  
  .nucleus-ml-4 {
	margin-left: 4rem;
  }
  
  .nucleus-mt-5 {
	margin-top: 5rem;
  }
  
  .nucleus-mr-5 {
	margin-right: 5rem;
  }
  
  .nucleus-mb-5 {
	margin-bottom: 5rem;
  }
  
  .nucleus-ml-5 {
	margin-left: 5rem;
  }
  
  .nucleus-mt-6 {
	margin-top: 6rem;
  }
  
  .nucleus-mr-6 {
	margin-right: 6rem;
  }
  
  .nucleus-mb-6 {
	margin-bottom: 6rem;
  }
  
  .nucleus-ml-6 {
	margin-left: 6rem;
  }
  
  .nucleus-mt-7 {
	margin-top: 7rem;
  }
  
  .nucleus-mr-7 {
	margin-right: 7rem;
  }
  
  .nucleus-mb-7 {
	margin-bottom: 7rem;
  }
  
  .nucleus-ml-7 {
	margin-left: 7rem;
  }
  
  .nucleus-mt-8 {
	margin-top: 8rem;
  }
  
  .nucleus-mr-8 {
	margin-right: 8rem;
  }
  
  .nucleus-mb-8 {
	margin-bottom: 8rem;
  }
  
  .nucleus-ml-8 {
	margin-left: 8rem;
  }
  
  .nucleus-mt-9 {
	margin-top: 9rem;
  }
  
  .nucleus-mr-9 {
	margin-right: 9rem;
  }
  
  .nucleus-mb-9 {
	margin-bottom: 9rem;
  }
  
  .nucleus-ml-9 {
	margin-left: 9rem;
  }
  
  .nucleus-mt-10 {
	margin-top: 10rem;
  }
  
  .nucleus-mr-10 {
	margin-right: 10rem;
  }
  
  .nucleus-mb-10 {
	margin-bottom: 10rem;
  }
  
  .nucleus-ml-10 {
	margin-left: 10rem;
  }
  
  .nucleus-mt-11 {
	margin-top: 11rem;
  }
  
  .nucleus-mr-11 {
	margin-right: 11rem;
  }
  
  .nucleus-mb-11 {
	margin-bottom: 11rem;
  }
  
  .nucleus-ml-11 {
	margin-left: 11rem;
  }
  
  .nucleus-mt-12 {
	margin-top: 12rem;
  }
  
  .nucleus-mr-12 {
	margin-right: 12rem;
  }
  
  .nucleus-mb-12 {
	margin-bottom: 12rem;
  }
  
  .nucleus-ml-12 {
	margin-left: 12rem;
  }
  `, "",{"version":3,"sources":["webpack://./src/css/nucleus_care_customer_support.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;;;AAGA;CACC,SAAS;CACT,UAAU;;CAEV,gBAAgB;CAChB,YAAY;;AAEb;;AAEA;CACC,gCAAgC;CAChC,oDAAoD;CACpD,2FAA2F;AAC5F;;AAEA;CACC,iCAAiC;CACjC,qDAAqD;CACrD,4FAA4F;AAC7F;;AAEA;CACC,kCAAkC;CAClC,sDAAsD;CACtD,6FAA6F;AAC9F;;AAEA;CACC,gCAAgC;CAChC,oDAAoD;CACpD,2FAA2F;AAC5F;;AAEA;CACC,qBAAqB;CACrB,+DAAiE;AAClE;;;AAGA;CACC,qBAAqB;CACrB,eAAe;AAChB;;AAEA;;CAEC,SAAS;CACT,UAAU;CACV,YAAY;AACb;;AAEA;CACC,SAAS;CACT,UAAU;CACV,gBAAgB;CAChB,YAAY;CACZ,WAAW;CACX,aAAa;;AAEd;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,uBAAuB;CACvB,uBAAuB;AACxB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,WAAW;CACX,eAAe;CACf,uBAAuB;;;AAGxB;;AAEA;CACC,uBAAuB;CACvB,kBAAkB;CAClB,2BAA2B;CAC3B,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;IACpB,gCAAgC;IAChC,2BAA2B;IAC3B,cAAc;IACd;AACJ;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;CACC,gCAAgC;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IAEI,mBAAmB;IACnB,aAAa;IACb,SAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;CACC,2BAA2B;CAC3B,gBAAgB;CAChB,gBAAgB;IACb,4BAA4B;AAChC;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,YAAY;IACT,8BAA8B;AAClC;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,WAAW;IACX,8BAA8B;IAC9B,6BAA6B;IAC7B,uBAAuB;IACvB,YAAY;IACZ,0BAA0B;IAC1B,yIAAyI;IACzI,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,yIAAyI;CACzI,gBAAgB;CAChB,mBAAmB;CACnB,0BAA0B;CAC1B,YAAY;CACZ,+BAA+B;CAC/B,kBAAkB;CAClB,mBAAmB;;AAEpB;;AAEA;CACC,yIAAyI;CACzI,gBAAgB;CAChB,mBAAmB;CACnB,0BAA0B;CAC1B,YAAY;CACZ,+BAA+B;CAC/B,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,iBAAiB;AAClB;AACA;CACC,yBAAyB;CACzB,oBAAoB;AACrB;;AAEA;CACC,yIAAyI;CACzI,gBAAgB;CAChB,mBAAmB;CACnB,0BAA0B;CAC1B,cAAc;CACd,+BAA+B;CAC/B,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,yIAAyI;CACzI,gBAAgB;CAChB,mBAAmB;CACnB,0BAA0B;CAC1B,cAAc;CACd,+BAA+B;CAC/B,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,2BAA2B;CAC3B,6BAA6B;IAC1B,UAAU;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,uBAAuB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;CACC,mBAAmB;CACnB,gCAAgC;AACjC;;AAEA;CACC,mBAAmB;CACnB,gCAAgC;AACjC;;AAEA;CACC,WAAW;CACX,aAAa;CACb,yBAAyB;CACzB,8BAA8B;CAC9B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,aAAa;IACV,mBAAmB;IACnB,mBAAmB;CACtB,UAAU;IACP,8BAA8B;AAClC;;AAEA;CACC,aAAa;IACV,mBAAmB;IACnB,mBAAmB;CACtB,UAAU;IACP,8BAA8B;AAClC;;AAEA;CACC,eAAe;CACf,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,cAAc;IACX,iBAAiB;AACrB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;IAC3B,UAAU;AACd;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;IAC3B,UAAU;AACd;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,2BAA2B;CAC3B,2CAA2C;CAC3C,yBAAyB;AAC1B;;AAEA;CACC,2BAA2B;CAC3B,2CAA2C;AAC5C;;AAEA,gBAAgB;AAChB;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;AACd;;AAEA,sBAAsB;AACtB;CACC,WAAW;AACZ;;AAEA,gCAAgC;AAChC;CACC,8BAA8B;CAC9B,4BAA4B;AAC7B;;AAEA;;;;KAIK;AACL;;;;KAIK;AACL;;;KAGK;;AAEL;CACC,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,YAAY;IACT,iBAAiB;AACrB;;AAEA;CACC,2BAA2B;CAC3B,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,yIAAyI;CACzI,iBAAiB;CACjB,iBAAiB;CACjB,eAAe;;AAEhB;;AAEA,wBAAwB;AACxB;CACC,oCAAoC;CACpC,YAAY;CACZ,aAAa;CACb,UAAU;CACV,QAAQ;CACR,SAAS;CACT,gCAAgC;CAChC,eAAe;EACd;;EAEA;CACD,eAAe;CACf,QAAQ;CACR,SAAS;CACT,gCAAgC;EAC/B;;EAEA;CACD,qBAAqB;CACrB,4BAA4B;EAC3B;;AAEF;CACC,aAAa;CACb,yBAAyB;CACzB,kBAAkB;CAClB,8CAA8C;EAC7C;;AAEF;CACC,eAAe;CACf,cAAc;AACf;EACE;CACD,aAAa;CACb,WAAW;CACX,6BAA6B;EAC5B;EACA;CACD,aAAa;CACb,WAAW;CACX,sBAAsB;CACtB,cAAc;EACb;EACA;CACD,UAAU;IACP,aAAa;IACb,8BAA8B;EAChC;EACA;CACD,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,eAAe;EACd;EACA;CACD,gCAAgC;EAC/B;EACA;CACD,aAAa;CACb,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;CACjB,mBAAmB;CACnB,WAAW;CACX,4CAA4C;EAC3C;;EAEA;CACD,aAAa;CACb,YAAY;CACZ,iBAAiB;CACjB,YAAY;CACZ,WAAW;CACX,4CAA4C;EAC3C;;EAEA;CACD,YAAY;CACZ,iBAAiB;CACjB,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;EAC5B;;EAEA;CACD,SAAS;CACT,aAAa;CACb,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,kBAAkB;EACjB;;EAEA;CACD,aAAa;CACb,eAAe;CACf,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;EACV;;EAEA;CACD,mBAAmB;CACnB,WAAW;EACV;;EAEA;CACD,aAAa;CACb,6BAA6B;CAC7B,mBAAmB;EAClB;;EAEA;CACD,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,0BAA0B;CAC1B,4CAA4C;CAC5C,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,oBAAoB;CACpB,gBAAgB;CAChB,kBAAkB;EACjB;;EAEA;CACD,4CAA4C;CAC5C,+BAA+B;EAC9B;;EAEA;CACD,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,UAAU;CACV,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;CACjB,0BAA0B;CAC1B,cAAc;CACd,mBAAmB;CACnB,0BAA0B;EACzB;;EAEA;CACD,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,UAAU;CACV,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;CACjB,0BAA0B;CAC1B,cAAc;CACd,mBAAmB;CACnB,0BAA0B;EACzB;;EAEA;CACD,oDAAoD;CACpD,2BAA2B;CAC3B,mBAAmB;EAClB;;EAEA;CACD,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,UAAU;CACV,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;CACjB,yBAAyB;CACzB,cAAc;CACd,mBAAmB;CACnB,0BAA0B;EACzB;;EAEA;CACD,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,UAAU;CACV,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;CACjB,yBAAyB;CACzB,cAAc;CACd,mBAAmB;CACnB,0BAA0B;EACzB;;EAEA;CACD,gBAAgB;CAChB,eAAe;CACf,kBAAkB;EACjB;;AAEF;CACC,aAAa;CACb,WAAW;CACX,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,aAAa;AACd;AACA,wBAAwB;;;AAGxB;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,0GAA0G;CAC1G,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;;AAElB;;AAEA;CACC,uBAAuB;CACvB,0BAA0B;CAC1B,8BAA8B;CAC9B,yBAAyB;CACzB,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,2IAA2I;CAC3I,eAAe;CACf,eAAe;;CAEf,cAAc;;CAEd,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,gCAAgC;CAChC,mBAAmB;AACpB;;AAEA;CACC,uBAAuB;CACvB,kCAAkC;CAClC,2BAA2B;;CAE3B,gBAAgB;IACb,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;;IAEhB,gBAAgB;;AAEpB;;AAEA;CACC,uBAAuB;CACvB,kCAAkC;CAClC,2BAA2B;;CAE3B,gBAAgB;IACb,oBAAoB;IACpB,mBAAmB;;IAEnB,wBAAwB;;IAExB,gBAAgB;AACpB;;AAEA;CACC,gBAAgB;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,mBAAmB;;AAEvB;;AAEA;CACC,yIAAyI;CACzI,gBAAgB;CAChB,iBAAiB;CACjB,0BAA0B;CAC1B,aAAa;CACb,+BAA+B;CAC/B,mBAAmB;KACf,iBAAiB;IAClB,kBAAkB;;IAElB,yBAAyB;;AAE7B;;;AAGA;CACC,uBAAuB;CACvB,0BAA0B;CAC1B,8BAA8B;CAC9B,yBAAyB;CACzB,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;;CAEC,0CAA0C;CAC1C,2BAA2B;CAC3B,oBAAoB;AACrB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;;;GAIG;;AAEH;CACC,mBAAmB;CACnB,cAAc;CACd,2GAA2G;CAC3G,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;CAC1B,6BAA6B;AAC9B;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,4BAA4B;AAC7B;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,0BAA0B;CAC1B,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,oBAAoB;AACrB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,6BAA6B;AAC9B;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;CACC,aAAa;CACb,UAAU;AACX;;AAEA;CACC,gBAAgB;IACb,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;CACC,gBAAgB;IACb,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;CACC,2BAA2B;CAC3B,oCAAoC;CACpC,6BAA6B;AAC9B;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;;gCAE+B;AAChC;;AAEA;CACC,uBAAuB;CACvB,gCAAgC;CAChC,gBAAgB;CAChB,2BAA2B;;;CAG3B,gBAAgB;KACZ,iBAAiB;EACpB,gBAAgB;AAClB;;AAEA;CACC,mBAAmB;CACnB,oCAAoC;CACpC,4BAA4B;CAC5B,oBAAoB;AACrB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,0BAA0B;CAC1B,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,oCAAoC;CACpC,0BAA0B;CAC1B,oBAAoB;AACrB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,0BAA0B;CAC1B,eAAe;AAChB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,yBAAyB;CACzB,oBAAoB;AACrB;;AAEA;CACC,iBAAiB;CACjB,aAAa;AACd;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,4BAA4B;IACzB,8BAA8B;AAClC;;AAEA;CACC,mBAAmB;CACnB,kCAAkC;CAClC,2BAA2B;CAC3B,UAAU;CACV,oBAAoB;AACrB;;AAEA;CACC,2BAA2B;CAC3B,eAAe;CACf,kBAAkB;CAClB,8IAA8I;CAC9I,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;CAC9B,0BAA0B;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;CACC,eAAe;;CAEf,uBAAuB;CACvB,8BAA8B;;IAE3B,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;;CAErB,gBAAgB;AACjB;;AAEA;CACC,eAAe;;CAEf,aAAa;CACb,qBAAqB;;IAElB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;;CAErB,gBAAgB;AACjB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,oCAAoC;AACrC;AACA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;CACC;;;EAGC;;CAED,0IAA0I;CAC1I,iBAAiB;;CAEjB,SAAS;CACT,UAAU;;CAEV,uBAAuB;CACvB,WAAW;CACX,gBAAgB;CAChB,kBAAkB;;CAElB,oBAAoB;CACpB,wBAAwB;CACxB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,WAAW;EACV;EACA;CACD,qBAAqB;CACrB,kDAAkD;EACjD;EACA;CACD,8BAA8B;EAC7B;EACA;CACD,qCAAqC;CACrC,kBAAkB;CAClB,oCAAoC;EACnC;;EAEA;CACD,iCAAiC;CACjC,kBAAkB;CAClB,oCAAoC;EACnC;;AAEF;CACC,aAAa;AACd;;AAEA;CACC;;;EAGC;CACD,yBAAyB;CACzB,YAAY;CACZ,sBAAsB;CACtB,WAAW;CACX,YAAY;CACZ,MAAM;AACP;;AAEA;CACC,UAAU;CACV,cAAc;CACd,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,kCAAkC;AACnC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;;AAEA;;CAEC,yDAAiD;CACjD,wBAAwB;CACxB,4BAA4B;CAC5B,2BAA2B;CAC3B,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,0DAA0D;CAC1D,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,YAAY;;CAEZ;;;;;;KAMI;AACL;;AAEA;CACC,gCAAgC;CAChC,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,gGAAgG;AACjG;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gCAAgC;CAChC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,wBAAwB;CACxB,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,uBAAuB;CACvB,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,SAAS;CACT,UAAU;;CAEV,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,iBAAiB;;AAElB;;AAEA;CACC,SAAS;CACT,aAAa;CACb,gBAAgB;;CAEhB,kBAAkB;;;CAGlB,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,0BAA0B;CAC1B,uBAAuB;CACvB,8BAA8B;CAC9B,kBAAkB;;CAElB,cAAc;CACd,mBAAmB;;CAEnB,oBAAoB;;CAEpB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,qBAAqB;CACrB,kBAAkB;CAClB,mBAAmB;CACnB,0BAA0B;CAC1B,uBAAuB;CACvB,8BAA8B;CAC9B,kBAAkB;CAClB,+BAA+B;CAC/B,cAAc;CACd,kBAAkB;CAClB,kBAAkB;;;AAGnB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,6BAA6B;IAC7B,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,WAAW;IACX,mBAAmB;EACrB;;;AAGF;CACC,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,qBAAqB;;CAErB,kBAAkB;CAClB,mBAAmB;CACnB,0BAA0B;CAC1B,uBAAuB;CACvB,8BAA8B;CAC9B,kBAAkB;;CAElB,cAAc;CACd,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,qBAAqB;;CAErB,kBAAkB;CAClB,mBAAmB;CACnB,0BAA0B;CAC1B,uBAAuB;CACvB,oBAAoB;CACpB,kBAAkB;;CAElB,cAAc;CACd,wBAAwB;CACxB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,qBAAqB;;CAErB,kBAAkB;CAClB,mBAAmB;CACnB,0BAA0B;CAC1B,sBAAsB;CACtB,8BAA8B;CAC9B,kBAAkB;;CAElB;;sBAEqB;AACtB;;;AAGA;;CAEC,iBAAiB;CACjB,WAAW;CACX,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,mIAAmI;CACnI,8BAA8B;CAC9B,kBAAkB;CAClB,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,2IAA2I;CAC3I,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,yIAAyI;CACzI,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,yIAAyI;CACzI,eAAe;CACf,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2IAA2I;AAC5I;;AAEA;CACC,cAAc;CACd,WAAW;CACX,gCAAgC;CAChC,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,kBAAkB;;CAElB,yIAAyI;CACzI,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,kBAAkB;;CAElB,yIAAyI;CACzI,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,kBAAkB;;CAElB,yIAAyI;CACzI,gBAAgB;AACjB;;AAEA;CACC,eAAe;;CAEf,yIAAyI;;AAE1I;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,eAAe;CACf,8BAA8B;AAC/B;;AAEA;CACC,eAAe;CACf,4BAA4B;CAC5B,cAAc;CACd,2IAA2I;AAC5I;;AAEA;CACC,eAAe;CACf,4BAA4B;CAC5B,cAAc;CACd,yIAAyI;AAC1I;;AAEA;CACC,eAAe;CACf,gBAAgB;;CAEhB,yIAAyI;CACzI,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,kBAAkB;;CAElB,yIAAyI;CACzI,iBAAiB;CACjB,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,kBAAkB;;CAElB,2IAA2I;CAC3I,iBAAiB;CACjB,kCAAkC;AACnC;;AAEA;CACC,eAAe;CACf,kBAAkB;;CAElB,2IAA2I;CAC3I,gBAAgB;CAChB,kCAAkC;AACnC;;AAEA;CACC,eAAe;CACf,kBAAkB;;CAElB,2IAA2I;CAC3I,iBAAiB;CACjB,kCAAkC;AACnC;;AAEA;CACC,eAAe;CACf,kBAAkB;;CAElB,yIAAyI;CACzI,iBAAiB;;CAEjB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,8BAA8B;CAC9B,6BAA6B;CAC7B,uBAAuB;CACvB,YAAY;;CAEZ,0BAA0B;;CAE1B,yIAAyI;CACzI,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,8BAA8B;CAC9B,6BAA6B;CAC7B,uBAAuB;CACvB,YAAY;;CAEZ,0BAA0B;;CAE1B,yIAAyI;CACzI,iBAAiB;;CAEjB,qBAAqB;CACrB,sBAAsB;CACtB,4BAA4B;CAC5B,6BAA6B;CAC7B,iCAAiC;CACjC,0BAA0B;CAC1B,2BAA2B;AAC5B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,8BAA8B;CAC9B,6BAA6B;CAC7B,uBAAuB;CACvB,YAAY;;CAEZ,0BAA0B;;CAE1B,yIAAyI;CACzI,iBAAiB;;CAEjB,0CAA0C;AAC3C;;;AAGA;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,YAAY;CACZ,0BAA0B;CAC1B,sBAAsB;CACtB,2BAA2B;CAC3B,qBAAqB;CACrB,oBAAoB;AACrB;;AAEA;;CAEC,UAAU;CACV,YAAY;CACZ,0BAA0B;CAC1B,sBAAsB;CACtB,kBAAkB;;CAElB,oBAAoB;CACpB,kBAAkB;;CAElB,qBAAqB;CACrB,oBAAoB;AACrB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,gCAAgC;CAChC,sBAAsB;CACtB,kBAAkB;;CAElB,gBAAgB;CAChB,kBAAkB;;CAElB,qBAAqB;CACrB,oBAAoB;AACrB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,gCAAgC;CAChC,sBAAsB;CACtB,kBAAkB;;CAElB,gBAAgB;CAChB,kBAAkB;;CAElB,qBAAqB;CACrB,oBAAoB;AACrB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,gCAAgC;CAChC,sBAAsB;CACtB,kBAAkB;;CAElB,gBAAgB;CAChB,kBAAkB;;CAElB,qBAAqB;CACrB,oBAAoB;AACrB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,0BAA0B;CAC1B,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;;CAElB,cAAc;CACd,kBAAkB;;CAElB,qBAAqB;CACrB,oBAAoB;AACrB;;;AAGA;CACC,UAAU;CACV,YAAY;CACZ,0BAA0B;CAC1B,sBAAsB;CACtB,8BAA8B;CAC9B,kBAAkB;;CAElB,cAAc;CACd,gBAAgB;;CAEhB,qBAAqB;CACrB,oBAAoB;AACrB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,0BAA0B;CAC1B,sBAAsB;CACtB,kBAAkB;;CAElB,cAAc;CACd,kBAAkB;;CAElB,qBAAqB;CACrB,oBAAoB;AACrB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,2BAA2B;CAC3B,uBAAuB;;CAEvB,cAAc;CACd,kBAAkB;;CAElB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,8BAA8B;CAC9B,kBAAkB;;CAElB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,8BAA8B;CAC9B,kBAAkB;;CAElB,gBAAgB;CAChB,qBAAqB;AACtB;;;;AAIA;CACC,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,yBAAyB;AAC1B;;AAEA;CACC,sCAAsC;CACtC,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;;AAGA;;;CAGC,UAAU;CACV,yBAAyB;AAC1B;;AAEA;;;CAGC,sCAAsC;CACtC,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;;;CAGC,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;;;CAGC,kBAAkB;AACnB;;AAEA;;;CAGC,YAAY;AACb;;AAEA;;;CAGC,YAAY;AACb;;;AAGA;CACC,UAAU;CACV,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,sCAAsC;CACtC,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,UAAU;CACV,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,sCAAsC;CACtC,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;;;;AAKA;CACC,UAAU;CACV,yBAAyB;AAC1B;;AAEA;CACC,sCAAsC;CACtC,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;AAChB;;;;AAIA;CACC,WAAW;CACX,cAAc;AACf;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,0BAA0B;CAC1B,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,UAAU;CACV,WAAW;;CAEX,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,gCAAgC;AACjC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;;AAGA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;;CAEhB,gBAAgB;CAChB,iBAAiB;;CAEjB,UAAU;CACV,8BAA8B;CAC9B,aAAa;CACb,sBAAsB;CACtB,gCAAgC;AACjC;;AAEA;CACC,cAAc;CACd,UAAU;CACV,aAAa;AACd;;AAEA;CACC;;;;;qBAKoB;CACpB,4BAA4B;CAC5B,6BAA6B;CAC7B,8BAA8B;CAC9B,+BAA+B;AAChC;;;;AAIA;CACC,oBAAoB;CACpB,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;;;CAGlB,YAAY;CACZ,aAAa;;CAEb,qBAAqB;CACrB,8BAA8B;CAC9B,aAAa;CACb,sBAAsB;CACtB,gCAAgC;CAChC,6BAA6B;;AAE9B;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;;CAEvB,YAAY;CACZ,aAAa;;CAEb,qBAAqB;;CAErB,yBAAyB;;AAE1B;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,sBAAsB;CACtB,uBAAuB;;CAEvB,OAAO;CACP,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,iCAAiC;CACjC,yBAAyB;CACzB,UAAU;CACV,yBAAyB;CACzB,0BAA0B;CAC1B,gCAAgC;CAChC,sBAAsB;CACtB,uBAAuB;CACvB,4BAA4B;CAC5B,6BAA6B;;CAE7B,mCAAmC;AACpC;;AAEA;;;;;;;CAOC;AACD;CACC,mCAAmC;CACnC,+BAA+B;CAC/B,kBAAkB;CAClB,uBAAuB;;CAEvB;;;;6CAI4C;AAC7C;;AAEA;CACC,mCAAmC;CACnC,yBAAyB;CACzB,yBAAyB;CACzB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,uCAAuC;CACvC,yBAAyB;CACzB,UAAU;CACV,yBAAyB;CACzB,uBAAuB;CACvB,gCAAgC;CAChC,sBAAsB;CACtB,uBAAuB;CACvB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,mCAAmC;AACpC;;AAEA;;EAEE;;;;;AAKF;CACC,kBAAkB;CAClB,sBAAsB;CACtB,uBAAuB;CACvB,wBAAwB;;CAExB,sBAAsB;CACtB,uBAAuB;CACvB,sBAAsB;CACtB,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,uBAAuB;CACvB,sBAAsB;;CAEtB,sBAAsB;CACtB,uBAAuB;CACvB,yBAAyB;CACzB,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,uBAAuB;CACvB,sBAAsB;;CAEtB,sBAAsB;CACtB,uBAAuB;CACvB,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,sBAAsB;CACtB,uBAAuB;CACvB,gBAAgB;CAChB,YAAY;CACZ,MAAM;CACN,yBAAyB;CACzB,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,sBAAsB;CACtB,uBAAuB;CACvB,aAAa;CACb,MAAM;CACN,uBAAuB;CACvB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;;;CAGC,kBAAkB;CAClB,YAAY;CACZ,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,0BAA0B;CAC1B,0IAA0I;;AAE3I;;;AAGA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,gBAAgB;CAChB,0BAA0B;CAC1B,0IAA0I;;AAE3I;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,sBAAsB;CACtB,uBAAuB;CACvB,2BAA2B;CAC3B,SAAS;CACT,uBAAuB;;CAEvB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,sBAAsB;CACtB,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,WAAW;CACX,eAAe;CACf,6BAA6B;AAC9B;;AAEA,mBAAmB;;AAEnB;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,uBAAuB;CACvB,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA,sEAAsE;AACtE;CACC,aAAa;CACb,2BAA2B;CAC3B,qBAAqB;AACtB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,kCAAkC;CAClC,2BAA2B;CAC3B,UAAU;CACV,oBAAoB;AACrB;;AAEA;;CAEC,mBAAmB;CACnB,kCAAkC;CAClC;;kBAEiB;CACjB,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,uBAAuB;CACvB,kCAAkC;CAClC,cAAc;CACd,UAAU;AACX;;AAEA;CACC,uBAAuB;CACvB,kCAAkC;CAClC,cAAc;CACd,UAAU;AACX;;AAEA;CACC,mBAAmB;CACnB,kCAAkC;CAClC,WAAW;CACX;kBACiB;CACjB,sBAAsB;CACtB,gBAAgB;CAChB,cAAc;CACd,UAAU;CACV,cAAc;AACf;;AAEA;CACC,WAAW;CACX,eAAe;CACf,uBAAuB;CACvB,qBAAqB;CACrB,6BAA6B;AAC9B;;AAEA;CACC,WAAW;CACX,eAAe;CACf,uBAAuB;CACvB,qBAAqB;CACrB,6BAA6B;CAC7B,kBAAkB;AACnB;;AAEA,mBAAmB;;AAEnB;;CAEC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,WAAW;CACX,eAAe;CACf,oBAAoB;CACpB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,0BAA0B;CAC1B,cAAc;AACf;;AAEA;CACC,kCAAkC;CAClC,SAAS;CACT,iBAAiB;CACjB,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,kCAAkC;CAClC,SAAS;CACT,iBAAiB;CACjB,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,kCAAkC;CAClC,SAAS;CACT,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,uBAAuB;CACvB,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,oBAAoB;CACpB,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;;;CAGC,kCAAkC;CAClC,mBAAmB;;CAEnB,cAAc;CACd,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,qBAAqB;AACtB;;AAEA;;;;;;CAMC,kCAAkC;CAClC,mBAAmB;;CAEnB,cAAc;CACd,UAAU;CACV,cAAc;AACf;;AAEA;;;;;;;;;;;CAWC,kCAAkC;CAClC,mBAAmB;;CAEnB,cAAc;CACd,UAAU;CACV,cAAc;AACf;;AAEA;;;;;CAKC,kCAAkC;CAClC,mBAAmB;;CAEnB,cAAc;CACd,UAAU;CACV,cAAc;AACf;;AAEA;;;CAGC,kCAAkC;CAClC,mBAAmB;;CAEnB,cAAc;CACd,UAAU;CACV,cAAc;AACf;;AAEA;;;;;;;;;;;;;;CAcC,kCAAkC;CAClC,mBAAmB;;CAEnB,cAAc;CACd,UAAU;CACV,cAAc;AACf;;AAEA;;CAEC,kBAAkB;CAClB,8BAA8B;AAC/B;;;AAGA;CACC,2CAA2C;CAG3C,wCAAwC;;CAExC,8BAA8B;CAC9B,uBAAuB;AACxB;;AAEA;CACC,yCAAyC;CAGzC,sCAAsC;;CAEtC,8BAA8B;CAC9B,uBAAuB;AACxB;;AAEA;CACC,yIAAyI;CACzI,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf,8BAA8B;AAC/B;;AAEA;CACC,yIAAyI;CACzI,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;CACf,8BAA8B;AAC/B;;AAEA;CACC,yIAAyI;CACzI,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,8BAA8B;AAC/B;;;;AAIA;CACC,yIAAyI;CACzI,iBAAiB;;CAEjB,gBAAgB;CAChB,mBAAmB;;AAEpB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,0IAA0I;CAC1I,eAAe;CACf,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,6CAA6C;CAC7C,eAAe;CACf,cAAc;AACf;;AAEA;CACC,+BAA+B;CAC/B,kCAAkC;CAClC,4BAA4B;CAC5B,6BAA6B;CAC7B,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;CAC/B,kCAAkC;CAClC,4BAA4B;CAC5B,6BAA6B;CAC7B,8BAA8B;CAC9B,qBAAqB;CACrB,6BAA6B;CAC7B,gBAAgB;;AAEjB;;AAEA,6BAA6B;AAC7B;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmFG;;AAEH;CACC,0BAA0B;CAC1B,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,0GAA0G;CAC1G,gBAAgB;AACjB;;AAEA;;CAEC,uBAAuB;CACvB,uBAAuB;CACvB,0BAA0B;AAC3B;;AAEA;;CAEC,eAAe;CACf,uBAAuB;AACxB;;;AAGA,aAAa;AACb,mBAAmB;;AAEnB;CACC,eAAe;CACf,kBAAkB;;CAElB,yIAAyI;CACzI,iBAAiB;CACjB,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,2BAA2B;CAC3B,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;CAC3B,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;AACvB;;AAEA;CACC,eAAe;IACZ,wBAAwB;IACxB,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;CACC,sBAAsB;CACtB,sBAAsB;CACtB,gCAAgC;CAChC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;IACZ,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;CACC,4BAA4B;CAC5B,yBAAyB;CACzB,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,uCAAuC;CACvC,gBAAgB;IACb,YAAY;CACf,qBAAqB;IAClB,WAAW;AACf;;AAEA;CACC,kBAAkB;CAClB,iCAAiC;CACjC,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;CACvB,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;CACvB,sBAAsB;AACvB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;CAC5B,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;CAC5B,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,8BAA8B;CAC9B,6BAA6B;CAC7B,uBAAuB;CACvB,YAAY;;CAEZ,0BAA0B;;CAE1B,yIAAyI;CACzI,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,qBAAqB;AACtB;;AAEA;;EAEE;;AAEF;CACC,iCAAiC;AAClC;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;AACxB;;;AAGA;CACC,0BAA0B;CAC1B,gBAAgB;AACjB;;;AAGA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,6BAA6B;CAC7B,2BAA2B;CAC3B,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;CAC7B,2BAA2B;CAC3B,6BAA6B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,4BAA4B;CAC5B,wBAAwB;CACxB,0BAA0B;CAC1B,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;CAC3B,uBAAuB;CACvB,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,aAAa;CACb,cAAc;AACf;;AAEA;;;GAGG;;AAEH,kBAAkB;AAClB;CACC,WAAW;CACX,mBAAmB;CACnB,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,sBAAsB;CACtB;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;;GAEG;AACH;;;GAGG;;AAEH;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC,cAAc;CACd,WAAW;CACX,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;GAEG;;AAEH;CACC,oBAAoB;CACpB;AACD;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;CACC,YAAY;CACZ,iBAAiB;CACjB,gBAAgB;CAChB,MAAM,EAAE,mDAAmD;CAC3D,mDAAmD;AACpD;AACA;CACC,kBAAkB;AACnB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAsEI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;IAEI,aAAa;IAEb,YAAY;IACZ;AACJ;;AAEA;IAEI,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IAEI,mBAAmB;IACnB;AACJ;;AAEA;IAEI,oBAAoB;IACpB;AACJ;;AAEA;IAEI,aAAa;IACb;AACJ;;AAEA;IAEI,oBAAoB;IACpB;AACJ;;AAEA;IAEI,oBAAoB;IACpB;AACJ;;AAEA;IAEI,aAAa;IACb;AACJ;;AAEA;IAEI,oBAAoB;IACpB;AACJ;;AAEA;IAEI,oBAAoB;IACpB;AACJ;;AAEA;IAEI,aAAa;IACb;AACJ;;AAEA;IAEI,oBAAoB;IACpB;AACJ;;AAEA;IAEI,oBAAoB;IACpB;AACJ;;AAEA;IAEI,cAAc;IACd;AACJ;;AAEA;CACC,aAAa;CACb,WAAW;CACX,mBAAmB;CACnB,8BAA8B;AAC/B;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,YAAY;CACZ,mBAAmB;CACnB,wCAAwC;AACzC;;AAEA;CACC,gCAAgC;CAChC,wCAAwC;;;CAGxC,yCAAyC;IACtC,2BAA2B;IAC3B,2BAA2B;;IAE3B,uBAAuB;CAC1B,kBAAkB;AACnB;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;CACC,gCAAgC;CAChC,wCAAwC;CACxC,uBAAuB;AACxB;;;AAGA,sBAAsB;AACtB;CACC,gBAAgB;CAChB,WAAW;CACX,8BAA8B;CAC9B,6BAA6B;CAC7B,sBAAsB;IACnB,YAAY;;IAEZ,0BAA0B;;CAE7B,yIAAyI;CACzI,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,YAAY;IACT,oBAAoB;CACvB,kBAAkB;AACnB;EACE;CACD,YAAY;EACX;;EAEA;CACD,YAAY;EACX;;EAEA;CACD,YAAY;EACX;;EAEA;CACD,YAAY;EACX;;EAEA;CACD,YAAY;EACX;;EAEA;CACD,YAAY;EACX;;EAEA;CACD,YAAY;EACX;;EAEA;CACD,YAAY;EACX;;EAEA;CACD,YAAY;EACX;;EAEA;CACD,aAAa;EACZ;;EAEA;CACD,aAAa;EACZ;;EAEA;CACD,aAAa;EACZ;;EAEA;CACD,gBAAgB;EACf;;EAEA;CACD,kBAAkB;EACjB;;EAEA;CACD,mBAAmB;EAClB;;EAEA;CACD,iBAAiB;EAChB;;EAEA;CACD,gBAAgB;EACf;;EAEA;CACD,kBAAkB;EACjB;;EAEA;CACD,mBAAmB;EAClB;;EAEA;CACD,iBAAiB;EAChB;;EAEA;CACD,gBAAgB;EACf;;EAEA;CACD,kBAAkB;EACjB;;EAEA;CACD,mBAAmB;EAClB;;EAEA;CACD,iBAAiB;EAChB;;EAEA;CACD,gBAAgB;EACf;;EAEA;CACD,kBAAkB;EACjB;;EAEA;CACD,mBAAmB;EAClB;;EAEA;CACD,iBAAiB;EAChB;;EAEA;CACD,gBAAgB;EACf;;EAEA;CACD,kBAAkB;EACjB;;EAEA;CACD,mBAAmB;EAClB;;EAEA;CACD,iBAAiB;EAChB;;EAEA;CACD,gBAAgB;EACf;;EAEA;CACD,kBAAkB;EACjB;;EAEA;CACD,mBAAmB;EAClB;;EAEA;CACD,iBAAiB;EAChB;;EAEA;CACD,gBAAgB;EACf;;EAEA;CACD,kBAAkB;EACjB;;EAEA;CACD,mBAAmB;EAClB;;EAEA;CACD,iBAAiB;EAChB;;EAEA;CACD,gBAAgB;EACf;;EAEA;CACD,kBAAkB;EACjB;;EAEA;CACD,mBAAmB;EAClB;;EAEA;CACD,iBAAiB;EAChB;;EAEA;CACD,gBAAgB;EACf;;EAEA;CACD,kBAAkB;EACjB;;EAEA;CACD,mBAAmB;EAClB;;EAEA;CACD,iBAAiB;EAChB;;EAEA;CACD,iBAAiB;EAChB;;EAEA;CACD,mBAAmB;EAClB;;EAEA;CACD,oBAAoB;EACnB;;EAEA;CACD,kBAAkB;EACjB;;EAEA;CACD,iBAAiB;EAChB;;EAEA;CACD,mBAAmB;EAClB;;EAEA;CACD,oBAAoB;EACnB;;EAEA;CACD,kBAAkB;EACjB;;EAEA;CACD,iBAAiB;EAChB;;EAEA;CACD,mBAAmB;EAClB;;EAEA;CACD,oBAAoB;EACnB;;EAEA;CACD,kBAAkB;EACjB","sourcesContent":["html {\n\theight: 100%;\n\t--scrollbarBG: #008FF1;\n\t--thumbBG: #0A313F;\n}\n\n\nbody {\n\tmargin: 0;\n\tpadding: 0;\n\n\toverflow: hidden;\n\theight: 100%;\n\n}\n\n@font-face {\n\tfont-family: 'GothamNarrow-Thin';\n\t/*src: url(../font/nucleus/GothamNarrow-Thin.otf); */\n\tsrc: url(https://s3-us-west-2.amazonaws.com/nucleuscare/font/nucleus/GothamNarrow-Thin.otf);\n}\n\n@font-face {\n\tfont-family: 'GothamNarrow-Light';\n\t/*src: url(../font/nucleus/GothamNarrow-Light.otf); */\n\tsrc: url(https://s3-us-west-2.amazonaws.com/nucleuscare/font/nucleus/GothamNarrow-Light.otf);\n}\n\n@font-face {\n\tfont-family: 'GothamNarrow-Medium';\n\t/*src: url(../font/nucleus/GothamNarrow-Medium.otf); */\n\tsrc: url(https://s3-us-west-2.amazonaws.com/nucleuscare/font/nucleus/GothamNarrow-Medium.otf);\n}\n\n@font-face {\n\tfont-family: 'GothamNarrow-Book';\n\t/*src: url(../font/nucleus/GothamNarrow-Book.otf); */\n\tsrc: url(https://s3-us-west-2.amazonaws.com/nucleuscare/font/nucleus/GothamNarrow-Book.otf);\n}\n\n@font-face {\n\tfont-family: 'Barlow';\n\tsrc: url('../font/Barlow/Barlow-SemiBold.ttf') format('truetype');\n}\n\n\n.sideBarFont {\n\tfont-family: 'Barlow';\n\tfont-size: 14px;\n}\n\n.main {\n\n\tmargin: 0;\n\tpadding: 0;\n\theight: 100%;\n}\n\n.nucleus-main-content {\n\tmargin: 0;\n\tpadding: 0;\n\toverflow: hidden;\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\n}\n\n.alto {\n\theight: 100%;\n}\n\n.altoImportant {\n\tpadding: 0px;\n\tmin-height: 80%;\n\theight: 100% !important;\n\tborder: 2px none purple;\n}\n\n.altoImportantStaff {\n\theight: 90% !important;\n}\n\n.altoImportantContainer {\n\tpadding: 0px;\n\tmin-height: 80%;\n\theight: 90%;\n\tmax-height: 90%;\n\tborder: 2px none purple;\n\n\n}\n\n.profile-header-body{\n\tbackground-color: white;\n\tmargin-bottom: 0px;\n\tbox-shadow: 2px 0px #d5d5d5;\n\tcolor:#09303f;\n\tmin-width: 720px;\n}\n\n.profile-header-bottom {\n\tbackground-color: white;\n    border-radius: 0px 0px 15px 15px;\n    box-shadow: 2px 2px #d5d5d5;\n    color: #09303f;\n    min-width: 720px\n}\n\n.bottom-border-menu {\n    border-bottom: 4px solid #B3C6D4;\n    padding-bottom: 5px;\n    color: #0F2B3A;\n}\n\n.staffSubTab {\n\tborder-bottom: 4px solid #2A97FF;\n    padding-bottom: 9px;\n}\n\n.padding-15 {\n    padding: 15px;\n}\n\n.selectStyle .css-1hwfws3 {\n    height: 33px;\n}\n\n.css-1hwfws3 {\n    -webkit-box-align: center;\n    align-items: center;\n    display: flex;\n    flex: 1 1 0%;\n    flex-wrap: wrap;\n    padding: 2px 8px;\n    position: relative;\n    overflow: hidden;\n    box-sizing: border-box;\n}\n\n.nucleus-input-mdm {\n\t/* width: 10% !important; */\n\tmax-width: 220px;\n\tmin-width: 120px;\n    margin-left: 2rem !important;\n}\n\n.selectContainer {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.checkboxContainer {\n\tdisplay: flex;\n\twidth: 22.5%;\n    justify-content: space-between;\n}\n\n.networkCheckboxSpace {\n\tmargin-left: 5rem;\n}\n\n.nucleusSearchInputContainer {\n\tdisplay: flex;\n\tflex-direction: row;\n\twidth: 24%;\n}\n\n.nucleusSearchInput {\n\tmargin-left: 1rem !important;\n\tmargin-right: 1rem !important;\n}\n\n.nucleus-input-form-small {\n    text-align: left !important; \n    color: #000; \n    padding-bottom: 0px !important; \n    margin-bottom: 4px !important; \n    border: 3px solid black; \n    height: 19px; \n    font-size: 15px !important; \n    font-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif; \n    font-size: larger; \n    width: 50% !important; \n    text-align: center; \n}\n\n.pdl-0 {\n\tpadding: 0 0 !important;\n}\n\n.staffTabs1 {\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: large;\n\tfont-weight: bolder;\n\tfont-size: 19px !important;\n\tcolor: black;\n\ttext-transform: none !important;\n\tpadding-left: 10px;\n\tpadding-right: 10px;\n\t\n}\n\n.staffTabs2 {\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: large;\n\tfont-weight: bolder;\n\tfont-size: 19px !important;\n\tcolor: black;\n\ttext-transform: none !important;\n\tpadding-left: 10px;\n\tpadding-right: 10px;\n\tmargin-left: 20px;\n\tline-height: 40px;\n}\n\n.nucleusTabContainer{\n\t/* white-space: nowrap; */\n\tline-height: 40px;\n}\n.nucleusTabText{\n\t/* white-space: nowrap; */\n\tdisplay: inline-flex;\n}\n\n.staffTabs {\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: large;\n\tfont-weight: bolder;\n\tfont-size: 19px !important;\n\tcolor: #0A313F;\n\ttext-transform: none !important;\n\theight: 40px;\n\tmargin-left: 10px;\n\tmargin-right: 10px;\n}\n\n.staffTabsMain {\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: large;\n\tfont-weight: bolder;\n\tfont-size: 24px !important;\n\tcolor: #0A313F;\n\ttext-transform: none !important;\n\theight: 40px;\n\tmargin-left: 10px;\n\tmargin-right: 10px;\n}\n\n.mdm-tabs-container {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 16px;\n\tjustify-content: flex-start;\n}\n\n.mdm-main-tabs-container {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 16px;\n\tjustify-content: flex-start;\n\tjustify-content: space-around;\n    width: 40%;\n}\n\n.mdm-tab {\n\tcursor: pointer;\n}\n\n.nucleus-btn-center {\n\tdisplay: flex;\n\tjustify-content: center;\n}\n\n.profile-header-btn1 {\n    box-shadow: 1px 1px #666666;\n    text-align: center;\n    padding: 3px 19px 2px;\n    border: 1px solid gray;\n    border-radius: 4px;\n}\n\n.staffTab {\n\tpadding-bottom: 3px;\n\tborder-bottom: 3px solid #2A97FF;\n}\n\n.staffTabMain {\n\tpadding-bottom: 3px;\n\tborder-bottom: 3px solid #FFCA20;\n}\n\n.mdmPolicyFooterContainer {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tborder-top:  3px solid #B4C6D3;\n\tpadding: 1%;\n\tmargin-top: 21%;\n}\n\n.kioskAppContainer {\n\tdisplay: flex;\n    flex-direction: row;\n    align-items: center;\n\twidth: 50%;\n    justify-content: space-between;\n}\n\n.kioskAppContainerNew {\n\tdisplay: flex;\n    flex-direction: row;\n    align-items: center;\n\twidth: 70%;\n    justify-content: space-between;\n}\n\n.kioskAppWarningTxt {\n\tfont-size: 16px;\n\tcolor: #0A313F;\n\tfont-weight: bold;\n}\n\n.kioskAppLine {\n\twidth: 100%;\n\tborder: 1px solid #B4C6D3;\n\tmargin-top: 1%;\n    margin-bottom: 5%;\n}\n\n.mdmPolicyFooterButtonContainer {\n\tdisplay: flex;\n\tflex-direction: row;\n}\n\n.mdmText {\n\tfont-size: 16px;\n\tcolor: #0A313F;\n}\n\n.mdmTextLg {\n\tfont-size: 24px;\n\tcolor: #0A313F;\n}\n\n.screenPluggedContainer {\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: space-between;\n    width: 32%;\n}\n\n.screenPluggedCheckBoxContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.kioskWarning {\n\tcolor: #FE3824;\n\tfont-weight: bold;\n\tfont-size: 60px;\n}\n\n.kioskTxt {\n\tfont-size: 20px;\n\tcolor: #0A313F;\n}\n\n.kioskContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.screenCounterContainer {\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: space-between;\n    width: 32%;\n}\n\n.counterContainer {\n\tdisplay: flex;\n\tflex-direction: row;\n}\n\n.ancho {\n\twidth: 100%;\n}\n\n.txt-black {\n\tcolor: #000;\n}\n\n.txt-white {\n\tcolor: #FFFFFF;\n}\n\n.txt-red {\n\tcolor: #FE3824;\n}\n\n.txt-green {\n\tcolor: #6dbe73;\n}\n\n.txt-special-color {\n\tcolor: #052F3E;\n}\n\n.nucleus-input-login {\n\ttext-align: center;\n\tcolor: #fff;\n}\n\n.text-center-align {\n\ttext-align: center !important;\n}\n\n.center-block {\n\tmargin-left: auto !important;\n\tmargin-right: auto !important;\n}\n\n.nucleus-input-login:focus {\n\tbox-shadow: none !important;\n}\n\n.nucleus-input-login2 {\n\ttext-align: center;\n\tcolor: #fff;\n\tbox-shadow: none !important;\n\tborder-bottom: 1px solid #2ba0fa !important;\n\theight: 2.5rem !important;\n}\n\n.nucleus-input-login2:focus {\n\tbox-shadow: none !important;\n\tborder-bottom: 1px solid #2ba0fa !important;\n}\n\n/* label color */\n.input-field label {\n\tcolor: #000;\n}\n\n.input-field {\n\tdisplay: flex;\n}\n\n/* label focus color */\n.input-field input[type=text]:focus+label {\n\tcolor: #000;\n}\n\n/* label underline focus color */\n.input-field input[type=email]:focus {\n\tborder-bottom: 1px none yellow;\n\tbox-shadow: 0 1px 0 0 yellow;\n}\n\n/* valid color \n   .input-field input[type=text].valid {\n     border-bottom: 1px solid #000;\n     box-shadow: 0 1px 0 0 #000;\n   }*/\n/* invalid color \n   .input-field input[type=text].invalid {\n     border-bottom: 1px solid #000;\n     box-shadow: 0 1px 0 0 #000;\n   }*/\n/* icon prefix focus color \n   .input-field .prefix.active {\n     color: #000;\n   }*/\n\n.no-margin {\n\tmargin: 0px !important;\n\tpadding: 0px !important;\n}\n\n.flex {\n\tdisplay: flex;\n}\n\n.devices-refresh {\n\tpadding: 3px;\n    margin-left: 10px;\n} \n\n.no-margin-left {\n\tmargin-left: 0px !important;\n\tpadding-left: 0px !important;\n}\n\n.no-margin-right {\n\tmargin-right: 0px !important;\n\tpadding-right: 0px !important;\n}\n\n.no-margin-bottom {\n\tmargin-bottom: 0px !important;\n}\n\n.nucleus-scroll {\n\toverflow: auto;\n\toverflow-y: scroll;\n\theight: 100% !important;\n}\n\n.nucleus-no-scroll {\n\toverflow: hidden;\n}\n\n.nucleus-font-8 {\n\tfont-size: 8px !important;\n}\n\n.nucleus-font-10 {\n\tfont-size: 10px !important;\n}\n\n.nucleus-font-11 {\n\tfont-size: 11px !important;\n}\n\n.nucleus-font-13 {\n\tfont-size: 13px !important;\n}\n\n.nucleus-font-14 {\n\tfont-size: 14px !important;\n}\n\n.nucleus-font-modal-btn {\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: medium;\n\tfont-weight: bold;\n\tfont-size: 16px;\n\n}\n\n/*MDM STYLES FOR MODAL */\n.darkBG {\n\tbackground-color: rgba(0, 0, 0, 0.3);\n\twidth: 100vw;\n\theight: 100vh;\n\tz-index: 0;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tposition: fixed;\n  }\n  \n  .centered {\n\tposition: fixed;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n  }\n\n  .addAppsCheckBox {\n\topacity: 1 !important;\n\tposition: inherit !important;\n  }\n\n.nucleusCard {\n\tdisplay: flex;\n\tbackground-color: #EBF2FE;\n\tborder-radius: 5px;\n\tbox-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.3);\n  }\n\n.nucleusCardFooterTxt {\n\tfont-size: 14px;\n\tcolor: #0A313F;\n}\n  .accountDetailsCardsContainer {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: space-evenly;\n  }\n  .mDMAccountDetailsNavBarContainer {\n\tdisplay: flex;\n\twidth: 100%;\n\tflex-direction: column;\n\tmargin-top: 3%;\n  }\n  .mDMAccountDetailsNavBarOptionsContainer {\n\twidth: 13%;\n    display: flex;\n    justify-content: space-between;\n  }\n  .mDMAccountDetailsNavBarTxt {\n\tfont-size: 18px;\n\tcolor: #0A313F;\n\tfont-weight: bold;\n\tcursor: pointer;\n  }\n  .mDMAccountDetailsNavBarTxtActive {\n\tborder-bottom: 1px solid #0092FF;\n  }\n  .mDMModal {\n\tdisplay: flex;\n\tmin-height: 400px;\n\tmin-width: 640px;\n\tbackground: white;\n\tborder-radius: 10px;\n\tz-index: 10;\n\tbox-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);\n  }\n\n  .mDMModalAddApps {\n\tdisplay: flex;\n\twidth: 795px;\n\tbackground: white;\n\tcolor: white;\n\tz-index: 10;\n\tbox-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);\n  }\n  \n  .modalHeader {\n\theight: 50px;\n\tbackground: white;\n\toverflow: hidden;\n\tborder-top-left-radius: 16px;\n\tborder-top-right-radius: 16px;\n  }\n  \n  .heading {\n\tmargin: 0;\n\tpadding: 10px;\n\tcolor: #2c3e50;\n\tfont-weight: 500;\n\tfont-size: 18px;\n\ttext-align: center;\n  }\n  \n  .modalContent {\n\tpadding: 10px;\n\tfont-size: 14px;\n\ttext-align: center;\n\tbackground-color: #E5E5E5;\n\tborder-radius: 10px;\n\twidth: 100%;\n  }\n  \n  .modalActions {\n\tmargin-bottom: 10px;\n\twidth: 100%;\n  }\n  \n  .actionsContainer {\n\tdisplay: flex;\n\tjustify-content: space-evenly;\n\talign-items: center;\n  }\n  \n  .closeBtn {\n\tcursor: pointer;\n\tfont-weight: 500;\n\tpadding: 4px 8px;\n\tborder-radius: 8px;\n\tborder: none;\n\tfont-size: 18px;\n\tcolor: #2c3e50;\n\tbackground: white;\n\ttransition: all 0.25s ease;\n\tbox-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.06);\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\talign-self: flex-end;\n\tmargin-top: -7px;\n\tmargin-right: -7px;\n  }\n  \n  .closeBtn:hover {\n\tbox-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);\n\ttransform: translate(-4px, 4px);\n  }\n  \n  .deleteBtn {\n\tmargin-top: 10px;\n\tcursor: pointer;\n\tfont-weight: 500;\n\twidth: 18%;\n\tpadding: 11px 28px;\n\tborder-radius: 50px;\n\tfont-size: 0.8rem;\n\tborder: #0A313F solid 1px ;\n\tcolor: #0A313F;\n\tbackground: #E5E5E5;\n\ttransition: all 0.25s ease;\n  }\n\n  .deleteBtnKiosk {\n\tmargin-top: 10px;\n\tcursor: pointer;\n\tfont-weight: 500;\n\twidth: 28%;\n\tpadding: 11px 28px;\n\tborder-radius: 50px;\n\tfont-size: 0.8rem;\n\tborder: #0A313F solid 1px ;\n\tcolor: #0A313F;\n\tbackground: #E5E5E5;\n\ttransition: all 0.25s ease;\n  }\n  \n  .deleteBtn:hover {\n\tbox-shadow: 0 10px 20px -10px rgba(93, 91, 215, 0.6);\n\ttransform: translateY(-5px);\n\tbackground: #E5E5E5;\n  }\n\n  .cancelBtnKiosk {\n\tmargin-top: 10px;\n\tcursor: pointer;\n\tfont-weight: 500;\n\twidth: 28%;\n\tpadding: 11px 28px;\n\tborder-radius: 50px;\n\tfont-size: 0.8rem;\n\tborder: #0A313F solid 1px;\n\tcolor: #ffffff;\n\tbackground: #0A313F;\n\ttransition: all 0.25s ease;\n  }\n  \n  .cancelBtn {\n\tmargin-top: 10px;\n\tcursor: pointer;\n\tfont-weight: 500;\n\twidth: 18%;\n\tpadding: 11px 28px;\n\tborder-radius: 50px;\n\tfont-size: 0.8rem;\n\tborder: #0A313F solid 1px;\n\tcolor: #ffffff;\n\tbackground: #0A313F;\n\ttransition: all 0.25s ease;\n  }\n  \n  .cancelBtn:hover {\n\tbox-shadow: none;\n\ttransform: none;\n\tbackground:#0A313F;\n  }\n  \n.mDMAddAppsContainer {\n\tdisplay: flex;\n\twidth: 100%;\n\theight: 500px;\n\tflex-direction: column;\n}\n\n.nucleusAppsModalSearchInputContainer {\n\twidth: 100%;\n\tdisplay: flex;\n}\n/*MDM STYLES FOR MODAL */\n\n\n.nucleus-font-small {\n\tfont-size: small;\n}\n\n.nucleus-font-medium {\n\tfont-size: medium;\n}\n\n.border {\n\tborder: 2px none black;\n}\n\n.bordered1 {\n\tborder: 1px solid red;\n}\n\n.nucleus-login {\n\tbackground-color: #008FFF;\n\tfont-family: GothamNarrow-Light, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', Geneva, sans-serif;\n\tfont-size: large;\n}\n\n.login-info {\n\tfont-size: medium;\n\n}\n\n.nucleus-token-btn {\n\tcolor: white !important;\n\tfont-size: 16px !important;\n\tfont-weight: normal !important;\n\tbackground-color: #124355;\n\tbox-shadow: 1px 1px #666666;\n\ttext-align: center;\n\tpadding: 3px 19px 2px;\n\tborder: 1px solid gray;\n\tborder-radius: 4px;\n}\n\n.new-nucleus-page-subtitle{\n\tfont-family: GothamNarrow-Medium, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: 18px;\n\tdisplay: inline;\n\n\tcolor :#0F2B3A;\n\n\tpadding-left: 3px;\n\tpadding-right: 3px;\n\tpadding-bottom: 2px;\n\tborder-bottom: 3px solid #FCCB00;\n\tmargin-bottom: 15px;\n}\n\n.devices-container {\n\tbackground-color: white;\n\tborder-radius: 15px 15px 15px 15px;\n\tbox-shadow: 2px 2px #d5d5d5;\n\n\tmargin-top: 12px;\n    padding-left: 8px;\n    padding-bottom: 25px;\n    padding-top: 6px;\n\n    min-width: 998px;\n\n}\n\n.patientSettings {\n\tbackground-color: white;\n\tborder-radius: 15px 15px 15px 15px;\n\tbox-shadow: 2px 2px #d5d5d5;\n\n\tmargin-top: 12px;\n    padding-bottom: 25px;\n    margin-bottom: 20px;\n\n    border:1px solid #d9d9d9;\n\n    min-width: 720px;\n}\n\n.tabSmallContainer{\n\tpadding-top: 9px;\n    display: inline-flex;\n    border-right: 1px solid #b4b4b4;\n    margin-bottom: -9px;\n\n}\n\n.staffTabsSmall2{\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: large;\n\tfont-weight: bold;\n\tfont-size: 17px !important;\n\tcolor: black ;\n\ttext-transform: none !important;\n\tpadding-bottom: 9px;\n\t    padding-left: 5px;\n    padding-right: 5px;\n\n    color :#0F2B3A !important;\n\n}\n\n\n.nucleus-unblock-api-btn {\n\tcolor: white !important;\n\tfont-size: 16px !important;\n\tfont-weight: normal !important;\n\tbackground-color: #124355;\n\tbox-shadow: 1px 1px #666666;\n\ttext-align: center;\n\tpadding: 3px 52px 2px;\n\tborder: 1px solid gray;\n\tborder-radius: 4px;\n\tcursor: pointer;\n}\n\n.nucleus-unblock-api-btn:disabled,\n.nucleus-unblock-api-btn[disabled] {\n\tbackground-color: rgba(181, 188, 191, 0.5);\n\tbox-shadow: 1px 1px #666666;\n\tpointer-events: none;\n}\n\n.nucleus-unblock-api-btn:hover {\n\tcursor: pointer;\n}\n\n.nucleus-bold {\n\tfont-weight: bolder;\n}\n\n/* .bold-text {\n\t\n\tfont-weight: bolder !important;\n\n} */\n\n.login-error {\n\t/* color:#cc0000; */\n\tcolor: #FFCA20;\n\tfont-family: GothamNarrow-Medium, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', Geneva, sans-serif;\n\tfont-size: large;\n}\n\n.forgot-style {\n\tmargin-top: -35px;\n}\n\n.nucleus-login-row {\n\tmargin-top: 0px !important;\n\tmargin-bottom: 0px !important;\n}\n\n.nucleus-submit-btn {\n\tborder-radius: 25px;\n\tbackground: #0A313F;\n\tpadding: 12px 50px 12px 50px;\n}\n\n.nucleus-submit-btn-tools {\n\tborder-radius: 25px;\n\tbackground: #0A313F;\n\tpadding: 8px 40px 8px 40px;\n\tdisplay: inline-flex;\n}\n\n.nucleus-submit-btn-tools:hover {\n\tcursor: pointer;\n\tdisplay: inline-flex;\n}\n\n.enterpriseFormTitleContainer {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.enterpriseFormTitleTxt {\n\tfont-size: 20px;\n\tcolor: #0A313F;\n}\n\n.enterpriseFormContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tpadding: 3%;\n}\n\n.mt-30 {\n\tmargin-top: 30%;\n}\n\n.enterpriseInputContainer {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: space-evenly;\n}\n\n.enterpriseModalLabelContainer {\n  display: flex;\n  width: 40%;\n}\n\n.enterpriseModalInputContainer {\n\tdisplay: flex;\n\twidth: 60%;\n} \n\n.deleteBtnEnterpriseModal {\n\tmargin-top: 10px;\n    cursor: pointer;\n    font-weight: 500;\n    width: 30%;\n    padding: 11px 28px;\n    border-radius: 50px;\n    font-size: 0.8rem;\n    border: #0A313F solid 1px;\n    color: #0A313F;\n    background: #E5E5E5;\n    transition: all 0.25s ease;\n}\n\n.cancelBtnEnterpriseModal {\n\tmargin-top: 10px;\n    cursor: pointer;\n    font-weight: 500;\n    width: 30%;\n    padding: 11px 28px;\n    border-radius: 50px;\n    font-size: 0.8rem;\n    border: #0A313F solid 1px;\n    color: #ffffff;\n    background: #0A313F;\n    transition: all 0.25s ease;\n}\n\n.enterpriseInput {\n\tmin-width: 200px !important;\n\tbackground-color: #FFFFFF !important;\n\tborder-radius: 5px !important;\n}\n\n.enterpriseInputTxt {\n\tcolor: #0A313F;\n\tfont-size: 18px;\n} \n\n.nucleus-submit-floating-btn {\n\t/*border-radius: 25px;\n    background: #0A313F;\n    padding: 1px 30px 1px 50px;*/\n}\n\n.toper-container {\n\tbackground-color: white;\n\tborder-radius: 15px 15px 0px 0px;\n\tpadding-top: 8px;\n\tbox-shadow: 2px 0px #d5d5d5;\n\n\t\n\tmin-width: 720px;\n\t    min-width: 1180px;\n\t\tmin-width: 720px;\n}\n\n.nucleus-submit-btn-disabled {\n\tborder-radius: 25px;\n\tbackground: rgba(181, 188, 191, 0.5);\n\tpadding: 12px 50px 12px 50px;\n\tpointer-events: none;\n}\n\n.nucleus-submit-btn:hover {\n\tcursor: pointer;\n}\n\n.nucleus-submit-btn-small {\n\tborder-radius: 25px;\n\tbackground: #0A313F;\n\tpadding: 5px 20px 5px 20px;\n\tcursor: pointer;\n}\n\n.nucleus-submit-btn-small-disabled {\n\tborder-radius: 25px;\n\tbackground: rgba(181, 188, 191, 0.5);\n\tpadding: 5px 20px 5px 20px;\n\tpointer-events: none;\n}\n\n.nucleus-submit-btn-small:hover {\n\tcursor: pointer;\n}\n\n.nucleus-api-token-btn-small {\n\tborder-radius: 5px;\n\tbackground: #929192;\n\tpadding: 5px 20px 5px 20px;\n\tcursor: pointer;\n}\n\n.dark-blue {\n\tcolor: #0A313F !important;\n}\n\n.border2 {\n\tborder: 1px solid red;\n}\n\n.border3 {\n\tborder: 1px solid blue;\n}\n\n.nucleus-link {\n\tcolor: #000000;\n}\n\n.nucleus-link-disabled {\n\topacity: .25;\n\t-moz-opacity: .25;\n\tfilter: alpha(opacity=25);\n\tpointer-events: none;\n}\n\n.new-page-title {\n\tfont-size: 2.5rem;\n\tcolor:#09303f;\n}\n\n.btn-add-new {\n\tmargin-left: -30px !important;\n}\n\n.nucleus-link:hover {\n\tcursor: pointer;\n\tfont-weight: bold;\n}\n\n.staffTabsMain:hover {\n\tcursor: pointer;\n\tfont-weight: bold;\n}\n\n.staffTabs:hover {\n\tcursor: pointer;\n\tfont-weight: bold;\n}\n\n\n.mt-10 {\n  margin-top: 10px;\n}\n\n.nucleus-link-light {\n\tcolor: #000;\n}\n\n.nucleus-link-light:hover {\n\tcursor: pointer;\n}\n\n.nucleus-link-red {\n\tcursor: pointer;\n\tcolor: #FE3824;\n}\n\n.nucleus-link-red:hover {\n\tcursor: pointer;\n\tcolor: #FE3824;\n}\n\n.nucleus-floating-btn  i {\n\tfont-size: 1.3rem !important;\n    line-height: 30.1px !important;\n}\n\n.modalScrollableWidth{\n\tbackground: #EBEBEB;\n\tborder-radius: 10px 10px 10px 10px;\n\tmin-width: 390px !important;\n\twidth: 65%;\n\tpadding-bottom: 10px;\n}\n\n.nucleus-font-label-title{\n\tfont-weight: 500 !important;\n\tfont-size: 14px;\n\tmargin-bottom: 5px;\n\t/*font-family: GothamNarrow-Light, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;*/\n\tfont-size: medium;\n}\n.patient-edit-title-container {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n}\n\n.profile-header-btn2{\n\tbox-shadow: 1px 1px #666666;\n    text-align: center;\n    padding: 3px 9px 2px;\n    border: 1px solid gray;\n    border-radius: 4px;\n}\n\n.a-little-right-11 {\n    padding-left: 11px !important;\n}\n\n.nucleus-floating-btn-mini {\n    width: 21px;\n    height: 21px;\n    line-height: 21px;\n}\n\n.nucleus-floating-btn-mini > i {\n    line-height: 0px !important;\n\tfont-size: 1rem !important;\n}\n\n.bottom-separated {\n    margin-top: 0px;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-bottom: 9px;\n}\n\n.patientConfigSelect {\n    margin-top: -5px;\n    min-width: 90% !important;\n    width: 95% !important;\n    height: 30px; \n}\n\n.selected-flag {\n    background-color: transparent !important;\n}\n\n.nucleus-link-button {\t\n\tcursor: pointer;\n\n\tcolor: rgb(9, 131, 206);\n\tborder-color: rgb(9, 131, 206);\n\t\n    border-width: 2px;\n    border-style: solid;\n    border-radius: 13px;\n    padding-right: 4px;\n\n\tfont-weight: 500;\n}\n\n.nucleus-link-button:hover {\n\tcursor: pointer;\n\n\tcolor:#0A313F;\n\tborder-color: #0A313F;\n\t\n    border-width: 2px;\n    border-style: solid;\n    border-radius: 13px;\n    padding-right: 4px;\n\n\tfont-weight: 500;\n}\n.nucleus-row {\n\tcursor: pointer;\n}\n.nucleus-clickable:hover {\n\tcursor: pointer;\n}\n.nucleus-floating-btn-icon-copy-to-cb {\n\tbackground-color: #03313E !important;\n}\n.nucleus-row-small {\n\tpadding-top: 15px;\n\tpadding-bottom: 15px;\n\tcursor: pointer;\n}\n\n.nucleus-row-small-top{\n\tpadding-top: 7px;\n\tpadding-bottom: 0px;\n    vertical-align: top;\n}\n\n.nucleus-floating-btn {\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    margin-bottom: 7px;\n}\n\n\n.nucleus-sidebar {\n\t/*\n\tmin-width: 40px;\n\tmax-width: 80px;\n\t*/\n\n\tfont-family: GothamNarrow-Light, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: medium;\n\n\tmargin: 0;\n\tpadding: 0;\n\n\theight: 100% !important;\n\twidth: 100%;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\n\tdisplay: inline-flex;\n\tborder:#03313E 1px solid;\n\tmin-width: 108px;\n}\n\n.nucleus-sidebar-bottom {\n\tpadding-bottom: 0px;\n\tmargin-bottom: 0px;\n}\n\n.nucleus-sidebar::-webkit-scrollbar {\n\twidth: 11px;\n  }\n  .nucleus-sidebar {\n\tscrollbar-width: auto;\n\tscrollbar-color: var(--thumbBG) var(--scrollbarBG);\n  }\n  .nucleus-sidebar::-webkit-scrollbar-track {\n\tbackground: var(--scrollbarBG);\n  }\n  .nucleus-sidebar::-webkit-scrollbar-thumb {\n\tbackground-color: var(--scrollbarBG) ;\n\tborder-radius: 6px;\n\tborder: 2px solid var(--scrollbarBG);\n  }\n\n  .nucleus-sidebar::-webkit-scrollbar-thumb:hover {\n\tbackground-color: var(--thumbBG) ;\n\tborder-radius: 6px;\n\tborder: 2px solid var(--scrollbarBG);\n  }\n\n.sidebar-logo {\n\theight: 100px;\n}\n\n.nucleus-topbar {\n\t/*\n\tmin-width: 40px;\n\tmax-width: 80px;\n\t*/\n\tbackground-color: #F0F0F0;\n\theight: 53px;\n\twidth: 100% !important;\n\tmargin: 0px;\n\tpadding: 0px;\n\ttop: 0;\n}\n\n.nucleus-search {\n\twidth: 80%;\n\tmax-width: 80%;\n\theight: 100%;\n\tmax-height: 100%;\n}\n\n.search-icon {\n\twidth: 16px;\n\tmargin-top: -15px;\n}\n\n.nucleus-menu {\n\tpadding-top: 15px;\n\tpadding-bottom: 15px;\n\tmargin-top: 0px;\n\tmargin-bottom: 0px;\n\tfont-family: \"GothamNarrow-Medium\";\n}\n\n.nucleus-active-menu {\n\tposition: relative;\n}\n\n.nucleus-menu-icon {\n\tz-index: 10;\n\tposition: absolute;\n}\n\n.nucleus-menu-notification {\n\n\tbackground-image: url(../img/notification_bg.svg);\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tcolor: white;\n\ttext-align: center;\n\tfont-weight: bolder;\n\tfont-family: -apple-system, BlinkMacSystemFont, sans-serif;\n\tz-index: 12;\n\tposition: absolute;\n\tmargin-left: -44px;\n\tfont-size: 13px;\n\tpadding: 4px;\n\n\t/*\n\t    background-color: #FFCA1F;\n    border-radius: 12px;\n    border: 3px solid white;\n    padding: 0px;\n    line-height: 12px;\n    */\n}\n\n.menu-active {\n\t/* background-color:  #073140; */\n\tbackground-color: #FFCA20;\n\tcolor: #0A313F;\n}\n\n.menu-active img {\n\tfilter: invert(100%) sepia(30%) saturate(1472%) hue-rotate(152deg) brightness(89%) contrast(94%);\n}\n\n.nucleus-menu:hover {\n\tbackground-color: #008FF1;\n}\n\n.menu-active:hover {\n\t/* background-color:  #073140; */\n\tbackground-color: #FFCA20;\n}\n\n.menu-content {\n\tposition: relative;\n\t/* height: 100%; */\n\tmin-height: 1190px;\n}\n\n.menu-logout {\n\twidth: 100%;\n\t/* position:absolute;  */\n\tbottom: 0;\n\tmargin-bottom: 10px;\n}\n\n.general-content {\n\tmargin: 0;\n\tpadding: 0px !important;\n\toverflow: hidden;\n\theight: 100%;\n}\n\n.general-containter {\n\tmargin: 0;\n\tpadding: 0;\n\n\twidth: 100%;\n\theight: 100%;\n\tmargin-top: -53px;\n\tpadding-top: 53px;\n\n}\n\n.nucleus-page {\n\tmargin: 0;\n\tpadding: 50px;\n\tpadding-top: 0px;\n\n\tposition: relative;\n\n\n\theight: 100%;\n\toverflow: hidden;\n}\n\n.nucleus-scrollable-page {\n\tpadding-left: 30px;\n\tpadding-right: 30px;\n\tmin-height: 88% !important;\n\theight: 100% !important;\n\tmargin-bottom: 10px !important;\n\tposition: relative;\n\n\toverflow: auto;\n\toverflow-y: overlay;\n\n\tborder: 2px none red;\n\n\tpadding-right: 30px;\n}\n\n.nucleus-hard-container {\n\twidth: 100%;\n\theight: 100%;\n\tborder: 1px none orange;\n\tdisplay: inline-block;\n\tpadding-left: 30px;\n\tpadding-right: 10px;\n\tmin-height: 88% !important;\n\theight: 100% !important;\n\tmargin-bottom: 10px !important;\n\tposition: relative;\n\t/* background-color: #f6f6f6; */\n\toverflow: auto;\n\toverflow-y: scroll;\n\toverflow-x: scroll;\n\n\n}\n\n.page-index {\n    background-color: transparent;\n    width: 48px;\n    height: 48px;\n    border-radius: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #656D77;\n    user-select: none;\n  }\n  \n  .page-index:hover {\n    background-color: #ccc5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #656D77;\n    cursor: pointer;\n    user-select: none;\n  }\n  \n  .page-index-selected {\n    background-color: #0092ff;\n    width: 48px;\n    height: 48px;\n    border-radius: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    font-weight: 500;\n  }\n  .page-index-disabled {\n    background-color: transparent;\n    color: #ccc;\n    cursor: not-allowed;\n  }\n  \n  .page-index-disabled:hover {\n    background-color: transparent;\n    color: #ccc;\n    cursor: not-allowed;\n  }\n  \n\n.nucleus-tools-container {\n\twidth: 100%;\n\theight: 100%;\n\tborder: 1px none orange;\n\tdisplay: inline-block;\n\n\tpadding-left: 30px;\n\tpadding-right: 10px;\n\tmin-height: 88% !important;\n\theight: 100% !important;\n\tmargin-bottom: 10px !important;\n\tposition: relative;\n\n\toverflow: auto;\n\toverflow-y: scroll;\n\toverflow-x: scroll;\n}\n\n.nucleus-tools-container-devices {\n\twidth: 100%;\n\theight: 100%;\n\tborder: 1px none orange;\n\tdisplay: inline-block;\n\n\tpadding-left: 30px;\n\tpadding-right: 10px;\n\tmin-height: 88% !important;\n\theight: 100% !important;\n\tpadding-bottom: 10px;\n\tposition: relative;\n\n\toverflow: auto;\n\t/* overflow-y: scroll; */\n\toverflow-x:auto;\n}\n\n.nucleus-tools-container-accounts {\n\twidth: 100%;\n\theight: 100%;\n\tborder: 1px none orange;\n\tdisplay: inline-block;\n\n\tpadding-left: 30px;\n\tpadding-right: 10px;\n\tmin-height: 88% !important;\n\theight: 95% !important;\n\tmargin-bottom: 10px !important;\n\tposition: relative;\n\n\t/* overflow: auto;\n\toverflow-y: scroll;\n\toverflow-x: scroll; */\n}\n\n\n.nucleus-all-scrollable-page {\n\n\tmin-width: 1130px;\n\twidth: 100%;\n\tborder: 1px none red;\n\tpadding-right: 10px;\n}\n\n.nucleus-page-title {\n\t/* GothamNarrow-Light, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif; */\n\tfont-family: GothamNarrow-Book;\n\tfont-size: x-large;\n\tcolor: #000;\n\tfont-weight: bolder;\n}\n\n.nucleus-page-subtitle {\n\tfont-family: GothamNarrow-Medium, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: 18px;\n\tdisplay: inline;\n}\n\n.nucleus-page-subtitle-special {\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: 19px;\n\tfont-weight: bold;\n}\n\n.nucleus-page-toast {\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: 16px;\n\tfont-weight: bold;\n\t/* color: #0A313F; */\n}\n\n.nucleus-font {\n\tfont-family: GothamNarrow-Light;\n}\n\n.nucleus-font-family-medium {\n\tfont-family: GothamNarrow-Medium, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n}\n\n.nucleus-news-separator {\n\tfont-size: 8px;\n\twidth: 100%;\n\tborder-bottom: 1px solid #B4C6D3;\n\tmargin-bottom: 15px;\n}\n\n.user-img {\n\twidth: 75%;\n\tmax-width: 80% !important;\n}\n\n.nucleus-labels-small {\n\tfont-size: 15px;\n\tmargin-bottom: 5px;\n\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: medium;\n}\n\n.nucleus-labels {\n\tfont-size: 16px;\n\tmargin-bottom: 5px;\n\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: medium;\n}\n\n.nucleus-labels-large {\n\tfont-size: 16px;\n\tmargin-bottom: 5px;\n\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: large;\n}\n\n.nucleus-label-book {\n\tfont-size: 16px;\n\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\n}\n\n.bold-500 {\n\tfont-weight: 500;\n}\n\n.nucleus-tools-page-title {\n\tfont-weight: bolder;\n\tcolor: #0a313f;\n\tfont-size: 24px;\n\tfont-family: GothamNarrow-Book;\n}\n\n.nucleus-tools-page-text-title {\n\tfont-size: 16px;\n\tpadding-top: 30px !important;\n\tcolor: #0A313F;\n\tfont-family: GothamNarrow-Medium, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n}\n\n.nucleus-tools-page-text-label {\n\tfont-size: 16px;\n\tpadding-top: 30px !important;\n\tcolor: #0A313F;\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n}\n\n.nucleus-token-labels {\n\tfont-size: 16px;\n\tmargin-top: 30px;\n\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: medium;\n}\n\n.nucleus-labels-height {\n\tfont-size: 16px;\n\tmargin-bottom: 5px;\n\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: medium;\n\tline-height: 30px !important;\n}\n\n.nucleus-labels-bold {\n\tfont-size: 16px;\n\tmargin-bottom: 5px;\n\n\tfont-family: GothamNarrow-Medium, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: medium;\n\t/*font-weight: bolder !important;*/\n}\n\n.nucleus-labels-large-bold{\n\tfont-size: 16px;\n\tmargin-bottom: 5px;\n\n\tfont-family: GothamNarrow-Medium, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: large;\n\t/*font-weight: bolder !important;*/\n}\n\n.nucleus-labels-bold-height {\n\tfont-size: 16px;\n\tmargin-bottom: 5px;\n\n\tfont-family: GothamNarrow-Medium, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: medium;\n\t/*font-weight: bolder !important;*/\n}\n\n.nucleus-labels-special {\n\tfont-size: 16px;\n\tmargin-bottom: 5px;\n\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: medium;\n\n\tmargin-left: -15px;\n}\n\n.nucleus-input-form {\n\ttext-align: left;\n\tcolor: #000;\n\tpadding-bottom: 0px !important;\n\tmargin-bottom: 5px !important;\n\tborder: 3px solid black;\n\theight: 20px;\n\n\tfont-size: 16px !important;\n\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: larger;\n}\n\n.nucleus-tel-input-form {\n\ttext-align: left;\n\tcolor: #000;\n\tpadding-bottom: 0px !important;\n\tmargin-bottom: 5px !important;\n\tborder: 3px solid black;\n\theight: 20px;\n\n\tfont-size: 16px !important;\n\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: larger;\n\n\twidth: 95% !important;\n\tmargin: 0px !important;\n\tpadding-top: 10px !important;\n\tborder-radius: 5px !important;\n\tbackground-color: #fff !important;\n\tfont-size: 16px !important;\n\tbox-shadow: none !important;\n}\n\n.nucleus-tel-input-form-container {\n\n\t\twidth: 85% !important;\n}\n\n.nucleus-input-form-disabled {\n\ttext-align: left;\n\tcolor: #000;\n\tpadding-bottom: 0px !important;\n\tmargin-bottom: 5px !important;\n\tborder: 3px solid black;\n\theight: 20px;\n\n\tfont-size: 16px !important;\n\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: larger;\n\n\tborder-bottom: 0px none #e6e6e6 !important;\n}\n\n\n.nucleus-table-icon {\n\tcolor: #000;\n}\n\n.img-company-logo {\n\tmargin-top: 20px;\n}\n\n.nucleus-fixed-container {\n\n\tpadding: 0px;\n\tmin-height: 88% !important;\n\theight: 95% !important;\n\tmin-width: 920px !important;\n\tborder: 1px none blue;\n\tpadding-bottom: 30px;\n}\n\n.nucleus-table-container,\n.nucleus-form-container {\n\tfloat: top;\n\tpadding: 0px;\n\tmin-height: 88% !important;\n\theight: 95% !important;\n\tposition: relative;\n\n\t/* overflow: auto; */\n\toverflow-y: scroll;\n\n\tborder: 2px none blue;\n\tpadding-bottom: 30px;\n}\n\n.nucleus-table-container-s {\n\tfloat: top;\n\tpadding: 0px;\n\t/* min-height: 88% !important; */\n\theight: 95% !important;\n\tposition: relative;\n\n\toverflow: hidden;\n\toverflow-y: hidden;\n\n\tborder: 2px none blue;\n\tpadding-bottom: 30px;\n}\n\n.nucleus-table-container-s-90 {\n\tfloat: top;\n\tpadding: 0px;\n\t/* min-height: 88% !important; */\n\theight: 90% !important;\n\tposition: relative;\n\n\toverflow: hidden;\n\toverflow-y: hidden;\n\n\tborder: 2px none blue;\n\tpadding-bottom: 30px;\n}\n\n.nucleus-table-container-s-70 {\n\tfloat: top;\n\tpadding: 0px;\n\t/* min-height: 88% !important; */\n\theight: 70% !important;\n\tposition: relative;\n\n\toverflow: hidden;\n\toverflow-y: hidden;\n\n\tborder: 2px none blue;\n\tpadding-bottom: 30px;\n}\n\n.nucleus-middle-table-container {\n\tfloat: top;\n\tpadding: 0px;\n\tmin-height: 50% !important;\n\t/* height: 35% !important; */\n\theight: 450px !important;\n\tposition: relative;\n\n\toverflow: auto;\n\toverflow-y: scroll;\n\n\tborder: 2px none pink;\n\tpadding-bottom: 30px;\n}\n\n\n.nucleus-75-table-container {\n\tfloat: top;\n\tpadding: 0px;\n\tmin-height: 50% !important;\n\theight: 72% !important;\n\t/* height: 560px !important; */\n\tposition: relative;\n\n\toverflow: auto;\n\toverflow-y: auto;\n\n\tborder: 2px none pink;\n\tpadding-bottom: 30px;\n}\n\n.nucleus-quarter-table-container {\n\tfloat: top;\n\tpadding: 0px;\n\tmin-height: 58% !important;\n\theight: 65% !important;\n\tposition: relative;\n\n\toverflow: auto;\n\toverflow-y: scroll;\n\n\tborder: 2px none pink;\n\tpadding-bottom: 30px;\n}\n\n.nucleus-mini-table-container {\n\tfloat: top;\n\tpadding: 0px;\n\tmin-height: 70px !important;\n\theight: 80px !important;\n\n\toverflow: auto;\n\toverflow-y: scroll;\n\n\tborder: 2px none pink;\n}\n\n.work-log {\n\tmin-height: 20%;\n\theight: 60%;\n\tmargin-bottom: 10px !important;\n\tposition: relative;\n\n\toverflow: hidden;\n\tborder: 2px none blue;\n}\n\n.work-log-long {\n\tmin-height: 20%;\n\theight: 90%;\n\tmargin-bottom: 10px !important;\n\tposition: relative;\n\n\toverflow: hidden;\n\tborder: 2px none blue;\n}\n\n\n\n.table-scroll-space {\n\tpadding-right: 16px;\n}\n\n.nucleus-table-container::-webkit-scrollbar {\n\twidth: 8px;\n\tbackground-color: #F5F5F5;\n}\n\n.nucleus-table-container::-webkit-scrollbar-thumb {\n\tbackground-color: rgba(3, 52, 66, 0.1);\n\tbackground-color: #03313E;\n\tborder-radius: 10px;\n}\n\n.nucleus-table-container::-webkit-scrollbar-thumb:hover {\n\tbackground-color: #03313E;\n\tborder-radius: 10px;\n}\n\n.nucleus-table-container::-webkit-scrollbar-track {\n\tborder-radius: 5px;\n}\n\n.nucleus-table-container::-webkit-scrollbar-track-piece {\n\theight: 50px;\n}\n\n.nucleus-table-container::-webkit-scrollbar-thumb:vertical {\n\theight: 50px;\n}\n\n\n.nucleus-middle-table-container::-webkit-scrollbar,\n.nucleus-scrollable-page::-webkit-scrollbar,\n.nucleus-textarea-scroll::-webkit-scrollbar {\n\twidth: 8px;\n\tbackground-color: #F5F5F5;\n}\n\n.nucleus-middle-table-container::-webkit-scrollbar-thumb,\n.nucleus-scrollable-page::-webkit-scrollbar-thumb,\n.nucleus-textarea-scroll::-webkit-scrollbar-thumb {\n\tbackground-color: rgba(3, 52, 66, 0.1);\n\tbackground-color: #03313E;\n\tborder-radius: 10px;\n}\n\n.nucleus-middle-table-container::-webkit-scrollbar-thumb:hover,\n.nucleus-scrollable-page::-webkit-scrollbar-thumb:hover,\n.nucleus-textarea-scroll::-webkit-scrollbar-thumb:hover {\n\tbackground-color: #03313E;\n\tborder-radius: 10px;\n}\n\n.nucleus-middle-table-container::-webkit-scrollbar-track,\n.nucleus-scrollable-page::-webkit-scrollbar-track,\n.nucleus-textarea-scroll::-webkit-scrollbar-track {\n\tborder-radius: 5px;\n}\n\n.nucleus-middle-table-container::-webkit-scrollbar-track-piece,\n.nucleus-scrollable-page::-webkit-scrollbar-track-piece,\n.nucleus-textarea-scroll::-webkit-scrollbar-track-piece {\n\theight: 50px;\n}\n\n.nucleus-middle-table-container::-webkit-scrollbar-thumb:vertical,\n.nucleus-scrollable-page::-webkit-scrollbar-thumb:vertical,\n.nucleus-textarea-scroll::-webkit-scrollbar-thumb:vertical {\n\theight: 50px;\n}\n\n\n.nucleus-hard-container::-webkit-scrollbar {\n\twidth: 8px;\n\theight: 8px;\n\tbackground-color: #F5F5F5;\n}\n\n.nucleus-hard-container::-webkit-scrollbar-thumb {\n\tbackground-color: rgba(3, 52, 66, 0.1);\n\tbackground-color: #03313E;\n\tborder-radius: 10px;\n}\n\n.nucleus-hard-container::-webkit-scrollbar-thumb:hover {\n\tbackground-color: #03313E;\n\tborder-radius: 10px;\n}\n\n.nucleus-hard-container::-webkit-scrollbar-track {\n\tborder-radius: 5px;\n}\n\n.nucleus-hard-container::-webkit-scrollbar-track-piece {\n\theight: 50px;\n}\n\n.nucleus-hard-container::-webkit-scrollbar-thumb:vertical {\n\theight: 50px;\n}\n\n.nucleus-hard-container::-webkit-scrollbar-thumb:horizontal {\n\twidth: 50px;\n}\n\n*:not(.nucleus-sidebar)::-webkit-scrollbar {\n\twidth: 8px;\n\theight: 8px;\n\tbackground-color: #F5F5F5;\n}\n\n*:not(.nucleus-sidebar)::-webkit-scrollbar-thumb {\n\tbackground-color: rgba(3, 52, 66, 0.1);\n\tbackground-color: #03313E;\n\tborder-radius: 10px;\n}\n\n*:not(.nucleus-sidebar)::-webkit-scrollbar-thumb:hover {\n\tbackground-color: #03313E;\n\tborder-radius: 10px;\n}\n\n*:not(.nucleus-sidebar)::-webkit-scrollbar-track {\n\tborder-radius: 5px;\n}\n\n*:not(.nucleus-sidebar)::-webkit-scrollbar-track-piece {\n\theight: 50px;\n}\n\n*:not(.nucleus-sidebar)::-webkit-scrollbar-thumb:vertical {\n\theight: 50px;\n}\n\n*:not(.nucleus-sidebar)::-webkit-scrollbar-thumb:horizontal {\n\twidth: 50px;\n}\n\n\n\n\n.nucleus-mini-table-container::-webkit-scrollbar {\n\twidth: 8px;\n\tbackground-color: #F5F5F5;\n}\n\n.nucleus-mini-table-container::-webkit-scrollbar-thumb {\n\tbackground-color: rgba(3, 52, 66, 0.1);\n\tbackground-color: #03313E;\n\tborder-radius: 10px;\n}\n\n.nucleus-mini-table-container::-webkit-scrollbar-thumb:hover {\n\tbackground-color: #03313E;\n\tborder-radius: 10px;\n}\n\n.nucleus-mini-table-container::-webkit-scrollbar-track {\n\tborder-radius: 5px;\n}\n\n.nucleus-mini-table-container::-webkit-scrollbar-track-piece {\n\theight: 50px;\n}\n\n.nucleus-mini-table-container::-webkit-scrollbar-thumb:vertical {\n\theight: 50px;\n}\n\n.nucleus-table {\n\tmax-height: 97%;\n}\n\n\n\n.log-table-cell {\n\tmargin: 0px;\n\tpadding: -30px;\n}\n\ninput[type=text] {\n\tpadding-bottom: -3px !important;\n}\n\n.nucleus-icon {\n\twidth: 1.6em;\n}\n\n.nucleus-icon-s {\n\tmargin-top: 4px !important;\n\twidth: 29px;\n\tmargin-bottom: -3px;\n}\n\n.nucleus-icon-smaller {\n\twidth: 1.3em;\n\tmargin-bottom: 1px;\n}\n\n.nucleus-icon-bigger {\n\twidth: 1.8em;\n}\n\n.nucleus-icon-dynamic {\n\tmargin: 0px;\n\tpadding: 0px;\n\tpadding-top: 0px;\n\theight: 28px;\n}\n\n.nucleus-chart {\n\twidth: 90%;\n\theight: 60%;\n\n\tborder: 1px solid #B3B3B3;\n\tborder-radius: 9px;\n}\n\n.nucleus-chart-title {\n\theight: 45px;\n\tborder-bottom: 1px solid #B3B3B3;\n}\n\n.nucleus-chart-title-text {\n\tfont-size: 14px;\n}\n\n.nucleus-chart-body {\n\theight: 290px;\n\tmargin-left: 10px;\n\tmargin-right: 10px;\n\tbottom: 0;\n}\n\n.chart-red {\n\tcolor: #C70100;\n\tfont-weight: bold;\n}\n\n.chart-yellow {\n\tcolor: #FCD200;\n\tfont-weight: bold;\n}\n\n.chart-dark-yellow {\n\tcolor: #FCD200;\n\tfont-size: 13px;\n}\n\n.chart-dark-white {\n\tcolor: #f2f2f2;\n\tfont-size: 11px;\n}\n\n.chart-blue {\n\tcolor: #3099D5;\n\tfont-weight: bold;\n}\n\n.chart-orange {\n\tcolor: #FA6500;\n\tfont-weight: bold;\n}\n\n.color-nucleus-yellow {\n\tcolor: #FFCD01;\n\tfont-weight: bold;\n}\n\n.color-nucleus-blue {\n\tcolor: #018FFF;\n\tfont-weight: bold;\n}\n\n\n.nucleus-modal {\n\toverflow-y: hidden;\n\tmin-width: 50px;\n\tmin-height: 50px;\n\n\tmax-width: 760px;\n\tmax-height: 471px;\n\n\tpadding: 0;\n\tbackground-color: rgb(0, 0, 0);\n\t/*13, 16, 45*/\n\tborder: 2px none green;\n\tborder-radius: 5px 5px 10px 10px;\n}\n\n#modalUpdateAssigneCaregiver {\n\tmargin-top: 5%;\n\twidth: 35%;\n\tz-index: 2000;\n}\n\n.nucleus-modal-content {\n\t/* padding: 0 !important;\n\tmargin:0px\n\n\t-webkit-box-shadow: none;\n\t-moz-box-shadow: none;\n\tbox-shadow: none;; */\n\tpadding-top: 23px !important;\n\tpadding-left: 35px !important;\n\tpadding-right: 35px !important;\n\tpadding-bottom: 25px !important;\n}\n\n\n\n.nucleus-call-image {\n\tmargin: 0 !important;\n\tborder: 2px none red;\n}\n\n.nucleus-modal-call {\n\toverflow-y: hidden;\n\n\n\twidth: 640px;\n\theight: 403px;\n\n\tpadding: 0 !important;\n\tbackground-color: rgb(0, 0, 0);\n\t/*13, 16, 45*/\n\tborder: 0px none green;\n\tborder-radius: 5px 5px 10px 10px;\n\toverflow-x: hidden !important;\n\n}\n\n.nucleus-modal-content-call {\n\tmargin: 0px !important;\n\tpadding: 0px !important;\n\n\twidth: 99.9%;\n\theight: 99.9%;\n\n\tborder: 0px none blue;\n\n\tbackground-color: #0E102B;\n\n}\n\n.volume-controls {\n\tposition: absolute;\n\twidth: 30%;\n\tmargin: 0px !important;\n\tpadding: 0px !important;\n\n\tleft: 0;\n\tborder: 1px none white;\n}\n\n.volume-controls-bar {\n\twidth: 100%;\n\tpadding-left: 5px;\n\tpadding-right: 5px;\n\theight: 50% !important;\n\tborder: 1px none white;\n\tpadding: 7px !important;\n}\n\n.nucleus-control-range {\n\tborder: 1px none white !important;\n\tmin-width: 40% !important;\n\twidth: 60%;\n\tmax-width: 60% !important;\n\t/*height: 30% !important;*/\n\ttext-decoration: none !important;\n\tmargin: 0px !important;\n\tpadding: 0px !important;\n\tmargin-left: 15px !important;\n\tmargin-right: 15px !important;\n\n\t-webkit-appearance: none !important;\n}\n\n/*input[type=range]{\n    text-decoration: none !important;\n  \toutline: none;\n     -webkit-appearance: none !important; Hides the slider so that custom slider can be made \n  \theight: 30% !important;\n  \tborder: 1px none white !important;\n}\n*/\ninput[type=\"range\"] {\n\t-webkit-appearance: none !important;\n\t-moz-apperance: none !important;\n\tborder-radius: 6px;\n\theight: 10px !important;\n\n\tbackground-image: -webkit-gradient(linear,\n\t\t\tleft top,\n\t\t\tright top,\n\t\t\tcolor-stop(0.5, rgba(194, 192, 194, 1)),\n\t\t\tcolor-stop(0.5, rgba(194, 192, 194, 0.3)));\n}\n\ninput[type='range']::-webkit-slider-thumb {\n\t-webkit-appearance: none !important;\n\tbackground-color: #E9E9E9;\n\tborder: 1px solid #CECECE;\n\theight: 15px;\n\twidth: 15px;\n}\n\ninput[type=range]:focus {\n\tborder: 1px none transparent !important;\n\tmin-width: 40% !important;\n\twidth: 60%;\n\tmax-width: 60% !important;\n\theight: 10px !important;\n\ttext-decoration: none !important;\n\tmargin: 0px !important;\n\tpadding: 0px !important;\n\tmargin-left: 15px !important;\n\tmargin-right: 15px !important;\n}\n\ninput[type=range]::-webkit-slider-runnable-track {\n\tbackground: transparent;\n}\n\ninput[type=range]::-webkit-slider-thumb {\n\t-webkit-appearance: none !important;\n}\n\n/*input[type=range]:focus {\n  outline: none;  Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. \n}*/\n\n\n\n\n.nucleus-communication-frame {\n\tposition: absolute;\n\tborder: 0px none white;\n\twidth: 640px !important;\n\theight: 364px !important;\n\n\tmargin: 0px !important;\n\tpadding: 0px !important;\n\tbackground-color: #000;\n\tmargin-top: 43px !important;\n}\n\n.nucleus-audiocall-frame {\n\tposition: absolute;\n\tborder: 0px none white;\n\twidth: 99.9% !important;\n\theight: 95% !important;\n\n\tmargin: 0px !important;\n\tpadding: 0px !important;\n\tbackground-color: #0E102B;\n\tmargin-top: 43px !important;\n}\n\n.nucleus-videocall-frame {\n\tposition: absolute;\n\tborder: 0px none white;\n\twidth: 99.9% !important;\n\theight: 95% !important;\n\n\tmargin: 0px !important;\n\tpadding: 0px !important;\n\tmargin-top: 43px !important;\n}\n\n.nucleus-call-bar {\n\tposition: absolute;\n\twidth: 99.9%;\n\tmargin: 0px !important;\n\tpadding: 0px !important;\n\tmin-height: 30px;\n\theight: 43px;\n\ttop: 0;\n\tbackground-color: #0E102B;\n\tborder: 0px none red;\n}\n\n.nucleus-call-caller {\n\tposition: absolute;\n\twidth: 99.9%;\n\tmargin: 0px !important;\n\tpadding: 0px !important;\n\theight: 99.9%;\n\ttop: 0;\n\tborder: 2px none yellow;\n\tbackground-color: #0E102B;\n}\n\n.call-name-capitals {\n\tposition: absolute;\n\tfont-size: 4em;\n}\n\n.call-rings,\n.call-oval {\n\n\tposition: absolute;\n\tmargin: auto;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n}\n\n.ring1 {\n\twidth: 180px;\n\theight: 180px;\n}\n\n.ring2 {\n\twidth: 180px;\n\theight: 180px;\n}\n\n.ring3 {\n\twidth: 210px;\n\theight: 150px;\n}\n\n.ring4 {\n\twidth: 290px;\n\theight: 150px;\n}\n\n.call-frame-background {\n\tposition: absolute;\n\twidth: 99%;\n\tmax-width: 99%;\n\tmax-height:  99%;\n\tmargin-top: -20px;\n\ttext-align: center;\n}\n\n.callModeTitle {\n\tposition: absolute;\n\theight: 99%;\n\twidth: 99.9%;\n\tmargin-top: 35px;\n\tfont-size: 29px !important;\n\tfont-family: GothamNarrow-Light, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\n}\n\n\n.callModeSubtitle {\n\tposition: absolute;\n\theight: 99%;\n\twidth: 99%;\n\tmargin-top: 75px;\n\tfont-size: 18px !important;\n\tfont-family: GothamNarrow-Light, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\n}\n\n.nucleus-call-controls {\n\tposition: absolute;\n\twidth: 99.9%;\n\tmargin: 0px !important;\n\tpadding: 0px !important;\n\tpadding-top: 9px !important;\n\tbottom: 0;\n\tborder: 0px none yellow;\n\n\tdisplay: inline;\n}\n\n.nucleus-call-control {\n\twidth: 42px;\n\tmargin-top: 5px;\n}\n\n.nucleus-call-controls-bg {\n\tbackground-color: rgba(64, 64, 64, 0.2);\n}\n\n.control-panels-container {\n\tborder: 1px none white;\n\tdisplay: inline-flex;\n}\n\n.control-panels {\n\tborder: 1px none white;\n\tdisplay: block;\n\twidth: 80px;\n\tfont-size: 10px;\n\ttext-align: center !important;\n}\n\n.control_end_call {}\n\n.mic1 {\n\twidth: 11px;\n}\n\n.vol1 {\n\twidth: 17px;\n}\n\n.call-control-title {\n\tmargin-top: -10px;\n}\n\ninput[type=range]::-webkit-slider-thumb {\n\tbackground-color: white;\n\tborder: 0px none white !important;\n}\n\ninput[type=range]::-moz-range-thumb {\n\tbackground-color: white !important;\n}\n\ninput[type=range]::-ms-thumb {\n\tbackground-color: white !important;\n}\n\n/***** These are to edit the thumb and the text inside the thumb *****/\ninput[type=range]+.thumb {\n\tdisplay: none;\n\ttext-decoration-color: none;\n\ttext-decoration: none;\n}\n\ninput[type=range]+.thumb.active .value {\n\tcolor: white;\n}\n\n.modalScrollableSmall {\n\tbackground: #EBEBEB;\n\tborder-radius: 10px 10px 10px 10px;\n\tmin-width: 390px !important;\n\twidth: 36%;\n\tpadding-bottom: 10px;\n}\n\n.modalCallLog,\n.modalMultiSMS {\n\tbackground: #D8D8D8;\n\tborder-radius: 10px 10px 10px 10px;\n\t/*height: 50%;\n\tmin-height: 54%;\n\tmax-height: 70%;*/\n\tborder: 2px none green;\n\toverflow: hidden;\n}\n\n#modalEditAssignment {\n\tmax-height: 90%;\n}\n\n.modalScrollable {\n\t/*background: #D8D8D8;*/\n\tborder-radius: 10px 10px 10px 10px;\n\tmin-width: 35%;\n\twidth: 45%;\n}\n\n.modalScrollable_55 {\n\t/*background: #D8D8D8;*/\n\tborder-radius: 10px 10px 10px 10px;\n\tmin-width: 45%;\n\twidth: 55%;\n}\n\n.modalAssignment {\n\tbackground: #D8D8D8;\n\tborder-radius: 10px 10px 10px 10px;\n\theight: 65%;\n\t/*min-height: 54%;\n\tmax-height: 70%;*/\n\tborder: 2px none green;\n\toverflow: hidden;\n\tmin-width: 35%;\n\twidth: 45%;\n\tmax-width: 55%;\n}\n\n.nucleus-modal-wrapper {\n\twidth: 100%;\n\tmin-height: 80%;\n\theight: 100% !important;\n\tborder: 2px none blue;\n\tmargin-bottom: 0px !important;\n}\n\n.nucleus-modal-wrapper-scrollable {\n\twidth: 100%;\n\tmin-height: 80%;\n\theight: 100% !important;\n\tborder: 2px none blue;\n\tmargin-bottom: 0px !important;\n\toverflow-y: scroll;\n}\n\n.modallScrollable {}\n\n.modalCallLogContent {\n\n\tmargin: 0px;\n\tpadding: 0px;\n\tmin-height: 50%;\n\theight: 83%;\n\tmax-height: 90%;\n\tborder: 2px none red;\n\tposition: relative;\n\tdisplay: block;\n}\n\n.modalSeparator {\n\tposition: relative;\n\tmargin-top: 25% !important;\n\tfont-size: 5px;\n}\n\n.nucleus-textarea {\n\tbackground-color: white !important;\n\tmargin: 0;\n\tmin-height: 140px;\n\theight: 70%;\n\tmax-height: 92%;\n\toverflow-y: scroll;\n\tmargin-bottom: 10px;\n\tpadding: 8px;\n}\n\n.nucleus-textarea-medium {\n\tbackground-color: white !important;\n\tmargin: 0;\n\tmin-height: 115px;\n\theight: 65%;\n\tmax-height: 85%;\n\toverflow-y: scroll;\n\tmargin-bottom: 10px;\n\tpadding: 8px;\n}\n\n.nucleus-textarea-small {\n\tbackground-color: white !important;\n\tmargin: 0;\n\tmin-height: 85px;\n\theight: 50%;\n\tmax-height: 85%;\n\toverflow-y: scroll;\n\tmargin-bottom: 10px;\n\tpadding: 8px;\n}\n\n.img-close-modal {\n\tposition: relative;\n\tfloat: right;\n\t/* margin-top: -10px; */\n\twidth: 14px;\n\tcursor: pointer;\n}\n\n.modal-overlay {\n\t/*display: none !important;*/\n}\n\n.log-header {\n\tborder: 2px none red;\n\tmargin-top: 23px;\n\tmargin-bottom: 5px;\n\tpadding-left: 0px;\n}\n\n.log-row {\n\tborder: 2px none blue;\n\tmargin-top: 13px;\n\tmargin-bottom: 13px;\n}\n\n.no-padding {\n\tpadding: 0px;\n}\n\n.no-padding-left {\n\tpadding-left: 0px !important;\n}\n\n.modalUnblockApi \n.modalResetUserPassword\n{\n\tborder-radius: 10px 10px 10px 10px;\n\tpadding-bottom: 0px;\n\n\tmin-width: 36%;\n\twidth: 36% !important;\n\tmax-width: 60%;\n}\n\n#modalResetUserPasswordForce{\n\twidth: 36% !important;\n}\n\n.modalDeletePatient,\n.modalDeleteCaregiver,\n.modalDeleteQueueItem,\n.modalDeviceSelectedDetails,\n.modalDeletePatientGenerateApiToken {\n\n\tborder-radius: 10px 10px 10px 10px;\n\tpadding-bottom: 0px;\n\n\tmin-width: 40%;\n\twidth: 40%;\n\tmax-width: 60%;\n}\n\n.modalDeleteAccountDevice,\n.modalDownloadDeviceLogs,\n.modalEditCategory,\n.modalNewCategory,\n.modalDeleteAccountButton,\n\n.modalEditCsUser,\n.modalDeviceDetails,\n.modalPatientTimezone \n{\n\n\tborder-radius: 10px 10px 10px 10px;\n\tpadding-bottom: 0px;\n\n\tmin-width: 40%;\n\twidth: 40%;\n\tmax-width: 60%;\n}\n\n.modalDeleteUser,\n.modalAssignClient,\n.modalUnassignClient,\n.modalAssignAllPatients {\n\n\tborder-radius: 10px 10px 10px 10px;\n\tpadding-bottom: 0px;\n\n\tmin-width: 40%;\n\twidth: 40%;\n\tmax-width: 60%;\n}\n\n.modalMedium,\n.modalSelectTemplate,\n.modalOrderDetails {\n\tborder-radius: 10px 10px 10px 10px;\n\tpadding-bottom: 0px;\n\n\tmin-width: 60%;\n\twidth: 60%;\n\tmax-width: 70%;\n}\n\n.modalNewAccount,\n.modalNewAccountDevice,\n.modalNewAccountLanguage,\n.modalNewAccountButton,\n.modalEditAccountButton,\n.modalNewAccountBiometricDevice,\n.modalEditAccountBiometricDevice,\n.modalDeleteAccountBioDevice,\n.modalNewAccountSchedule,\n.modalEditAccountSchedule,\n.modalDeleteAccountSchedule,\n.modalUpdateDefaultAccountSchedule,\n.modalDeleteAccount {\n\n\tborder-radius: 10px 10px 10px 10px;\n\tpadding-bottom: 0px;\n\n\tmin-width: 40%;\n\twidth: 40%;\n\tmax-width: 60%;\n}\n\n.modal-content-delete,\n.modal-general-content {\n\tmargin-bottom: 0px;\n\tpadding-bottom: 0px !important;\n}\n\n\ninput {\n\tborder-bottom: 1px solid #e6e6e6 !important;\n\t-webkit-box-shadow: 0 1px 0 0 #e6e6e6 !important;\n\t-moz-box-shadow: 0 1px 0 0 #e6e6e6 !important;\n\tbox-shadow: 0 1px 0 0 #e6e6e6 !important;\n\n\tpadding-bottom: 0px !important;\n\theight: 2rem !important;\n}\n\ninput:focus {\n\tborder-bottom: 1px solid black !important;\n\t-webkit-box-shadow: 0 1px 0 0 black !important;\n\t-moz-box-shadow: 0 1px 0 0 black !important;\n\tbox-shadow: 0 1px 0 0 black !important;\n\n\tpadding-bottom: 0px !important;\n\theight: 2rem !important;\n}\n\n.nucleus-table-header {\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: large;\n\tfont-weight: bolder;\n\tfont-size: 19px;\n\tpadding-bottom: 0px !important;\n}\n\n.nucleus-table-header-medium {\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: large;\n\tfont-weight: bold;\n\tfont-size: 18px;\n\tpadding-bottom: 0px !important;\n}\n\n.nucleus-table-header-small {\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: medium;\n\tfont-weight: 500;\n\tfont-size: 17px;\n\tpadding-bottom: 0px !important;\n}\n\n\n\ntd {\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: medium;\n\n\tpadding-top: 7px;\n\tpadding-bottom: 7px;\n\n}\n\nth {\n\tpadding-top: 7px;\n\tpadding-bottom: 2px;\n\tvertical-align: bottom;\n}\n\n.nucleus-form-error {\n\tfont-family: GothamNarrow-Light, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: 14px;\n\tcolor: red;\n\twidth: 100%;\n}\n\n.nucleus-form-error-tools {\n\tfont-family: GothamNarrow-Book, 'Lucida Sans';\n\tfont-size: 14px;\n\tcolor: #D0021B;\n}\n\n.nucleus-date-picker {\n\tborder: 2px none red !important;\n\tbackground-color: white !important;\n\tpadding-left: 4px !important;\n\tmargin-bottom: 0px !important;\n\tpadding-bottom: 0px !important;\n}\n\n.nucleus-date-picker2 {\n\tborder: 1px none red !important;\n\tbackground-color: white !important;\n\tpadding-left: 4px !important;\n\tmargin-bottom: 0px !important;\n\tpadding-bottom: 0px !important;\n\twidth: 60% !important;\n\tborder-radius: 2px !important;\n\tmargin-top: -2px;\n\n}\n\n/* do not group these rules */\n.placeholder-black::-webkit-input-placeholder {\n\tcolor: black;\n}\n\n.placeholder-black:-moz-placeholder {\n\t/* FF 4-18 */\n\tcolor: black;\n}\n\n.placeholder-black::-moz-placeholder {\n\t/* FF 19+ */\n\tcolor: black;\n}\n\n.placeholder-black:-ms-input-placeholder {\n\t/* IE 10+ */\n\tcolor: black;\n}\n\n.placeholder-gray {\n\tcolor: #9D9D9D;\n}\n\n.gray {\n\tcolor: #868686;\n}\n\n/* .table-col-1{\n\twidth: 1%;\n}\n.table-col-2{\n\twidth: 2%;\n}\n.table-col-3{\n\twidth: 3%;\n}\n.table-col-4{\n\twidth: 4%;\n}\n.table-col-5{\n\twidth: 5%;\n}\n.table-col-5{\n\twidth: 5%;\n}\n.table-col-6{\n\twidth: 6%;\n}\n.table-col-7{\n\twidth: 7%;\n}\n.table-col-8{\n\twidth: 8%;\n}\n.table-col-9{\n\twidth: 9%;\n}\n.table-col-10{\n\twidth: 10%;\n}\n.table-col-11{\n\twidth: 11%;\n}\n.table-col-12{\n\twidth: 12%;\n}\n.table-col-13{\n\twidth: 13%;\n}\n.table-col-14{\n\twidth: 14%;\n}\n.table-col-15{\n\twidth: 15%;\n}\n.table-col-16{\n\twidth: 16%;\n}\n.table-col-17{\n\twidth: 17%;\n}\n.table-col-18{\n\twidth: 18%;\n}\n.table-col-19{\n\twidth: 19%;\n}\n.table-col-20{\n\twidth: 20%;\n}\n.table-col-21{\n\twidth: 21%;\n}\n.table-col-24{\n\twidth: 24%;\n}\n.table-col-25{\n\twidth: 25%;\n}\n.table-col-30{\n\twidth: 30%;\n}\n.table-col-40{\n\twidth: 40%;\n}\n.table-col-45{\n\twidth: 45%;\n}\n.table-col-50{\n\twidth: 50%;\n} */\n\n.invalid-field {\n\tbackground: red !important;\n\tcolor: white;\n}\n\n.nucleus-profile {\n\tbackground-color: #008FFF;\n\tfont-family: GothamNarrow-Light, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', Geneva, sans-serif;\n\tfont-size: large;\n}\n\n.txt-device-mac,\n.txt-device-mac:focus {\n\twidth: 190px !important;\n\theight: 35px !important;\n\tmargin-top: 9px !important;\n}\n\n.select-device-mac,\n.select-device-mac:focus {\n\tmargin-top: 9px;\n\theight: 35px !important;\n}\n\n\n/* CS Style */\n/* ============== */\n\n.nucleus-labels-bottom {\n\tfont-size: 16px;\n\tmargin-bottom: 5px;\n\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: medium;\n\tposition: absolute;\n\tbottom: 0;\n}\n\n.accountLogo {\n\twidth: 29px;\n}\n\n.accountTextShort {\n\tmin-width: 150px !important;\n\twidth: 165px !important;\n}\n\n.accountText {\n\tmin-width: 140px !important;\n\twidth: 160px !important;\n}\n\n.accountTextBitShort {\n\tmin-width: 25% !important;\n\twidth: 30% !important;\n}\n\n.dim-input-size {\n\tmax-width: 25% !important;\n\twidth: 25% !important;\n}\n\n.accountTextLong {\n\tmin-width: 60% !important;\n\twidth: 65% !important;\n}\n\n.accountTextMedium {\n\tmin-width: 70% !important;\n\twidth: 75% !important;\n}\n\n.accountTextFull {\n\tmin-width: 90% !important;\n\twidth: 95% !important;\n}\n\n.accountTextFull2 {\n\tmin-width: 90% !important;\n\twidth: 100% !important;\n}\n\n.accountTextFull3 {\n\tmin-width: 90% !important;\n\twidth: 104% !important;\n}\n\n.accountSelect {\n\tmargin-top: 5px;\n    min-width: 8% !important;\n    /* width: 8% !important; */\n    height: 30px;\n}\n\n.b-table-colored thead th {\n\tvertical-align: bottom;\n\tvertical-align: bottom;\n\tborder-bottom: 2px solid #2296f3;\n\tcolor: #2296f3;\n}\n\n.nucleus-table-header-colored {\n\tcolor: #2296f3;\n}\n\n.accountSelectApps {\n\tmargin-top: 5px;\n    min-width: 24% !important;\n    width: 24% !important;\n    height: 30px;\n}\n\n.accountSelectDim {\n\tmargin-left: 30px !important;\n\tmin-width: 30% !important;\n\twidth: 50% !important;\n\theight: 30px;\n}\n\n.accountSelect100 {\n\tmargin-top: 5px;\n\tmin-width: 90% !important;\n\twidth: 100% !important;\n\theight: 30px;\n}\n\n.vbottom-align {\n\ttext-align: bottom;\n\t/* vertical-align: bottom !important; */\n\tmin-height: 30px;\n    height: 38px;\n\tdisplay: inline-table;\n    width: 100%;\n}\n\n.vbottom-align-not-height {\n\ttext-align: bottom;\n\tvertical-align: bottom !important;\n\tmin-height: 25px;\n\theight: 30px;\n}\n\n.span-text-bottom {\n\tpadding-top: 10px;\n}\n\n.top-more-separated {\n\tpadding-bottom: 30px !important;\n}\n\n.bit-top-separated {\n\tpadding-top: 5px !important;\n}\n\n.bit-top-separated-2 {\n\tpadding-top: 2px !important;\n}\n\n.top-separated {\n\tpadding-top: 10px !important;\n}\n\n.top-separated-12 {\n\tmargin-top: 12px !important;\n}\n\n.top-separated-15 {\n\tmargin-top: 15px !important;\n}\n\n.top-separated-20 {\n\tpadding-top: 20px !important;\n}\n\n.a-few-left {\n\tmargin-right: 5px !important;\n}\n\n.a-bit-left {\n\tmargin-left: -2px;\n}\n\n.a-bit-lower3 {\n    margin-top: 5px !important;\n}\n\n.only-top-margin-upper{\n    margin: -5px 0px 0px;\n\tpadding: 0px !important;\n}\n\n.a-left {\n\tmargin-left: -4px;\n}\n\n.a-bit-right {\n\tmargin-left: 3px;\n}\n\n.a-few-right {\n\tmargin-left: 5px;\n}\n\n.a-more-right {\n\tmargin-left: 10px !important;\n}\n\n.a-more-right-21 {\n\tmargin-left: 21px !important;\n}\n\n.a-more-right-23 {\n\tmargin-left: 23px !important;\n}\n\n.a-little-right {\n\tpadding-left: 2px !important;\n}\n\n.padding-left-10 {\n\tpadding-left: 10px;\n}\n\n.a-few-right2 {\n\tmargin-left: 20px;\n}\n\n.a-much-right {\n\tmargin-left: 185px !important;\n}\n\n.a-much-left {\n\tmargin-right: 185px !important;\n}\n\n.margin-left {\n\tmargin-left: 10px !important;\n}\n\n.a-margin-left {\n\tmargin-left: 25px !important;\n}\n\n.margin-right {\n\tmargin-right: 10px !important;\n}\n\n.a-margin-right {\n\tmargin-right: 15px !important;\n}\n\n.much-margin-left {\n\tmargin-left: 50px !important;\n}\n\n.nucleus-floating-button {\n\theight: 48px !important;\n\twidth: 48px !important;\n}\n\n.nucleus-floating-icon {\n\tline-height: 48px !important;\n}\n\n.nucleus-floating-btn-icon {\n\tfont-size: 1.1rem !important;\n\tline-height: 30px !important;\n}\n\n.nucleus-floating-copy-btn-icon {\n\tfont-size: 1.1rem !important;\n\tline-height: 30px !important;\n\tmargin-bottom: 5px !important;\n}\n\n.nucleus-check {\n\tmargin-left: 0px !important;\n}\n\n.nucleus-input-form-small-left {\n\ttext-align: left;\n\tcolor: #000;\n\tpadding-bottom: 0px !important;\n\tmargin-bottom: 4px !important;\n\tborder: 3px solid black;\n\theight: 19px;\n\n\tfont-size: 17px !important;\n\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: larger;\n\twidth: 50% !important;\n}\n\n.no-margin-bottom {\n\tmargin-bottom: 0px !important;\n}\n\n.height30 {\n\theight: 30px !important;\n}\n\n.width100 {\n\twidth: 100%;\n}\n\n.width83 {\n\twidth: 73% !important;\n}\n\n/*.selected-flag {\n\tbackground-color: #fff !important;\n}*/\n\n.selected-flag:focus {\n\tbackground-color: #fff !important;\n}\n\n.txt-black-forced {\n\tcolor: #000 !important;\n}\n\n.txt-1-4 {\n\tmin-width: 70% !important;\n\twidth: 75% !important;\n\theight: 21px !important;\n}\n\n.txt-1-4:hover {\n\theight: 21px !important;\n}\n\n.txt-1-4:focus {\n\theight: 21px !important;\n}\n\n\n.f-small {\n\tfont-size: 15px !important;\n\twhite-space: pre;\n}\n\n\n.nucleus-icon-active {\n\tcolor: #000;\n}\n\n.nucleus-icon-inactive {\n\tcolor: #b3b3b3;\n}\n\n.nucleus-icon-active:hover {\n\tcursor: pointer;\n}\n\n.nucleus-icon-inactive:hover {\n\tcursor: pointer;\n}\n\n.MuiInputBase-root {\n\tmargin-top: -5px;\n\twidth: 100%;\n}\n\n.MuiInputBase-root input {\n\tborder-style: none !important;\n\tbox-shadow: none !important;\n\tmargin-bottom: 0px !important;\n}\n\n.MuiInputBase-root input:focus {\n\tborder-style: none !important;\n\tbox-shadow: none !important;\n\tmargin-bottom: 0px !important;\n}\n\n.browser-default .MuiInput-underline:before {\n  border-bottom: none !important;\n}\n\n.MuiPickersClock-squareMask {\n\tcursor: pointer;\n}\n\n.MuiIconButton-root:focus {\n\tbackground-color: transparent !important;\n}\n\n.bottom-line {\n\tborder-bottom-color: #b1b6ba;\n\tborder-bottom-width: 1px;\n\tborder-bottom-style: solid;\n\tpadding-bottom: 5px;\n}\n\n.right-line-separator {\n\tborder-right-color: #b1b6ba;\n\tborder-right-width: 2px;\n\tborder-right-style: solid;\n\tmargin-bottom: 12px;\n}\n\n.specialOverflowX {\n\toverflow-x: scroll;\n}\n\n.specialOverflowX:hover {\n\toverflow-x: scroll;\n}\n\n.thead-s {\n\tmargin-right: 16px;\n}\n\n.tbody-s {\n\tdisplay: block;\n\theight: 560px;\n\toverflow: auto;\n}\n\n/* .thead-s, .tbody-s tr {\n    display:table;\n    table-layout:fixed;\n} */\n\n/* New Table Css */\n.b-table {\n\twidth: 100%;\n\tmargin-bottom: 1rem;\n\tcolor: #212529;\n\tborder-collapse: separate; \n}\n\n.b-table td {\n\tpadding: .75rem;\n\tvertical-align: center;\n\tborder-top: 1px solid #dee2e6\n}\n\n.b-table thead th {\n\tvertical-align: bottom;\n\tborder-bottom: 2px solid #dee2e6\n}\n\n.b-table-colored thead th {\n\tvertical-align: bottom;\n\tborder-bottom: 2px solid #2296f3ff\n}\n\n.b-table tbody+tbody {\n\tborder-top: 2px solid #dee2e6\n}\n\n.b-table .thead-dark th {\n\tcolor: #fff;\n\tbackground-color: #343a40;\n\tborder-color: #454d55\n}\n\n.b-table .thead-light th {\n\tcolor: #495057;\n\tbackground-color: #e9ecef;\n\tborder-color: #dee2e6\n}\n\n/* .b-table {\n\tborder-collapse: collapse !important\n} */\n/* .b-table td,\n.b-table th {\n\tbackground-color: #fff !important\n} */\n\n.b-table .thead-dark th {\n\tcolor: inherit;\n\tborder-color: #dee2e6\n}\n\n.b-table-bordered {\n\tborder: 1px solid #dee2e6\n}\n\n.b-table-bordered td,\n.b-table-bordered th {\n\tborder: 1px solid #dee2e6\n}\n\n.b-table-bordered thead td,\n.b-table-bordered thead th {\n\tborder-bottom-width: 2px\n}\n\n.table-dark.b-table-bordered {\n\tborder: 0\n}\n\n@media (max-width:575.98px) {\n\t.table-responsive-sm {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\toverflow-x: auto;\n\t\t-webkit-overflow-scrolling: touch\n\t}\n\n\t.table-responsive-sm>.b-table-bordered {\n\t\tborder: 0\n\t}\n}\n\n@media (max-width:767.98px) {\n\t.table-responsive-md {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\toverflow-x: auto;\n\t\t-webkit-overflow-scrolling: touch\n\t}\n\n\t.table-responsive-md>.b-table-bordered {\n\t\tborder: 0\n\t}\n}\n\n@media (max-width:991.98px) {\n\t.table-responsive-lg {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\toverflow-x: auto;\n\t\t-webkit-overflow-scrolling: touch\n\t}\n\n\t.table-responsive-lg>.b-table-bordered {\n\t\tborder: 0\n\t}\n}\n\n@media (max-width:1199.98px) {\n\t.table-responsive-xl {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\toverflow-x: auto;\n\t\t-webkit-overflow-scrolling: touch\n\t}\n\n\t.table-responsive-xl>.b-table-bordered {\n\t\tborder: 0\n\t}\n}\n\n.table-responsive {\n\tdisplay: block;\n\twidth: 100%;\n\toverflow-x: auto;\n\t-webkit-overflow-scrolling: touch\n}\n\n.table-responsive>.b-table-bordered {\n\tborder: 0\n}\n\n.b-table-bordered td,\n.b-table-bordered th {\n\tborder: 1px solid #dee2e6 !important\n}\n\n/* table {\n\tborder-collapse: collapse\n} */\n\n.b-table-hover tbody tr:hover {\n\t/* color: #FFFFFF; */\n\tbackground-color: #eeeeee\n}\n\n/* .b-table-active,\n.b-table-active>td,\n.b-table-active>th {\n    background-color: rgba(0, 0, 0, .075)\n}\n\n.b-table-hover .b-table-active:hover {\n\tbackground-color: #03313E\n}\n\n.b-table-hover .b-table-active:hover>td,\n.b-table-hover .b-table-active:hover>th {\n\tbackground-color: #03313E\n} */\n\n.sticky-thead th {\n\tz-index: 999;\n\tbackground: white;\n\tposition: sticky;\n\ttop: 0; /* Don't forget this, required for the stickiness */\n\t/* box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4); */\n}\n.b-table td{\n\t/* display: tab; */\n}\n.col,\n.b-col-1,\n.b-col-10,\n.b-col-11,\n.b-col-12,\n.b-col-2,\n.b-col-3,\n.b-col-4,\n.b-col-5,\n.b-col-6,\n.b-col-7,\n.b-col-8,\n.b-col-9,\n.b-col-auto,\n.b-col-lg,\n.b-col-lg-1,\n.b-col-lg-10,\n.b-col-lg-11,\n.b-col-lg-12,\n.b-col-lg-2,\n.b-col-lg-3,\n.b-col-lg-4,\n.b-col-lg-5,\n.b-col-lg-6,\n.b-col-lg-7,\n.b-col-lg-8,\n.b-col-lg-9,\n.b-col-lg-auto,\n.b-col-md,\n.b-col-md-1,\n.b-col-md-10,\n.b-col-md-11,\n.b-col-md-12,\n.b-col-md-2,\n.b-col-md-3,\n.b-col-md-4,\n.b-col-md-5,\n.b-col-md-6,\n.b-col-md-7,\n.b-col-md-8,\n.b-col-md-9,\n.b-col-md-auto,\n.b-col-sm,\n.b-col-sm-1,\n.b-col-sm-10,\n.b-col-sm-11,\n.b-col-sm-12,\n.b-col-sm-2,\n.b-col-sm-3,\n.b-col-sm-4,\n.b-col-sm-5,\n.b-col-sm-6,\n.b-col-sm-7,\n.b-col-sm-8,\n.b-col-sm-9,\n.b-col-sm-auto,\n.b-col-xl,\n.b-col-xl-1,\n.b-col-xl-10,\n.b-col-xl-11,\n.b-col-xl-12,\n.b-col-xl-2,\n.b-col-xl-3,\n.b-col-xl-4,\n.b-col-xl-5,\n.b-col-xl-6,\n.b-col-xl-7,\n.b-col-xl-8,\n.b-col-xl-9,\n.b-col-xl-auto {\n    position: relative;\n    width: 100%;\n    padding-right: 15px;\n    padding-left: 15px\n}\n\n.b-col {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    max-width: 100%\n}\n\n.b-col-auto {\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%\n}\n\n.b-col-1 {\n    -ms-flex: 0 0 8.333333%;\n    flex: 0 0 8.333333%;\n    max-width: 8.333333%\n}\n\n.b-col-2 {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%\n}\n\n.b-col-3 {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%\n}\n\n.b-col-4 {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%\n}\n\n.b-col-5 {\n    -ms-flex: 0 0 41.666667%;\n    flex: 0 0 41.666667%;\n    max-width: 41.666667%\n}\n\n.b-col-6 {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%\n}\n\n.b-col-7 {\n    -ms-flex: 0 0 58.333333%;\n    flex: 0 0 58.333333%;\n    max-width: 58.333333%\n}\n\n.b-col-8 {\n    -ms-flex: 0 0 66.666667%;\n    flex: 0 0 66.666667%;\n    max-width: 66.666667%\n}\n\n.b-col-9 {\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%\n}\n\n.b-col-10 {\n    -ms-flex: 0 0 83.333333%;\n    flex: 0 0 83.333333%;\n    max-width: 83.333333%\n}\n\n.b-col-11 {\n    -ms-flex: 0 0 91.666667%;\n    flex: 0 0 91.666667%;\n    max-width: 91.666667%\n}\n\n.b-col-12 {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%\n}\n\n.nucleusSearchInputMainContainer {\n\tdisplay: flex;\n\twidth: 100%;\n\tflex-direction: row;\n\tjustify-content: space-between;\n}\n\n.nucleusInputSelect {\n\tdisplay: block; \n\twidth: 200px; \n\theight: 35px;\n\tborder-radius: 10px;\n\tbox-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.nucleus-chips input{\n\ttext-decoration: none !important;\n\tborder-bottom: 0px none white !important;\n\t\n\n\tborder-bottom: 1px solid white !important;\n    box-shadow: none !important;\n    padding-top: 5px !important;\n\n    width: 150px !important;\n\ttext-align: center;\n}\n\n.nucleus-chips .input{\n\n    width: 148px !important;\n}\n\n.nucleus-chips input:hover{\n\ttext-decoration: none !important;\n\tborder-bottom: 0px none white !important;\n\twidth: 140px !important;\n}\n\n\n/* For page Accounts */\n.nucleus-input-form-big-left{\n\ttext-align: left;\n\tcolor: #000;\n\tpadding-bottom: 0px !important;\n\tmargin-bottom: 4px !important;\n\tborder:3px solid black;\n    height: 19px;\n\n    font-size: 15px !important;\n\n\tfont-family: GothamNarrow-Book, 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n\tfont-size: larger;\n}\n\n.nucleus-select-wrapper{\n\theight: 50px;\n\toverflow-y: visible;\n\twidth: 102px;\n    display: inline-flex;\n\tmargin-left: 105px;\n}\n  .nucleus-m-1 {\n\tmargin: 1rem;\n  }\n  \n  .nucleus-m-2 {\n\tmargin: 2rem;\n  }\n  \n  .nucleus-m-3 {\n\tmargin: 3rem;\n  }\n  \n  .nucleus-m-4 {\n\tmargin: 4rem;\n  }\n  \n  .nucleus-m-5 {\n\tmargin: 5rem;\n  }\n  \n  .nucleus-m-6 {\n\tmargin: 6rem;\n  }\n  \n  .nucleus-m-7 {\n\tmargin: 7rem;\n  }\n  \n  .nucleus-m-8 {\n\tmargin: 8rem;\n  }\n  \n  .nucleus-m-9 {\n\tmargin: 9rem;\n  }\n  \n  .nucleus-m-10 {\n\tmargin: 10rem;\n  }\n  \n  .nucleus-m-11 {\n\tmargin: 11rem;\n  }\n  \n  .nucleus-m-12 {\n\tmargin: 12rem;\n  }\n  \n  .nucleus-mt-1 {\n\tmargin-top: 1rem;\n  }\n  \n  .nucleus-mr-1 {\n\tmargin-right: 1rem;\n  }\n  \n  .nucleus-mb-1 {\n\tmargin-bottom: 1rem;\n  }\n  \n  .nucleus-ml-1 {\n\tmargin-left: 1rem;\n  }\n  \n  .nucleus-mt-2 {\n\tmargin-top: 2rem;\n  }\n  \n  .nucleus-mr-2 {\n\tmargin-right: 2rem;\n  }\n  \n  .nucleus-mb-2 {\n\tmargin-bottom: 2rem;\n  }\n  \n  .nucleus-ml-2 {\n\tmargin-left: 2rem;\n  }\n  \n  .nucleus-mt-3 {\n\tmargin-top: 3rem;\n  }\n  \n  .nucleus-mr-3 {\n\tmargin-right: 3rem;\n  }\n  \n  .nucleus-mb-3 {\n\tmargin-bottom: 3rem;\n  }\n  \n  .nucleus-ml-3 {\n\tmargin-left: 3rem;\n  }\n  \n  .nucleus-mt-4 {\n\tmargin-top: 4rem;\n  }\n  \n  .nucleus-mr-4 {\n\tmargin-right: 4rem;\n  }\n  \n  .nucleus-mb-4 {\n\tmargin-bottom: 4rem;\n  }\n  \n  .nucleus-ml-4 {\n\tmargin-left: 4rem;\n  }\n  \n  .nucleus-mt-5 {\n\tmargin-top: 5rem;\n  }\n  \n  .nucleus-mr-5 {\n\tmargin-right: 5rem;\n  }\n  \n  .nucleus-mb-5 {\n\tmargin-bottom: 5rem;\n  }\n  \n  .nucleus-ml-5 {\n\tmargin-left: 5rem;\n  }\n  \n  .nucleus-mt-6 {\n\tmargin-top: 6rem;\n  }\n  \n  .nucleus-mr-6 {\n\tmargin-right: 6rem;\n  }\n  \n  .nucleus-mb-6 {\n\tmargin-bottom: 6rem;\n  }\n  \n  .nucleus-ml-6 {\n\tmargin-left: 6rem;\n  }\n  \n  .nucleus-mt-7 {\n\tmargin-top: 7rem;\n  }\n  \n  .nucleus-mr-7 {\n\tmargin-right: 7rem;\n  }\n  \n  .nucleus-mb-7 {\n\tmargin-bottom: 7rem;\n  }\n  \n  .nucleus-ml-7 {\n\tmargin-left: 7rem;\n  }\n  \n  .nucleus-mt-8 {\n\tmargin-top: 8rem;\n  }\n  \n  .nucleus-mr-8 {\n\tmargin-right: 8rem;\n  }\n  \n  .nucleus-mb-8 {\n\tmargin-bottom: 8rem;\n  }\n  \n  .nucleus-ml-8 {\n\tmargin-left: 8rem;\n  }\n  \n  .nucleus-mt-9 {\n\tmargin-top: 9rem;\n  }\n  \n  .nucleus-mr-9 {\n\tmargin-right: 9rem;\n  }\n  \n  .nucleus-mb-9 {\n\tmargin-bottom: 9rem;\n  }\n  \n  .nucleus-ml-9 {\n\tmargin-left: 9rem;\n  }\n  \n  .nucleus-mt-10 {\n\tmargin-top: 10rem;\n  }\n  \n  .nucleus-mr-10 {\n\tmargin-right: 10rem;\n  }\n  \n  .nucleus-mb-10 {\n\tmargin-bottom: 10rem;\n  }\n  \n  .nucleus-ml-10 {\n\tmargin-left: 10rem;\n  }\n  \n  .nucleus-mt-11 {\n\tmargin-top: 11rem;\n  }\n  \n  .nucleus-mr-11 {\n\tmargin-right: 11rem;\n  }\n  \n  .nucleus-mb-11 {\n\tmargin-bottom: 11rem;\n  }\n  \n  .nucleus-ml-11 {\n\tmargin-left: 11rem;\n  }\n  \n  .nucleus-mt-12 {\n\tmargin-top: 12rem;\n  }\n  \n  .nucleus-mr-12 {\n\tmargin-right: 12rem;\n  }\n  \n  .nucleus-mb-12 {\n\tmargin-bottom: 12rem;\n  }\n  \n  .nucleus-ml-12 {\n\tmargin-left: 12rem;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
